<div class="account-pages my-5 pt-sm-5">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-8 col-lg-6 col-xl-5">
        <div class="card overflow-hidden">
          <div class="bg-soft bg-primary">
            <div class="row">
              <div class="col-7">
                <div class="text-primary p-4">
                  <h5 class="text-primary">Registeration Form</h5>
                  <p>Get your Zohdy account now.</p>
                </div>
              </div>
              <div class="col-5 align-self-end">
                <img src="assets/images/profile-img.png" alt="" class="img-fluid">
              </div>
            </div>
          </div>
          <div class="card-body pt-0">
            <div>
              <a routerLink="/">
                <div class="avatar-md profile-user-wid mb-4">
                  <span class="avatar-title rounded-circle bg-light">
                    <img src="assets/images/logo.svg" alt="" class="rounded-circle" height="34">
                  </span>
                </div>
              </a>
            </div>
            <div class="p-2">
                  <div>
                    

                    <!-- [activeId]="3"  -->

                    <ul ngbNav
                      [(activeId)]="activeTab" 
                      (navChange)="onTabChange($event)" 
                      #customNav="ngbNav" 
                      class="nav-tabs nav-tabs-custom nav-justified">
                      
                        <li [ngbNavItem]="1">
                          <a ngbNavLink (click)="changeActiveTab(1)">
                            <span class="d-block d-sm-none"><i class="fas fa-user"></i></span>
                            <span class="d-none d-sm-block">Customers</span>
                          </a>
                          <ng-template ngbNavContent>
                            <ng-template [ngTemplateOutlet]="TabContent"></ng-template>
                          </ng-template>
                        </li>
                        <li [ngbNavItem]="2">
                          <a ngbNavLink (click)="changeActiveTab(2)">
                            <span class="d-block d-sm-none"><i class="fas fa-user-tie"></i></span>
                            <span class="d-none d-sm-block">Freelancer</span>
                          </a>
                          <ng-template ngbNavContent>
                            <ng-template [ngTemplateOutlet]="TabContent1"></ng-template>
                          </ng-template>
                        </li>
                        <li [ngbNavItem]="3">
                          <a ngbNavLink (click)="changeActiveTab(3)">
                            <span class="d-block d-sm-none"><i class="fas fa-users"></i></span>
                            <span class="d-none d-sm-block">Company</span>
                          </a>
                          <ng-template ngbNavContent>
                            <ng-template [ngTemplateOutlet]="TabContent2"></ng-template>
                          </ng-template>
                        </li>
                    </ul>
                    <div [ngbNavOutlet]="customNav"></div>
                    
                  </div>
                

            </div>
          </div>
        </div>
        <!-- end card -->

        <div class="mt-5 text-center">
          <p>Already have an account ? <a routerLink="/account/login" class="fw-medium text-primary"> Login</a>
          </p>
          <p>Copyright © {{year}} SKYTECH CYBER CLOUD All Right Reserved.</p>
        </div>
      </div> <!-- end col -->
    </div>
    <!-- end row -->
  </div>
  <!-- end container -->
</div>





<!-- Tab Content -->
<ng-template #TabContent>
  <div class="col-lg-12">
    <div class="card">
      <div class="card-body">
        <h4 class="card-title mb-4">Customer</h4>
        <aw-wizard #wizard [navBarLayout]="'large-empty-symbols'">
          <form class="needs-validation" (ngSubmit)="validSubmit()" [formGroup]="validationform">
            <aw-wizard-step>
              <ng-template awWizardStepSymbol>
                <i class="fas fa-user"></i>
              </ng-template>
              <div class="row"> 
                  <div class="row mb-3">
                    <label for="validationCustom01" class="col-md-3 col-form-label">Name</label>
                    <div class="col-md-9">
                      <input type="text" class="form-control" id="validationCustom01" formControlName="name"
                      placeholder="Enter Name" [ngClass]="{'is-invalid': validation && form.name.errors}">
                      <div *ngIf="form.name.errors" class="invalid-feedback">
                        <span *ngIf="form.name.hasError('required')">User Name is required.</span>
                        <span *ngIf="form.name.hasError('pattern')">Only Allowed Alphabet and Number.</span>
                      </div> 
                    </div>
                  </div>
                  <div class="row mb-3">
                    <label for="validationCustom02" class="col-md-3 col-form-label">Email</label>
                    <div class="col-md-9">
                      <input type="text" class="form-control" id="validationCustom02" formControlName="email"
                      placeholder="Enter Email" [ngClass]="{'is-invalid': validation && form.email.errors}">
                      <div *ngIf="form.email.errors" class="invalid-feedback">
                        <span *ngIf="form.email.hasError('required')">User Email is required.</span>
                        <span *ngIf="form.email.hasError('pattern')">Email Pattern is not match.</span>
                      </div> 
                    </div>
                  </div>
                  <div class="row mb-3">
                    <label for="validationCustom03" class="col-md-3 col-form-label">Password</label>
                    <div class="col-md-9">
                      <input type="password" class="form-control" id="validationCustom03" formControlName="password"
                      placeholder="Enter Password" [ngClass]="{'is-invalid': validation && form.password.errors}">
                      <div *ngIf="form.password.errors" class="invalid-feedback">
                        <span *ngIf="form.password.hasError('required')">User password is required.</span>
                        <span *ngIf="form.password.hasError('minlength')">Atleaset 8 characters required.</span>
                      </div> 
                    </div>
                  </div>
                  <div class="mb-3 row">
                    <label for="validationCustom04" class="col-md-3 col-form-label">Gender</label>
                    <div class="col-md-9">
                        <select class="form-select" id="validationCustom04" formControlName="gender"
                                [ngClass]="{'is-invalid': validation && form.gender.errors}">
                            <option value="M">Male</option>
                            <option value="F">Female</option>
                            <!-- <option value="O">Other</option> -->
                        </select>
                        <div *ngIf="form.gender.errors" class="invalid-feedback">
                          <span *ngIf="form.gender.hasError('required')">Gender is required.</span>
                        </div> 
                    </div>
                  </div>
                  <div class="mb-3 row">
                    <label for="validationCustom05" class="col-md-3 col-form-label">Phone Number</label>
                    <div class="col-md-9 d-flex align-items-center">

                      <div class="input-group">
                        <div class="input-group-text">+971</div>
                        <input type="text" class="form-control" id="validationCustom05" formControlName="phone_number"
                        placeholder="Enter Phone Number" [ngClass]="{'is-invalid': validation && form.phone_number.errors}">
                      </div>

                     
                      
                      <div *ngIf="form.phone_number.errors" class="invalid-feedback">
                        <span *ngIf="form.phone_number.hasError('required')">Phone Number is required.</span>
                        <span *ngIf="form.phone_number.hasError('pattern')">Phone number has 9 digit.</span>
                      </div> 
                    </div>
                  </div>
              </div>
              <ul class="list-inline wizard mb-0">
                <li class="next list-inline-item float-end"><button class="btn btn-primary" (click)="goToPreviousStep()" awNextStep>Next</button>
                </li>
              </ul>
            </aw-wizard-step>

            <aw-wizard-step>
              <ng-template awWizardStepSymbol>
                <i class="far fa-address-card"></i>
              </ng-template>
              <div class="row">
                  <div class="row mb-3">
                    <label for="validationCustom06" class="col-md-3 col-form-label">Address Name</label>
                    <div class="col-md-9">
                      <input type="text" class="form-control" id="validationCustom06" formControlName="address_name"
                      placeholder="Enter Address Name" [ngClass]="{'is-invalid': validation && form.address_name.errors}">
                      <div *ngIf="form.address_name.errors" class="invalid-feedback">
                        <span *ngIf="form.address_name.hasError('required')">Address Name is required.</span>
                      </div> 
                    </div>
                  </div>
                  <div class="mb-3 row">
                    <label for="validationCustom08" class="col-md-3 col-form-label">Country</label>
                    <div class="col-md-9">
                        <select class="form-select" id="validationCustom08" formControlName="country"
                                [ngClass]="{'is-invalid': validation && form.country.errors}">
                          <option value="UAE">United Arab Emirates</option>
                        </select>
                        <div *ngIf="form.country.errors" class="invalid-feedback">
                          <span *ngIf="form.country.hasError('required')">Country is required.</span>
                        </div> 
                    </div>                  
                  </div>
                  <div class="mb-3 row">
                    <label for="validationCustom09" class="col-md-3 col-form-label">City</label>
                    <div class="col-md-9">
                        <select class="form-select" id="validationCustom09" formControlName="city"
                                [ngClass]="{'is-invalid': validation && form.city.errors}">
                            <option value="AUH">Abu Dhabi</option>
                            <option value="AA">Al Ain</option>
                            <option value="DXB">Dubai</option>
                            <option value="SHJ">Sharjah</option>
                            <option value="AJM">Ajman</option>
                            <option value="UAQ">Umm Al Quwain</option>
                            <option value="RAK">Ras Al Khaimah</option>
                            <option value="FUJ">Fujairah</option>
                        </select>
                        <div *ngIf="form.city.errors" class="invalid-feedback">
                          <span *ngIf="form.city.hasError('required')">City is required.</span>
                        </div> 
                    </div>  
                  </div>
                  <div class="row mb-3">
                    <label for="validationCustom21" class="col-md-3 col-form-label">Area</label>
                    <div class="col-md-9">
                      <!-- <input type="text" class="form-control" id="validationCustom21" formControlName="area"
                      placeholder="Enter Area" [ngClass]="{'is-invalid': validation && form.area.errors}"> -->
                      <select class="form-select" id="validationCustom21" formControlName="area"
                      [ngClass]="{'is-invalid': validation && form.area.errors}">
                      <ng-container *ngIf="validationform.get('city').value === 'AUH'">
                          <option value="Abu Al Abyad">Abu Al Abyad</option>
                          <option value="Abu Dhabi">Abu Dhabi</option>
                          <option value="Abu Dhabi Airport">Abu Dhabi Airport</option>
                          <option value="Abu Dhabi Gate City">Abu Dhabi Gate City</option>
                          <option value="Al `Ayn">Al `Ayn</option>
                          <option value="Al `Idd">Al `Idd</option>
                          <option value="Al `Udayd">Al `Udayd</option>
                          <option value="Al Ain">Al Ain</option>
                          <option value="Al Aman">Al Aman</option>
                          <option value="Al Atir">Al Atir</option>
                          <option value="Al Badaa">Al Badaa</option>
                          <option value="Al Bahia">Al Bahia</option>
                          <option value="Al Baladiyah">Al Baladiyah</option>
                          <option value="Al Baraha">Al Baraha</option>
                          <option value="Al Bateen">Al Bateen</option>
                          <option value="Al Dhafrah">Al Dhafrah</option>
                          <option value="Al Falah City">Al Falah City</option>
                          <option value="Al Ghadeer">Al Ghadeer</option>
                          <option value="Al Hadhi">Al Hadhi</option>
                          <option value="Al Hayer">Al Hayer</option>
                          <option value="Al Hisn">Al Hisn</option>
                          <option value="Al Hosn">Al Hosn</option>
                          <option value="Al Hudayriat Island">Al Hudayriat Island</option>
                          <option value="Al Ittihad">Al Ittihad</option>
                          <option value="Al Jahr">Al Jahr</option>
                          <option value="Al Jami` al Kabir">Al Jami` al Kabir</option>
                          <option value="Al Karamah ">Al Karamah</option>
                          <option value="Al Khabb">Al Khabb</option>
                          <option value="Al Khaleej Al Arabi">Al Khaleej Al Arabi</option>
                          <option value="Al Khalidiya">Al Khalidiya</option>
                          <option value="Al Khalidiyah">Al Khalidiyah</option>
                          <option value="Al Khatim">Al Khatim</option>
                          <option value="Al Khazna">Al Khazna</option>
                          <option value="Al Khaznah">Al Khaznah</option>
                          <option value="Al Khis">Al Khis</option>
                          <option value="Al Khubayrah">Al Khubayrah</option>
                          <option value="Al Khubeirah">Al Khubeirah</option>
                          <option value="Al Mafraq">Al Mafraq</option>
                          <option value="Al Manaseer">Al Manaseer</option>
                          <option value="Al Manhal">Al Manhal</option>
                          <option value="Al Maqta">Al Maqta</option>
                          <option value="Al Marfa">Al Marfa</option>
                          <option value="Al Mariah United Group">Al Mariah United Group</option>
                          <option value="Al Mariyah">Al Mariyah</option>
                          <option value="Al Mariyah al Gharbiyah">Al Mariyah al Gharbiyah</option>
                          <option value="Al Markaziyah">Al Markaziyah</option>
                          <option value="Al Mashrub">Al Mashrub</option>
                          <option value="Al Mina">Al Mina</option>
                          <option value="Al Mirfa">Al Mirfa</option>
                          <option value="Al Mu`tarad">Al Mu`tarad</option>
                          <option value="Al Mughayra">Al Mughayra</option>
                          <option value="Al Muqattarah">Al Muqattarah</option>
                          <option value="Al Muroor">Al Muroor</option>
                          <option value="Al Murur">Al Murur</option>
                          <option value="Al Musalla">Al Musalla</option>
                          <option value="Al Mushrif">Al Mushrif</option>
                          <option value="Al Muwayqi`i">Al Muwayqi`i</option>
                          <option value="Al Muzun">Al Muzun</option>
                          <option value="Al Nahda Abu Dhabi">Al Nahda Abu Dhabi</option>
                          <option value="Al Nahyan">Al Nahyan</option>
                          <option value="Al Najda">Al Najda</option>
                          <option value="Al Qaia">Al Qaia</option>
                          <option value="Al Qimi">Al Qimi</option>
                          <option value="Al Qurm">Al Qurm</option>
                          <option value="Al Raha Beach">Al Raha Beach</option>
                          <option value="Al Raha Corniche">Al Raha Corniche</option>
                          <option value="Al Raha Gardens">Al Raha Gardens</option>
                          <option value="Al Raha Golf Gardens">Al Raha Golf Gardens</option>
                          <option value="Al Rahba">Al Rahba</option>
                          <option value="Al Ras Al Akhdar">Al Ras Al Akhdar</option>
                          <option value="Al Rawdah">Al Rawdah</option>
                          <option value="Al Reef">Al Reef</option>
                          <option value="Al Reem Island">Al Reem Island</option>
                          <option value="Al Rowdah">Al Rowdah</option>
                          <option value="Al Ruwais">Al Ruwais</option>
                          <option value="Al Samha">Al Samha</option>
                          <option value="Al Shahama">Al Shahama</option>
                          <option value="Al Shamkha">Al Shamkha</option>
                          <option value="Al Sowwah">Al Sowwah</option>
                          <option value="Al Wahda">Al Wahda</option>
                          <option value="Al Wahdah">Al Wahdah</option>
                          <option value="Al Wathba">Al Wathba</option>
                          <option value="Al Wathbah">Al Wathbah</option>
                          <option value="Al Zaab">Al Zaab</option>
                          <option value="An Nadi as Siyahi">An Nadi as Siyahi</option>
                          <option value="An Nashshash">An Nashshash</option>
                          <option value="Aqbiyah">Aqbiyah</option>
                          <option value="Ar Ra's al Akhdar">Ar Ra's al Akhdar</option>
                          <option value="Ar Rawdah">Ar Rawdah</option>
                          <option value="Ar Rihan">Ar Rihan</option>
                          <option value="Ar Ruways">Ar Ruways</option>
                          <option value="Aradah">Aradah</option>
                          <option value="As Sad">As Sad</option>
                          <option value="As Slabeikh">As Slabeikh</option>
                          <option value="As Sulaymat">As Sulaymat</option>
                          <option value="Ash Shahamah">Ash Shahamah</option>
                          <option value="Ash Shibhanah">Ash Shibhanah</option>
                          <option value="Attab">Attab</option>
                          <option value="Ayn al Faydah">Ayn al Faydah</option>
                          <option value="Az Za`ab">Az Za`ab</option>
                          <option value="Az Zafrah">Az Zafrah</option>
                          <option value="Az Zahra">Az Zahra</option>
                          <option value="Badiyah">Badiyah</option>
                          <option value="Baniyas">Baniyas</option>
                          <option value="Batin">Batin</option>
                          <option value="Bid' Zayed">Bid' Zayed</option>
                          <option value="Bid' Zayed, Manar Mall">Bid' Zayed, Manar Mall</option>
                          <option value="Bin Ahmad">Bin Ahmad</option>
                          <option value="Bu Hasa">Bu Hasa</option>
                          <option value="Bu Lifiyat">Bu Lifiyat</option>
                          <option value="Bu Rays">Bu Rays</option>
                          <option value="Capital District">Capital District</option>
                          <option value="Corniche">Corniche</option>
                          <option value="Da`sah">Da`sah</option>
                          <option value="Dahin">Dahin</option>
                          <option value="Danet">Danet</option>
                          <option value="Downtown">Downtown</option>
                          <option value="Fariq Tarif">Fariq Tarif</option>
                          <option value="Ghantoot">Ghantoot</option>
                          <option value="Ghurbah">Ghurbah</option>
                          <option value="Golf Gardens">Golf Gardens</option>
                          <option value="Grand Mosque District">Grand Mosque District</option>
                          <option value="Habshan">Habshan</option>
                          <option value="Hadbat az Za`faranah">Hadbat az Za`faranah</option>
                          <option value="Hafif">Hafif</option>
                          <option value="Hamarur">Hamarur</option>
                          <option value="Hameem">Hameem</option>
                          <option value="Hamim">Hamim</option>
                          <option value="Hilli">Hilli</option>
                          <option value="Humar">Humar</option>
                          <option value="Huwaylah">Huwaylah</option>
                          <option value="Huwaytayn">Huwaytayn</option>
                          <option value="Hydra Village">Hydra Village</option>
                          <option value="Istayhah">Istayhah</option>
                          <option value="Jarbub">Jarbub</option>
                          <option value="Jayf">Jayf</option>
                          <option value="Jebel Dhanna">Jebel Dhanna</option>
                          <option value="Jurayrah">Jurayrah</option>
                          <option value="Kayyah">Kayyah</option>
                          <option value="Khalifa City B">Khalifa City B</option>
                          <option value="Khalifa Street">Khalifa Street</option>
                          <option value="Khannur">Khannur</option>
                          <option value="Liwa">Liwa</option>
                          <option value="Lulu Island">Lulu Island</option>
                          <option value="Madinat ad Dubbat">Madinat ad Dubbat</option>
                          <option value="Madinat an Nahdah">Madinat an Nahdah</option>
                          <option value="Madinat Khalifah A">Madinat Khalifah A</option>
                          <option value="Madinat Khalifah B">Madinat Khalifah B</option>
                          <option value="Madinat Zayed">Madinat Zayed</option>
                          <option value="Madinat Zayid">Madinat Zayid</option>
                          <option value="Madinat Zayid, Rak Sports Cultural Club">Madinat Zayid, Rak Sports Cultural Club</option>
                          <option value="Madinat Zayid, Vegetable and Fruits Market">Madinat Zayid, Vegetable and Fruits Market</option>
                          <option value="Mahdar Bin `Usayyan">Mahdar Bin `Usayyan</option>
                          <option value="Majra al Ghaf">Majra al Ghaf</option>
                          <option value="Marawwah">Marawwah</option>
                          <option value="Marina Village">Marina Village</option>
                          <option value="Mas`udi">Mas`udi</option>
                          <option value="Masdar City ">Masdar City </option>
                          <option value="Mawsil">Mawsil</option>
                          <option value="Mazyad">Mazyad</option>
                          <option value="Milqatah">Milqatah</option>
                          <option value="Mintaqah Bayn al Jisrayn">Mintaqah Bayn al Jisrayn</option>
                          <option value="Mintaqat al Matar">Mintaqat al Matar</option>
                          <option value="Mohamed Bin Zayed City">Mohamed Bin Zayed City</option>
                          <option value="Mujib">Mujib</option>
                          <option value="Mundafinah">Mundafinah</option>
                          <option value="Muroor Area">Muroor Area</option>
                          <option value="Mussafah">Mussafah</option>
                          <option value="Muzayri">Muzayri</option>
                          <option value="Nafir">Nafir</option>
                          <option value="Nahel">Nahel</option>
                          <option value="Naqrah">Naqrah</option>
                          <option value="NPCC, Mussafa, Abu DHabi">NPCC, Mussafa, Abu DHabi</option>
                          <option value="Nuqayrah">Nuqayrah</option>
                          <option value="Nurai Island">Nurai Island</option>
                          <option value="Police Officers City">Police Officers City</option>
                          <option value="Qaryat at Turath">Qaryat at Turath</option>
                          <option value="Qasr al Bahr">Qasr al Bahr</option>
                          <option value="Qasr ash Shati">Qasr ash Shati</option>
                          <option value="Qasr El Bahr">Qasr El Bahr</option>
                          <option value="Qasr El Shatie">Qasr El Shatie</option>
                          <option value="Qatar">Qatar</option>
                          <option value="Qattarah">Qattarah</option>
                          <option value="Qu`aysah">Qu`aysah</option>
                          <option value="Qurmidah">Qurmidah</option>
                          <option value="Qutuf">Qutuf</option>
                          <option value="Radaim">Radaim</option>
                          <option value="Ras Khumais">Ras Khumais</option>
                          <option value="Rowdat Al Reef Palace">Rowdat Al Reef Palace</option>
                          <option value="Saadiyat Island">Saadiyat Island</option>
                          <option value="Sabkhah">Sabkhah</option>
                          <option value="Sas Al Nakheel">Sas Al Nakheel</option>
                          <option value="Sas an Nakhl">Sas an Nakhl</option>
                          <option value="Shah">Shah</option>
                          <option value="Shamis">Shamis</option>
                          <option value="Shati' ar Rahah">Shati' ar Rahah</option>
                          <option value="Sikkat al Khayl">Sikkat al Khayl</option>
                          <option value="Suwayhan">Suwayhan</option>
                          <option value="Sweihan">Sweihan</option>
                          <option value="Taraq">Taraq</option>
                          <option value="Tarif">Tarif</option>
                          <option value="Tharwaniyah">Tharwaniyah</option>
                          <option value="Tourist Club Area">Tourist Club Area</option>
                          <option value="Umm al Qurayn">Umm al Qurayn</option>
                          <option value="Wadhil">Wadhil</option>
                          <option value="Wafd">Wafd</option>
                          <option value="Yafur">Yafur</option>
                          <option value="Yas Island">Yas Island</option>
                          <option value="Yas Marina F1 Circuit">Yas Marina F1 Circuit</option>
                          <option value="Zafir">Zafir</option>
                          <option value="Zayed Military City">Zayed Military City</option>
                          <option value="Zuwayhir">Zuwayhir</option>

                          <option value="Abu Dhabi Cricket Stadium">Abu Dhabi Cricket Stadium</option>
                          <option value="Abu Dhabi Golf Club">Abu Dhabi Golf Club</option>
                          <option value="Khalifa A">Khalifa A</option>

                          <option value="Mazyad Mall">Mazyad Mall</option>
                          <option value="Mohammed Bin Zayed City">Mohammed Bin Zayed City</option>

                      </ng-container>
                      <ng-container *ngIf="validationform.get('city').value === 'AJM'">
                          <option value="Ain Ajman">Ain Ajman</option>
                          <option value="Ajman">Ajman</option>
                          <option value="Ajman, Al Bustan">Ajman, Al Bustan</option>
                          <option value="Ajman, Al Butain">Ajman, Al Butain</option>
                          <option value="Ajman, Al Nakhil">Ajman, Al Nakhil</option>
                          <option value="Ajman, Al Owan">Ajman, Al Owan</option>
                          <option value="Ajman, Al Rashidiya">Ajman, Al Rashidiya</option>
                          <option value="Ajman, Al Rifaah">Ajman, Al Rifaah</option>
                          <option value="Ajman, Al Rumailah">Ajman, Al Rumailah</option>
                          <option value="Ajman, Corniche Area">Ajman, Corniche Area</option>
                          <option value="Ajman, Old Industrial Area">Ajman, Old Industrial Area</option>
                          <option value="Ajman, Port Area">Ajman, Port Area</option>
                          <option value="Al Ameera Village">Al Ameera Village</option>
                          <option value="Al Bustan">Al Bustan</option>
                          <option value="Al Butain">Al Butain</option>
                          <option value="Al Hamidiyah">Al Hamidiyah</option>
                          <option value="Al Helio">Al Helio</option>
                          <option value="Al Humaid City">Al Humaid City</option>
                          <option value="Al Ittihad Village">Al Ittihad Village</option>
                          <option value="Al Naimiya">Al Naimiya</option>
                          <option value="Al Nakhil">Al Nakhil</option>
                          <option value="Al Owan">Al Owan</option>
                          <option value="Al Rumailah">Al Rumailah</option>
                          <option value="Al Tala Camel Race Track of Ajman">Al Tala Camel Race Track of Ajman</option>
                          <option value="Al Zahraa">Al Zahraa</option>
                          <option value="Awali City">Awali City</option>
                          <option value="Bustan">Bustan</option>
                          <option value="Corniche">Corniche</option>
                          <option value="Downtown">Downtown</option>
                          <option value="Emirates City">Emirates City</option>
                          <option value="Green City">Green City</option>
                          <option value="Hamideeyah">Hamideeyah</option>
                          <option value="Hasat al Bidiyah">Hasat al Bidiyah</option>
                          <option value="Helio">Helio</option>
                          <option value="Industrial Area">Industrial Area</option>
                          <option value="Jurf">Jurf</option>
                          <option value="Manama">Manama</option>
                          <option value="Marina">Marina</option>
                          <option value="Marmooka City">Marmooka City</option>
                          <option value="Meadows">Meadows</option>
                          <option value="Muehat">Muehat</option>
                          <option value="Musheirif">Musheirif</option>
                          <option value="Musheirif Commercial">Musheirif Commercial</option>
                          <option value="Muwayhat">Muwayhat</option>
                          <option value="Nakheel">Nakheel</option>
                          <option value="Naymiyah">Naymiyah</option>
                          <option value="New industrial area">New industrial area</option>
                          <option value="Park View City">Park View City</option>
                          <option value="Private Airfield">Private Airfield</option>
                          <option value="Rashidiya">Rashidiya</option>
                          <option value="Rumaylah">Rumaylah</option>
                          <option value="Sawan">Sawan</option>
                          <option value="Tala">Tala</option>
                          <option value="Uptown">Uptown</option>
                          <option value="Zahra">Zahra</option>
                          <option value="Zawra">Zawra</option>

                          <option value="Manama">Manama</option>
                          <option value="Manama, Al Aswaq Hayper Market">Manama, Al Aswaq Hayper Market</option>
                          <option value="Goal">Goal</option>
                          <option value="Masfut">Masfut</option>
                          <option value="Mazeira">Mazeira</option>

                      </ng-container>
                      <ng-container *ngIf="validationform.get('city').value === 'SHJ'">
                          <option value="Dayd">Dayd</option>
                          <option value="Dayd, Al Bustan">Dayd, Al Bustan</option>
                          <option value="Dayd, Al Hasan">Dayd, Al Hasan</option>
                          <option value="Dayd, Al Sharaya">Dayd, Al Sharaya</option>
                          <option value="Dayd, Al Suwaiah">Dayd, Al Suwaiah</option>
                          <option value="Dayd, Al Tayebah">Dayd, Al Tayebah</option>
                          <option value="Dayd, Lubsah Camel Race Track">Dayd, Lubsah Camel Race Track</option>
                          
                          <option value="Kalba">Kalba</option>
                          <option value="Kalba, Al Aoud">Kalba, Al Aoud</option>
                          <option value="Kalba, Al Baraha">Kalba, Al Baraha</option>
                          <option value="Kalba, Al Bateen">Kalba, Al Bateen</option>
                          <option value="Kalba, Al Bridi">Kalba, Al Bridi</option>
                          <option value="Kalba, Al Mafraq">Kalba, Al Mafraq</option>
                          <option value="Kalba, Al Nighala">Kalba, Al Nighala</option>
                          <option value="Kalba, Al Qadsia">Kalba, Al Qadsia</option>
                          <option value="Kalba, Al Qual'aa">Kalba, Al Qual'aa</option>
                          <option value="Kalba, Al Sidrah">Kalba, Al Sidrah</option>
                          <option value="Kalba, Industrial Area">Kalba, Industrial Area</option>
                          <option value="Khawr Kalba">Khawr Kalba</option>
                          <option value="Wadi Hilo">Wadi Hilo</option>

                          <option value="Al Lou'aluo'ayyah">Al Lou'aluo'ayyah</option>
                          <option value="Al Lou'aluo'ayyah, Stadium Sports Club Pterygium">Al Lou'aluo'ayyah, Stadium Sports Club Pterygium</option>
                          <option value="Khawr Fakkan">Khawr Fakkan</option>
                          <option value="Khawr Fakkan, Al Bridi">Khawr Fakkan, Al Bridi</option>
                          <option value="Khawr Fakkan, Al Khaledya">Khawr Fakkan, Al Khaledya</option>
                          <option value="Khawr Fakkan, Al Rifa'a">Khawr Fakkan, Al Rifa'a</option>
                          <option value="Khawr Fakkan, Al Sharq">Khawr Fakkan, Al Sharq</option>
                          <option value="Khawr Fakkan, Al Suwan Camel Track">Khawr Fakkan, Al Suwan Camel Track</option>
                          <option value="Khawr Fakkan, Al Yarmook">Khawr Fakkan, Al Yarmook</option>
                          <option value="Khawr Fakkan, Fort Hatta">Khawr Fakkan, Fort Hatta</option>
                          <option value="Khawr Fakkan, Hawaya">Khawr Fakkan, Hawaya</option>
                          <option value="Khawr Fakkan, Hutain">Khawr Fakkan, Hutain</option>
                          <option value="Khawr Fakkan, Vegetable and Fruits Market">Khawr Fakkan, Vegetable and Fruits Market</option>
                          <option value="Zubarah">Zubarah</option>


                          <option value="Abu Sangara">Abu Sangara</option>
                          <option value="Adh Dhayd">Adh Dhayd</option>
                          <option value="Al Aber">Al Aber</option>
                          <option value="Al Ardiyah">Al Ardiyah</option>
                          <option value="Al Azrra">Al Azrra</option>
                          <option value="Al Brashi">Al Brashi</option>
                          <option value="Al Butina">Al Butina</option>
                          <option value="Al Darrare">Al Darrare</option>
                          <option value="Al Dhaid">Al Dhaid</option>
                          <option value="Al Fallaj">Al Fallaj</option>
                          <option value="Al Fayha">Al Fayha</option>
                          <option value="AL Ghafiya">AL Ghafiya</option>
                          <option value="Al Ghuhaiba">Al Ghuhaiba</option>
                          <option value="Al Ghuwair">Al Ghuwair</option>
                          <option value="Al Goaz">Al Goaz</option>
                          <option value="Al Hamriyah">Al Hamriyah</option>
                          <option value="Al Hawayah">Al Hawayah</option>
                          <option value="Al Hayrah">Al Hayrah</option>
                          <option value="Al Hazana">Al Hazana</option>
                          <option value="Al Heera Suburb">Al Heera Suburb</option>
                          <option value="Al Hutain">Al Hutain</option>
                          <option value="Al Jazzat">Al Jazzat</option>
                          <option value="Al Khabba">Al Khabba</option>
                          <option value="Al Khaildia Suburb">Al Khaildia Suburb</option>
                          <option value="Al Khaldeia">Al Khaldeia</option>
                          <option value="Al Khan">Al Khan</option>
                          <option value="Al Khouzamiya">Al Khouzamiya</option>
                          <option value="Al Madam">Al Madam</option>
                          <option value="Al Mahatah">Al Mahatah</option>
                          <option value="Al Majaz">Al Majaz</option>
                          <option value="Al Malaiha">Al Malaiha</option>
                          <option value="Al Mamzar">Al Mamzar</option>
                          <option value="Al Mamzer">Al Mamzer</option>
                          <option value="Al Manakh">Al Manakh</option>
                          <option value="Al Marijah">Al Marijah</option>
                          <option value="Al Mirgab">Al Mirgab</option>
                          <option value="Al Mudaifi">Al Mudaifi</option>
                          <option value="Al Mussalla">Al Mussalla</option>
                          <option value="Al Nabba">Al Nabba</option>
                          <option value="Al Nahda 1">Al Nahda 1</option>
                          <option value="Al Nahda 2">Al Nahda 2</option>
                          <option value="Al Naimiya">Al Naimiya</option>
                          <option value="Al Nasserya">Al Nasserya</option>
                          <option value="Al nekhailat">Al nekhailat</option>
                          <option value="Al Nud">Al Nud</option>
                          <option value="Al Nujoom Islands">Al Nujoom Islands</option>
                          <option value="Al Qadsia">Al Qadsia</option>
                          <option value="Al Qasba">Al Qasba</option>
                          <option value="Al Qasemiya">Al Qasemiya</option>
                          <option value="Al Qusais Industrial Area 1">Al Qusais Industrial Area 1</option>
                          <option value="Al Qusais Industrial Area 3">Al Qusais Industrial Area 3</option>
                          <option value="Al Rafee'a 1">Al Rafee'a 1</option>
                          <option value="Al Ramaqia">Al Ramaqia</option>
                          <option value="Al Ramla">Al Ramla</option>
                          <option value="Al Ramla East">Al Ramla East</option>
                          <option value="AL Ramla West">AL Ramla West</option>
                          <option value="Al Ramtha">Al Ramtha</option>
                          <option value="Al Rifa">Al Rifa</option>
                          <option value="Al Rifah">Al Rifah</option>
                          <option value="Al Riqa Suburb">Al Riqa Suburb</option>
                          <option value="Al Sajaa">Al Sajaa</option>
                          <option value="Al Shahab">Al Shahab</option>
                          <option value="Al Sharq">Al Sharq</option>
                          <option value="Al Shuwaiheen">Al Shuwaiheen</option>
                          <option value="Al Subaikhi">Al Subaikhi</option>
                          <option value="Al Swehat">Al Swehat</option>
                          <option value="Al Talae">Al Talae</option>
                          <option value="Al Wahda">Al Wahda</option>
                          <option value="Al Yarmook">Al Yarmook</option>
                          <option value="an-Nahwa">an-Nahwa</option>
                          <option value="Ar Rufaysah">Ar Rufaysah</option>
                          <option value="Ash Shu`ayb">Ash Shu`ayb</option>
                          <option value="Atain">Atain</option>
                          <option value="Bu Danig">Bu Danig</option>
                          <option value="Bu Tina">Bu Tina</option>
                          <option value="Corniche Al Buhaira">Corniche Al Buhaira</option>
                          <option value="Eliash">Eliash</option>
                          <option value="Etisalat">Etisalat</option>
                          <option value="Ghunah">Ghunah</option>
                          <option value="Hajar">Hajar</option>
                          <option value="Hamriya">Hamriya</option>
                          <option value="Hamriyah Free Zone">Hamriyah Free Zone</option>
                          <option value="HANGAR AEROPRAKT A22 No220">HANGAR AEROPRAKT A22 No220</option>
                          <option value="Hiyawah">Hiyawah</option>
                          <option value="Hizayib az Zanah">Hizayib az Zanah</option>
                          <option value="Huwayyah">Huwayyah</option>
                          <option value="Industrial Area 13">Industrial Area 13</option>
                          <option value="Industrial Area 18">Industrial Area 18</option>
                          <option value="Khor Fakkan">Khor Fakkan</option>
                          <option value="Layyah">Layyah</option>
                          <option value="Lulayyah">Lulayyah</option>
                          <option value="Madha">Madha</option>
                          <option value="Maysaloon">Maysaloon</option>
                          <option value="Muelih">Muelih</option>
                          <option value="Muwafjah">Muwafjah</option>
                          <option value="Nahwa">Nahwa</option>
                          <option value="Nazwa">Nazwa</option>
                          <option value="Nedaifi">Nedaifi</option>
                          <option value="New Shwaib">New Shwaib</option>
                          <option value="Private airfield">Private airfield</option>
                          <option value="Rafa">Rafa</option>
                          <option value="Rolla Area">Rolla Area</option>
                          <option value="Rollah Square">Rollah Square</option>
                          <option value="Sa`d">Sa`d</option>
                          <option value="Sahanah">Sahanah</option>
                          <option value="Sajaa Industrial Area">Sajaa Industrial Area</option>
                          <option value="Samnan">Samnan</option>
                          <option value="Saruj">Saruj</option>
                          <option value="Shargan">Shargan</option>
                          <option value="Sharjah">Sharjah</option>
                          <option value="Sharjah Airport Free Zone (SAIF)">Sharjah Airport Free Zone (SAIF)</option>
                          <option value="Sharjah Industrial Area 1">Sharjah Industrial Area 1</option>
                          <option value="Sharjah Industrial Area 10">Sharjah Industrial Area 10Sharjah Industrial Area 10</option>
                          <option value="Sharjah Industrial Area 12">Sharjah Industrial Area 12</option>
                          <option value="Sharjah Industrial Area 2">Sharjah Industrial Area 2</option>
                          <option value="Sharjah Industrial Area 3">Sharjah Industrial Area 3</option>
                          <option value="Sharjah Industrial Area 4">Sharjah Industrial Area 4</option>
                          <option value="Sharjah Industrial Area 5">Sharjah Industrial Area 5</option>
                          <option value="Sharjah Industrial Area 6">Sharjah Industrial Area 6</option>
                          <option value="Sharjah Industrial Area 7">Sharjah Industrial Area 7</option>
                          <option value="Sharjah Industrial Area 8">Sharjah Industrial Area 8</option>
                          <option value="Sharjah Industrial Area 9">Sharjah Industrial Area 9</option>
                          <option value="Shis">Shis</option>
                          <option value="Shwaib">Shwaib</option>
                          <option value="Tawi Bil Khabis">Tawi Bil Khabis</option>
                          <option value="Tawi Rashidia">Tawi Rashidia</option>
                          <option value="Tawi Zubair Hamriyah">Tawi Zubair Hamriyah</option>
                          <option value="Turrfana">Turrfana</option>
                          <option value="Um Tarrafa">Um Tarrafa</option>
                          <option value="Umm Khanoor">Umm Khanoor</option>
                          <option value="Wadi Shi">Wadi Shi</option>
                          <option value="Wasit Suburb">Wasit Suburb</option>
                      

                      </ng-container>
                      <ng-container *ngIf="validationform.get('city').value === 'DXB'">
                          <option value="Ayal Nasir">Ayal Nasir</option>
                          <option value="Ud al Bayda">Ud al Bayda</option>
                          <option value="Urqub Juwayza">Urqub Juwayza</option>
                          <option value="Abu Hail">Abu Hail</option>
                          <option value="Abu Hayl">Abu Hayl</option>
                          <option value="Academic City">Academic City</option>
                          <option value="Ad Daghayah">Ad Daghayah</option>
                          <option value="Airport Free Zone">Airport Free Zone</option>
                          <option value="Al `Usbij">Al `Usbij</option>
                          <option value="Al Aweer">Al Aweer</option>
                          <option value="Al Awir">Al Awir</option>
                          <option value="Al Bada">Al Bada</option>
                          <option value="Al Bada'a">Al Bada'a</option>
                          <option value="Al Baharnah">Al Baharnah</option>
                          <option value="Al Balush">Al Balush</option>
                          <option value="Al Baraha">Al Baraha</option>
                          <option value="Al Barahah">Al Barahah</option>
                          <option value="Al Barari">Al Barari</option>
                          <option value="Al Barsha 1">Al Barsha 1</option>
                          <option value="Al Barsha 2">Al Barsha 2</option>
                          <option value="Al Barsha 3">Al Barsha 3</option>
                          <option value="Al Barsha First">Al Barsha First</option>
                          <option value="Al Barshaa Second">Al Barshaa Second</option>
                          <option value="Al Barshaa Third">Al Barshaa Third</option>
                          <option value="Al Faq">Al Faq</option>
                          <option value="Al Furjan">Al Furjan</option>
                          <option value="Al Garhoud">Al Garhoud</option>
                          <option value="Al Goze Industrial District">Al Goze Industrial District</option>
                          <option value="Al Hajarayn">Al Hajarayn</option>
                          <option value="Al Hamriyah">Al Hamriyah</option>
                          <option value="Al Hudaba">Al Hudaba</option>
                          <option value="Al Hudaiba">Al Hudaiba</option>
                          <option value="Al Hudaybah">Al Hudaybah</option>
                          <option value="Al Jaddaf">Al Jaddaf</option>
                          <option value="Al Jafiliya">Al Jafiliya</option>
                          <option value="Al Jafliya">Al Jafliya</option>
                          <option value="Al Karama">Al Karama</option>
                          <option value="Al Khabasi">Al Khabasi</option>
                          <option value="Al Khabeesi">Al Khabeesi</option>
                          <option value="Al Khawanij">Al Khawanij</option>
                          <option value="Al Kifaf">Al Kifaf</option>
                          <option value="Al Lusayli">Al Lusayli</option>
                          <option value="Al Mahra">Al Mahra</option>
                          <option value="Al Manara">Al Manara</option>
                          <option value="Al Mankhool">Al Mankhool</option>
                          <option value="Al Marqadh">Al Marqadh</option>
                          <option value="Al Matinah">Al Matinah</option>
                          <option value="Al Mina">Al Mina</option>
                          <option value="Al Mizhar">Al Mizhar</option>
                          <option value="Al Mizhar 1">Al Mizhar 1</option>
                          <option value="Al Mizhar 2">Al Mizhar 2</option>
                          <option value="Al Muhaisnah">Al Muhaisnah</option>
                          <option value="Al Muraqqabat">Al Muraqqabat</option>
                          <option value="Al Murar">Al Murar</option>
                          <option value="Al Murar al Jadid">Al Murar al Jadid</option>
                          <option value="Al Murar al Qadim">Al Murar al Qadim</option>
                          <option value="Al Musalla">Al Musalla</option>
                          <option value="Al Nahda">Al Nahda</option>
                          <option value="Al Qawz">Al Qawz</option>
                          <option value="Al Quoz">Al Quoz</option>
                          <option value="Al Quoz Industrial Area 1">Al Quoz Industrial Area 1</option>
                          <option value="Al Quoz Industrial Area 2">Al Quoz Industrial Area 2</option>
                          <option value="Al Quoz Industrial Area 3">Al Quoz Industrial Area 3</option>
                          <option value="Al Quoz Industrial Area 4">Al Quoz Industrial Area 4</option>
                          <option value="Al Qusais 1">Al Qusais 1</option>
                          <option value="Al Qusais 2">Al Qusais 2</option>
                          <option value="Al Qusais 3">Al Qusais 3</option>
                          <option value="Al Qusais First">Al Qusais First</option>
                          <option value="Al Qusais Industrial Area Second">Al Qusais Industrial Area Second</option>
                          <option value="Al Qusais Second">Al Qusais Second</option>
                          <option value="Al Qusais Third">Al Qusais Third</option>
                          <option value="Al Qusays">Al Qusays</option>
                          <option value="Al Raffa">Al Raffa</option>
                          <option value="Al Rashidiya">Al Rashidiya</option>
                          <option value="Al Reem 1">Al Reem 1</option>
                          <option value="Al Reem 2">Al Reem 2</option>
                          <option value="Al Reem 3">Al Reem 3</option>
                          <option value="Al Rigga">Al Rigga</option>
                          <option value="Al Safa 1">Al Safa 1</option>
                          <option value="Al Safa 2">Al Safa 2</option>
                          <option value="Al Saffa First">Al Saffa First</option>
                          <option value="Al Saffa Second">Al Saffa Second</option>
                          <option value="Al Safouh First">Al Safouh First</option>
                          <option value="Al Satwa">Al Satwa</option>
                          <option value="Al Shindagah">Al Shindagah</option>
                          <option value="Al Sufouh 2">Al Sufouh 2</option>
                          <option value="Al Twar 1">Al Twar 1</option>
                          <option value="Al Twar 2">Al Twar 2</option>
                          <option value="Al Twar 3">Al Twar 3</option>
                          <option value="Al Twar First">Al Twar First</option>
                          <option value="AL Twar Second">AL Twar Second</option>
                          <option value="Al Waha Villas 1">Al Waha Villas 1</option>
                          <option value="Al Waha Villas 2">Al Waha Villas 2</option>
                          <option value="Al Waheda">Al Waheda</option>
                          <option value="Al Warq'a 5">Al Warq'a 5</option>
                          <option value="Al Warqa'a">Al Warqa'a</option>
                          <option value="Al Wasl">Al Wasl</option>
                          <option value="Al Wuheida">Al Wuheida</option>
                          <option value="Alma">Alma</option>
                          <option value="Alvorada">Alvorada</option>
                          <option value="An Nakhl">An Nakhl</option>
                          <option value="Ar Ra's">Ar Ra's</option>
                          <option value="Ar Rashidiyah">Ar Rashidiyah</option>
                          <option value="Ar Rifa`ah">Ar Rifa`ah</option>
                          <option value="Ar Riqqah">Ar Riqqah</option>
                          <option value="Ar Riqqah Gharb">Ar Riqqah Gharb</option>
                          <option value="Ar Riqqah Sharq">Ar Riqqah Sharq</option>
                          <option value="Arabian Ranches">Arabian Ranches</option>
                          <option value="Armada towers">Armada towers</option>
                          <option value="As Sabkhah">As Sabkhah</option>
                          <option value="As Safa">As Safa</option>
                          <option value="As Satwah">As Satwah</option>
                          <option value="Ash Shamal">Ash Shamal</option>
                          <option value="Ash Shindaghah">Ash Shindaghah</option>
                          <option value="At Tawar">At Tawar</option>
                          <option value="Bawadi">Bawadi</option>
                          <option value="Bu Kadra">Bu Kadra</option>
                          <option value="Bur Dubai">Bur Dubai</option>
                          <option value="Bur Sa`id">Bur Sa`id</option>
                          <option value="Burj Nahar">Burj Nahar</option>
                          <option value="Business Bay">Business Bay</option>
                          <option value="Carmen Village">Carmen Village</option>
                          <option value="City of Arabia">City of Arabia</option>
                          <option value="Corniche Deira">Corniche Deira</option>
                          <option value="Culture Village">Culture Village</option>
                          <option value="Dawwar Burj Nahar">Dawwar Burj Nahar</option>
                          <option value="Dayrah">Dayrah</option>
                          <option value="Deira">Deira</option>
                          <option value="Discovery Gardens">Discovery Gardens</option>
                          <option value="Downtown Burj Khalifa">Downtown Burj Khalifa</option>
                          <option value="Dubai Aid City">Dubai Aid City</option>
                          <option value="Dubai Airport Freezone Area">Dubai Airport Freezone Area</option>
                          <option value="Dubai Autodrome">Dubai Autodrome</option>
                          <option value="Dubai Festival City">Dubai Festival City</option>
                          <option value="Dubai Healthcare City">Dubai Healthcare City</option>
                          <option value="Dubai Industrial City">Dubai Industrial City</option>
                          <option value="Dubai International Financial Centre">Dubai International Financial Centre</option>
                          <option value="Dubai International Media Production Zone (IMPZ)">Dubai International Media Production Zone (IMPZ)</option>
                          <option value="Dubai Internet City">Dubai Internet City</option>
                          <option value="Dubai Investment Park">Dubai Investment Park</option>
                          <option value="Dubai Land">Dubai Land</option>
                          <option value="Dubai Life Style City">Dubai Life Style City</option>
                          <option value="Dubai Marina">Dubai Marina</option>
                          <option value="Dubai Media City">Dubai Media City</option>
                          <option value="Dubai Pearl">Dubai Pearl</option>
                          <option value="Dubai Promenade">Dubai Promenade</option>
                          <option value="Dubai Silicon Oasis">Dubai Silicon Oasis</option>
                          <option value="Dubai Studio City">Dubai Studio City</option>
                          <option value="Dubai Studio City 1">Dubai Studio City 1</option>
                          <option value="Dubai Waterfront">Dubai Waterfront</option>
                          <option value="Dubai World Central">Dubai World Central</option>
                          <option value="DuBiotech">DuBiotech</option>
                          <option value="Emirates Hill First">Emirates Hill First</option>
                          <option value="Emirates Hill Second">Emirates Hill Second</option>
                          <option value="Emirates Hill Third">Emirates Hill Third</option>
                          <option value="Emirates Hills">Emirates Hills</option>
                          <option value="Estella Village">Estella Village</option>
                          <option value="Falcon City of Wonders">Falcon City of Wonders</option>
                          <option value="Ferij al Muhadham">Ferij al Muhadham</option>
                          <option value="Global Village">Global Village</option>
                          <option value="Green Community">Green Community</option>
                          <option value="Green Community Motor City">Green Community Motor City</option>
                          <option value="Green Community West">Green Community West</option>
                          <option value="Greens">Greens</option>
                          <option value="Hamriyah">Hamriyah</option>
                          <option value="Hatta">Hatta</option>
                          <option value="Hattan">Hattan</option>
                          <option value="Hawr al `Anz">Hawr al `Anz</option>
                          <option value="Hayl">Hayl</option>
                          <option value="Hayy al Bastakiyah">Hayy al Bastakiyah</option>
                          <option value="Healthcare City">Healthcare City</option>
                          <option value="Hor Al Anz">Hor Al Anz</option>
                          <option value="Hor Al Anz East">Hor Al Anz East</option>
                          <option value="Hunaywah">Hunaywah</option>
                          <option value="Industrial Area 15">Industrial Area 15</option>
                          <option value="Industrial Area 17">Industrial Area 17</option>
                          <option value="International City">International City</option>
                          <option value="International City (Phase 2)">International City (Phase 2)</option>
                          <option value="International Media Production Zone (IMPZ)">International Media Production Zone (IMPZ)</option>
                          <option value="Jaddaf">Jaddaf</option>
                          <option value="Jebel Ali Village">Jebel Ali Village</option>
                          <option value="Jumayra">Jumayra</option>
                          <option value="Jumeira Second">Jumeira Second</option>
                          <option value="Jumeira Third">Jumeira Third</option>
                          <option value="Jumeirah">Jumeirah</option>
                          <option value="Jumeirah 1">Jumeirah 1</option>
                          <option value="Jumeirah 2">Jumeirah 2</option>
                          <option value="Jumeirah Beach Residence (JBR)">Jumeirah Beach Residence (JBR)</option>
                          <option value="Jumeirah Golf Estates ">Jumeirah Golf Estates </option>
                          <option value="Jumeirah Heights">Jumeirah Heights</option>
                          <option value="Jumeirah Islands">Jumeirah Islands</option>
                          <option value="Jumeirah Lakes Towers">Jumeirah Lakes Towers</option>
                          <option value="Jumeirah Park">Jumeirah Park</option>
                          <option value="Jumeirah Village">Jumeirah Village</option>
                          <option value="Karama">Karama</option>
                          <option value="Knowledge Village ">Knowledge Village </option>
                          <option value="Kurnish">Kurnish</option>
                          <option value="La Colleccion">La Colleccion</option>
                          <option value="Lahbab">Lahbab</option>
                          <option value="Legends">Legends</option>
                          <option value="Liwan">Liwan</option>
                          <option value="M Z Faraidooni (MZF Al Kabhessi)">M Z Faraidooni (MZF Al Kabhessi)</option>
                          <option value="Ma`sharat al Baharnah">Ma`sharat al Baharnah</option>
                          <option value="Madinat Badr">Madinat Badr</option>
                          <option value="Majan">Majan</option>
                          <option value="Mankhul">Mankhul</option>
                          <option value="Margham">Margham</option>
                          <option value="Maritime City">Maritime City</option>
                          <option value="Masfut">Masfut</option>
                          <option value="Meydan">Meydan</option>
                          <option value="Meydan City">Meydan City</option>
                          <option value="Mintaqat as Suq">Mintaqat as Suq</option>
                          <option value="Mintaqat Dubayy at Ta`limiyah">Mintaqat Dubayy at Ta`limiyah</option>
                          <option value="Mirador">Mirador</option>
                          <option value="Mirdif">Mirdif</option>
                          <option value="Motor City">Motor City</option>
                          <option value="Mudon">Mudon</option>
                          <option value="Muhaisanah Fourth">Muhaisanah Fourth</option>
                          <option value="Muhaisanah Second">Muhaisanah Second</option>
                          <option value="Muhaisanah Third">Muhaisanah Third</option>
                          <option value="Muhaisnah 1">Muhaisnah 1</option>
                          <option value="Muhaisnah 2">Muhaisnah 2</option>
                          <option value="Muhaysnah">Muhaysnah</option>
                          <option value="Muhaysnah Shamal">Muhaysnah Shamal</option>
                          <option value="Murrquab">Murrquab</option>
                          <option value="Mushrif">Mushrif</option>
                          <option value="Mushrif Park">Mushrif Park</option>
                          <option value="Muteena">Muteena</option>
                          <option value="Nad Al Hammar">Nad Al Hammar</option>
                          <option value="Nad Al Sheba">Nad Al Sheba</option>
                          <option value="Nad Al Sheba 2">Nad Al Sheba 2</option>
                          <option value="Nadd al Humr">Nadd al Humr</option>
                          <option value="Nadd Al Sheba 3">Nadd Al Sheba 3</option>
                          <option value="Nadd Al Sheba 4">Nadd Al Sheba 4</option>
                          <option value="Nadd ash Shiba">Nadd ash Shiba</option>
                          <option value="Nayf">Nayf</option>
                          <option value="Oud Al Muteena">Oud Al Muteena</option>
                          <option value="Oud Metha">Oud Metha</option>
                          <option value="Palm Jebel Ali">Palm Jebel Ali</option>
                          <option value="Palm Jumeirah">Palm Jumeirah</option>
                          <option value="Palmera">Palmera</option>
                          <option value="Plantation Equestrian and Polo Club">Plantation Equestrian and Polo Club</option>
                          <option value="Port Saeed">Port Saeed</option>
                          <option value="Qaraytaysah">Qaraytaysah</option>
                          <option value="Qimah">Qimah</option>
                          <option value="Ras Al Khor">Ras Al Khor</option>
                          <option value="Ras Al Khor Industrial Area 1">Ras Al Khor Industrial Area 1</option>
                          <option value="Ras Al Khor Industrial Area 2">Ras Al Khor Industrial Area 2</option>
                          <option value="Ras Al Khor Industrial Area 3">Ras Al Khor Industrial Area 3</option>
                          <option value="Remraam">Remraam</option>
                          <option value="Riqqah al Butayn">Riqqah al Butayn</option>
                          <option value="Saheel">Saheel</option>
                          <option value="Satwa">Satwa</option>
                          <option value="Savannah">Savannah</option>
                          <option value="Sharjah Industrial Area 11">Sharjah Industrial Area 11</option>
                          <option value="Sikkat al Khayl">Sikkat al Khayl</option>
                          <option value="Sports City">Sports City</option>
                          <option value="Sufayri">Sufayri</option>
                          <option value="Tawi as Saygh">Tawi as Saygh</option>
                          <option value="Technology Park">Technology Park</option>
                          <option value="Tecom">Tecom</option>
                          <option value="Terra Nova">Terra Nova</option>
                          <option value="The Gardens">The Gardens</option>
                          <option value="The Lagoons">The Lagoons</option>
                          <option value="The Lakes">The Lakes</option>
                          <option value="The Meadows">The Meadows</option>
                          <option value="The Meadows 5">The Meadows 5</option>
                          <option value="The Springs">The Springs</option>
                          <option value="The Tiger Woods Dubai">The Tiger Woods Dubai</option>
                          <option value="The Views">The Views</option>
                          <option value="The Villa">The Villa</option>
                          <option value="The World Islands">The World Islands</option>
                          <option value="Tilal Dubai">Tilal Dubai</option>
                          <option value="Um Al Sheif">Um Al Sheif</option>
                          <option value="Um Suqaim Second">Um Suqaim Second</option>
                          <option value="Umm Al Sheif">Umm Al Sheif</option>
                          <option value="Umm Hurair 1">Umm Hurair 1</option>
                          <option value="Umm Hurair 2">Umm Hurair 2</option>
                          <option value="Umm Hurayr">Umm Hurayr</option>
                          <option value="Umm Ramool">Umm Ramool</option>
                          <option value="Umm Suqaym">Umm Suqaym</option>
                          <option value="Umm Suqueim 1">Umm Suqueim 1</option>
                          <option value="Umm Suqueim 2">Umm Suqueim 2</option>
                          <option value="Umm Suqueim 3">Umm Suqueim 3</option>
                          <option value="Up Town Motor City">Up Town Motor City</option>
                          <option value="Victory Heights">Victory Heights</option>
                          <option value="Warisan">Warisan</option>
                          <option value="Warsan">Warsan</option>
                          <option value="Warsan 1">Warsan 1</option>
                          <option value="Warsan 2">Warsan 2</option>
                          <option value="World Trade Center">World Trade Center</option>
                          <option value="Zabeel 1">Zabeel 1</option>
                          <option value="Zabeel First">Zabeel First</option>
                          <option value="Zaribat Dawiy">Zaribat Dawiy</option>

                          <option value="Hatta, Friday Market">Hatta, Friday Market</option>
                          <option value="Hatta, Hatta Stadium">Hatta, Hatta Stadium</option>
                          <option value="Hatta, Khansaheb Camel Track">Hatta, Khansaheb Camel Track</option>

                      </ng-container>
                      <ng-container *ngIf="validationform.get('city').value === 'UAQ'">
                        <option value="Falaj Al Mualla">Falaj Al Mualla</option>

                        <option value="Uwaynat">Uwaynat</option>
                        <option value="Al `Adhib">Al `Adhib</option>
                        <option value="Al Abraq">Al Abraq</option>
                        <option value="Al Azeeb">Al Azeeb</option>
                        <option value="Al Azeeb, Al Khaleej Markets">Al Azeeb, Al Khaleej Markets</option>
                        <option value="Al Biyatha">Al Biyatha</option>
                        <option value="Al Dar Al Baida - A">Al Dar Al Baida - A</option>
                        <option value="Al Dar Al Baida - B">Al Dar Al Baida - B</option>
                        <option value="Al Haditha">Al Haditha</option>
                        <option value="Al Hamrah - B">Al Hamrah - B</option>
                        <option value="Al Hamrah - D">Al Hamrah - D</option>
                        <option value="Al Hawiyah">Al Hawiyah</option>
                        <option value="Al Hazaywah">Al Hazaywah</option>
                        <option value="Al Humrah - A">Al Humrah - A</option>
                        <option value="Al Khor">Al Khor</option>
                        <option value="Al Labsah">Al Labsah</option>
                        <option value="Al Limghadar">Al Limghadar</option>
                        <option value="Al Madar">Al Madar</option>
                        <option value="Al Maidan">Al Maidan</option>
                        <option value="Al Quram">Al Quram</option>
                        <option value="Al Raafa">Al Raafa</option>
                        <option value="Al Ra'as - A">Al Ra'as - A</option>
                        <option value="Al Ra'as - B">Al Ra'as - B</option>
                        <option value="Al Ra'as - C">Al Ra'as - C</option>
                        <option value="Al Ra'as - D">Al Ra'as - D</option>
                        <option value="Al Rashidiya">Al Rashidiya</option>
                        <option value="Al Rashidiya, Hamra Golf Club">Al Rashidiya, Hamra Golf Club</option>
                        <option value="Al Rashidiya, Sharjah Co-Operative Society">Al Rashidiya, Sharjah Co-Operative Society</option>
                        <option value="Al Raudah">Al Raudah</option>
                        <option value="Al Riqqah">Al Riqqah</option>
                        <option value="Al Salam City">Al Salam City</option>
                        <option value="Al Surrah">Al Surrah</option>
                        <option value="Ar Ra`fah">Ar Ra`fah</option>
                        <option value="Ar Ramlah">Ar Ramlah</option>
                        <option value="Ar Rashidiyah">Ar Rashidiyah</option>
                        <option value="As Salamah">As Salamah</option>
                        <option value="As Surrah">As Surrah</option>
                        <option value="Barracuda">Barracuda</option>
                        <option value="Barracuda Beach Resort">Barracuda Beach Resort</option>
                        <option value="Biyatah">Biyatah</option>
                        <option value="Defence Camp">Defence Camp</option>
                        <option value="Diwwan Al Amiri">Diwwan Al Amiri</option>
                        <option value="Emirates Modern Industrial">Emirates Modern Industrial</option>
                        <option value="Emirates Motorplex - UAQ/RAK road">Emirates Motorplex - UAQ/RAK road</option>
                        <option value="Environmental Marine Research Center">Environmental Marine Research Center</option>
                        <option value="Falaj al Moalla">Falaj al Moalla</option>
                        <option value="Green Belt">Green Belt</option>
                        <option value="Hazaiwa">Hazaiwa</option>
                        <option value="Industrial Area A">Industrial Area A</option>
                        <option value="Industrial Area B">Industrial Area B</option>
                        <option value="Industrial Area C">Industrial Area C</option>
                        <option value="Kaber">Kaber</option>
                        <option value="Kabir">Kabir</option>
                        <option value="Khor Al Beidah">Khor Al Beidah</option>
                        <option value="Lazimah">Lazimah</option>
                        <option value="Lubsah">Lubsah</option>
                        <option value="Lubsah, Lulu Centre">Lubsah, Lulu Centre</option>
                        <option value="Mintaqah al Hadithah">Mintaqah al Hadithah</option>
                        <option value="Mintaqat ad Dar al Bayda' A">Mintaqat ad Dar al Bayda' A</option>
                        <option value="Mintaqat ad Dar al Bayda' B">Mintaqat ad Dar al Bayda' B</option>
                        <option value="Mintaqat al `Ahd">Mintaqat al `Ahd</option>
                        <option value="Mintaqat al Hawiyah">Mintaqat al Hawiyah</option>
                        <option value="Mintaqat al Humrah A">Mintaqat al Humrah A</option>
                        <option value="Mintaqat al Humrah B">Mintaqat al Humrah B</option>
                        <option value="Mintaqat al Humrah D">Mintaqat al Humrah D</option>
                        <option value="Mintaqat al Humrah J">Mintaqat al Humrah J</option>
                        <option value="Mintaqat al Khawr">Mintaqat al Khawr</option>
                        <option value="Mintaqat al Madinah al Qadimah">Mintaqat al Madinah al Qadimah</option>
                        <option value="Mintaqat al Maydan">Mintaqat al Maydan</option>
                        <option value="Mintaqat ar Ra's A">Mintaqat ar Ra's A</option>
                        <option value="Mintaqat ar Ra's B">Mintaqat ar Ra's B</option>
                        <option value="Mintaqat ar Ra's D">Mintaqat ar Ra's D</option>
                        <option value="Mintaqat ar Ra's J">Mintaqat ar Ra's J</option>
                        <option value="Mintaqat ar Rawdah">Mintaqat ar Rawdah</option>
                        <option value="Mintaqat ar Riqqah">Mintaqat ar Riqqah</option>
                        <option value="Mintaqat Limghadar">Mintaqat Limghadar</option>
                        <option value="Mintaqat Umm al Qaywayn at Tibbiyah">Mintaqat Umm al Qaywayn at Tibbiyah</option>
                        <option value="Mohadhub">Mohadhub</option>
                        <option value="Muhadhdhib">Muhadhdhib</option>
                        <option value="Old Town">Old Town</option>
                        <option value="The settlement of fishermen">The settlement of fishermen</option>
                        <option value="Umm Al Quwain">Umm Al Quwain</option>
                        <option value="Umm Al Quwain Aviation & Parachute Club">Umm Al Quwain Aviation & Parachute Club</option>
                        <option value="Umm Al Quwain Hunting & Shooting Club">Umm Al Quwain Hunting & Shooting Club</option>
                        <option value="Umm Al Quwain Marina">Umm Al Quwain Marina</option>
                        <option value="Umm Al Thaoub Industrial Area">Umm Al Thaoub Industrial Area</option>
                        <option value="White Bay">White Bay</option>
                      </ng-container>
                      <ng-container *ngIf="validationform.get('city').value === 'FUJ'">
                          <option value="Abadilah">Abadilah</option>
                          <option value="Akamiyah">Akamiyah</option>
                          <option value="Aqqah">Aqqah</option>
                          <option value="Asamah">Asamah</option>
                          <option value="Ashashah">Ashashah</option>
                          <option value="Uqayr">Uqayr</option>
                          <option value="Afarah">Afarah</option>
                          <option value="Al `Awdah">Al `Awdah</option>
                          <option value="Al `Ayn al Ghumur">Al `Ayn al Ghumur</option>
                          <option value="Al `Uyaynah">Al `Uyaynah</option>
                          <option value="Al Aqah">Al Aqah</option>
                          <option value="Al Fuqait">Al Fuqait</option>
                          <option value="Al Ghurfa">Al Ghurfa</option>
                          <option value="Al Ghurfah">Al Ghurfah</option>
                          <option value="Al Gissemari">Al Gissemari</option>
                          <option value="Al Halah">Al Halah</option>
                          <option value="Al Hayl">Al Hayl</option>
                          <option value="Al Hinya">Al Hinya</option>
                          <option value="Al Kubus">Al Kubus</option>
                          <option value="Al Manamah">Al Manamah</option>
                          <option value="Al Qurayyah">Al Qurayyah</option>
                          <option value="Ar Rul">Ar Rul</option>
                          <option value="Badiyah">Badiyah</option>
                          <option value="Bethna">Bethna</option>
                          <option value="Bitnah">Bitnah</option>
                          <option value="Blaydah">Blaydah</option>
                          <option value="Corniche">Corniche</option>
                          <option value="Dab`ah">Dab`ah</option>
                          <option value="Dadna">Dadna</option>
                          <option value="Daftah">Daftah</option>
                          <option value="Dahir">Dahir</option>
                          <option value="Diba">Diba</option>
                          <option value="Dibba">Dibba</option>
                          <option value="Dub">Dub</option>
                          <option value="Falakh">Falakh</option>
                          <option value="Faqi">Faqi</option>
                          <option value="Far`ah">Far`ah</option>
                          <option value="Friday Market">Friday Market</option>
                          <option value="Fujairah">Fujairah</option>
                          <option value="Ghamarah">Ghamarah</option>
                          <option value="Ghayl">Ghayl</option>
                          <option value="Ghurfah">Ghurfah</option>
                          <option value="Girath">Girath</option>
                          <option value="Haqil">Haqil</option>
                          <option value="Harat Zutut">Harat Zutut</option>
                          <option value="Harrah">Harrah</option>
                          <option value="Hatiyah">Hatiyah</option>
                          <option value="Hayat">Hayat</option>
                          <option value="Jabal Qurayyah">Jabal Qurayyah</option>
                          <option value="Jareef">Jareef</option>
                          <option value="Kalba">Kalba</option>
                          <option value="Khalba">Khalba</option>
                          <option value="Khawr Kalba">Khawr Kalba</option>
                          <option value="Khor Khalba">Khor Khalba</option>
                          <option value="Khulaybiyah">Khulaybiyah</option>
                          <option value="Maidaq">Maidaq</option>
                          <option value="Masafi">Masafi</option>
                          <option value="Masafi, Fruit and Vegetables Market">Masafi, Fruit and Vegetables Market</option>
                          <option value="Mawrid">Mawrid</option>
                          <option value="Maydaq">Maydaq</option>
                          <option value="Merbah, Fujairah">Merbah, Fujairah</option>
                          <option value="Minazif">Minazif</option>
                          <option value="Mu`taridah">Mu`taridah</option>
                          <option value="Mukhtaraqah">Mukhtaraqah</option>
                          <option value="Murbad">Murbad</option>
                          <option value="Murbah">Murbah</option>
                          <option value="Murrah">Murrah</option>
                          <option value="Nuhayy">Nuhayy</option>
                          <option value="Osfai">Osfai</option>
                          <option value="Qidfa">Qidfa</option>
                          <option value="Ras Dibba">Ras Dibba</option>
                          <option value="Riyamah">Riyamah</option>
                          <option value="Rughaylat">Rughaylat</option>
                          <option value="Rul Dadna">Rul Dadna</option>
                          <option value="Safad">Safad</option>
                          <option value="Sa'if">Sa'if</option>
                          <option value="Saqamqam">Saqamqam</option>
                          <option value="Sharm">Sharm</option>
                          <option value="Shawiyah">Shawiyah</option>
                          <option value="Siji">Siji</option>
                          <option value="Sinnah">Sinnah</option>
                          <option value="Sumbrair">Sumbrair</option>
                          <option value="Sur">Sur</option>
                          <option value="Tarif Kalba">Tarif Kalba</option>
                          <option value="Tariqat Ja`d">Tariqat Ja`d</option>
                          <option value="Tawi Siji">Tawi Siji</option>
                          <option value="Tawian">Tawian</option>
                          <option value="Tayyibah">Tayyibah</option>
                          <option value="Teba">Teba</option>
                          <option value="Theeb">Theeb</option>
                          <option value="Thoban">Thoban</option>
                          <option value="Wa`bayn">Wa`bayn</option>
                          <option value="Wahala">Wahala</option>
                          <option value="Wamm">Wamm</option>
                          <option value="Yalah">Yalah</option>
                          <option value="Zanhah">Zanhah</option>
                          <option value="Zikt">Zikt</option>
                      </ng-container>
                      <ng-container *ngIf="validationform.get('city').value === 'RAK'">
                          <option value="Old Ras Al Khaimah">Old Ras Al Khaimah</option>
                          <option value="Old Ras Al Khaimah, Al Waha Trading Market">Old Ras Al Khaimah, Al Waha Trading Market</option>
                          <option value="Old Ras Al Khaimah, Bin Dahur Centre">Old Ras Al Khaimah, Bin Dahur Centre</option>
                          <option value="Ayim">Ayim</option>
                          <option value="Uraybi">Uraybi</option>
                          <option value="Adh Dharbaniyah">Adh Dharbaniyah</option>
                          <option value="Adhan">Adhan</option>
                          <option value="Al Fahlayn">Al Fahlayn</option>
                          <option value="Al Fara">Al Fara</option>
                          <option value="Al Fara">Al Fara</option>
                          <option value="Al Fulayyah">Al Fulayyah</option>
                          <option value="Al Ghabah">Al Ghabah</option>
                          <option value="Al Ghabam">Al Ghabam</option>
                          <option value="Al Ghail">Al Ghail</option>
                          <option value="Al Ghashban">Al Ghashban</option>
                          <option value="Al Hamra Village">Al Hamra Village</option>
                          <option value="Al Hamraniyah">Al Hamraniyah</option>
                          <option value="Al Hayr">Al Hayr</option>
                          <option value="Al Hulaylah">Al Hulaylah</option>
                          <option value="Al Jaddah">Al Jaddah</option>
                          <option value="Al Jazirah al Hamra">Al Jazirah al Hamra</option>
                          <option value="Al Jazirah Aviation Club">Al Jazirah Aviation Club</option>
                          <option value="Al Khari">Al Khari</option>
                          <option value="Al Khashfah">Al Khashfah</option>
                          <option value="Al Mahamm">Al Mahamm</option>
                          <option value="Al Mamorah">Al Mamorah</option>
                          <option value="Al Marjan Island">Al Marjan Island</option>
                          <option value="Al Masafirah">Al Masafirah</option>
                          <option value="Al Mu`amurah">Al Mu`amurah</option>
                          <option value="Al Qir">Al Qir</option>
                          <option value="Al Quwayz">Al Quwayz</option>
                          <option value="Al Ramms">Al Ramms</option>
                          <option value="Al Riffa">Al Riffa</option>
                          <option value="Al Usayli">Al Usayli</option>
                          <option value="An Nakhil">An Nakhil</option>
                          <option value="Ar Rams">Ar Rams</option>
                          <option value="As Sur">As Sur</option>
                          <option value="Ash Sha`m">Ash Sha`m</option>
                          <option value="Athabat">Athabat</option>
                          <option value="Baqal">Baqal</option>
                          <option value="Bida">Bida</option>
                          <option value="Bidiyah">Bidiyah</option>
                          <option value="Bulaydah">Bulaydah</option>
                          <option value="Corniche">Corniche</option>
                          <option value="Creek">Creek</option>
                          <option value="Daftah">Daftah</option>
                          <option value="Darah">Darah</option>
                          <option value="Dayah">Dayah</option>
                          <option value="Daynah">Daynah</option>
                          <option value="Dhad al Arab">Dhad al Arab</option>
                          <option value="Difan">Difan</option>
                          <option value="Dihan">Dihan</option>
                          <option value="Diqdaqah">Diqdaqah</option>
                          <option value="Diqdaqah, Al Waha Centre">Diqdaqah, Al Waha Centre</option>
                          <option value="eXmajor Hangar">eXmajor Hangar</option>
                          <option value="Fashrah">Fashrah</option>
                          <option value="Fa'y">Fa'y</option>
                          <option value="Fayyad">Fayyad</option>
                          <option value="Financial City (DIFC)">Financial City (DIFC)</option>
                          <option value="Furfar">Furfar</option>
                          <option value="Ghadf">Ghadf</option>
                          <option value="Ghaghah">Ghaghah</option>
                          <option value="Ghalilah">Ghalilah</option>
                          <option value="Ghay">Ghay</option>
                          <option value="Ghubb">Ghubb</option>
                          <option value="Ghubbat Khawrah">Ghubbat Khawrah</option>
                          <option value="Ghurah">Ghurah</option>
                          <option value="Gragrah">Gragrah</option>
                          <option value="Habhab">Habhab</option>
                          <option value="Ham Ham">Ham Ham</option>
                          <option value="Hamra' Al Jazirah al">Hamra' Al Jazirah al</option>
                          <option value="Harat `Awali">Harat `Awali</option>
                          <option value="Hayl">Hayl</option>
                          <option value="Homraniya">Homraniya</option>
                          <option value="Hudaybah">Hudaybah</option>
                          <option value="Huwaylat">Huwaylat</option>
                          <option value="Industrial and Technology Park">Industrial and Technology Park</option>
                          <option value="Jazirat al Hamra">Jazirat al Hamra</option>
                          <option value="Jazirat al Hamra', Beach Centre">Jazirat al Hamra', Beach Centre</option>
                          <option value="Jazirat al Hamra', Hatta Fort Golf Course">Jazirat al Hamra', Hatta Fort Golf Course</option>
                          <option value="Khabakhib">Khabakhib</option>
                          <option value="Kharran">Kharran</option>
                          <option value="Khatt">Khatt</option>
                          <option value="Khawr Khuwayr">Khawr Khuwayr</option>
                          <option value="Khazam">Khazam</option>
                          <option value="Kub">Kub</option>
                          <option value="Ma`ali">Ma`ali</option>
                          <option value="Maghribiyah">Maghribiyah</option>
                          <option value="Manqashah">Manqashah</option>
                          <option value="Marhamid">Marhamid</option>
                          <option value="Masafi">Masafi</option>
                          <option value="Masah">Masah</option>
                          <option value="Mina Al Arab">Mina Al Arab</option>
                          <option value="Minha">Minha</option>
                          <option value="Mu`ayrid">Mu`ayrid</option>
                          <option value="Munay`i">Munay`i</option>
                          <option value="Muraytah">Muraytah</option>
                          <option value="New Hangar Zebra VON">New Hangar Zebra VON</option>
                          <option value="Qabas">Qabas</option>
                          <option value="Qaf'ah">Qaf'ah</option>
                          <option value="Qarat ad Dum">Qarat ad Dum</option>
                          <option value="Quar Ah Qahlish">Quar Ah Qahlish</option>
                          <option value="Qur">Qur</option>
                          <option value="Qurm">Qurm</option>
                          <option value="Qusaydat">Qusaydat</option>
                          <option value="Rafaq">Rafaq</option>
                          <option value="RAK airport">RAK airport</option>
                          <option value="Ramlah">Ramlah</option>
                          <option value="Rams">Rams</option>
                          <option value="Ras Al Khaimah">Ras Al Khaimah</option>
                          <option value="Ras al Khaimah, Al Dour Archaeological Site">Ras al Khaimah, Al Dour Archaeological Site</option>
                          <option value="Ras al Khaimah, Al Safeer Shopping Center">Ras al Khaimah, Al Safeer Shopping Center</option>
                          <option value="Ras al Khaimah, Emirates Cultural Sport Club">Ras al Khaimah, Emirates Cultural Sport Club</option>
                          <option value="Ras al Khaimah, Emirates Pearls Markets">Ras al Khaimah, Emirates Pearls Markets</option>
                          <option value="Ras al Khaimah, Fish Market">Ras al Khaimah, Fish Market</option>
                          <option value="Ras al Khaimah, Madinet Zayed Camel Race Track">Ras al Khaimah, Madinet Zayed Camel Race Track</option>
                          <option value="Ras al Khaimah, Mdinet Zayed Market">Ras al Khaimah, Mdinet Zayed Market</option>
                          <option value="Ras al Khaimah, Rak Trading Mall">Ras al Khaimah, Rak Trading Mall</option>
                          <option value="Ras al Khaimah, Safeer Mall">Ras al Khaimah, Safeer Mall</option>
                          <option value="Ras al Khaimah, Saif Al Shawi">Ras al Khaimah, Saif Al Shawi</option>
                          <option value="Rima">Rima</option>
                          <option value="Sal Dora">Sal Dora</option>
                          <option value="Salihiyah">Salihiyah</option>
                          <option value="Samarat">Samarat</option>
                          <option value="Saraya Islands">Saraya Islands</option>
                          <option value="Sayh">Sayh</option>
                          <option value="Sayh as Saqlah">Sayh as Saqlah</option>
                          <option value="Sha`biyat Naslah">Sha`biyat Naslah</option>
                          <option value="Shabakah">Shabakah</option>
                          <option value="Shah">Shah</option>
                          <option value="Shahawat">Shahawat</option>
                          <option value="Shariyah">Shariyah</option>
                          <option value="Sharyat">Sharyat</option>
                          <option value="Shawkah">Shawkah</option>
                          <option value="Shimal">Shimal</option>
                          <option value="Stan">Stan</option>
                          <option value="Suhaybah">Suhaybah</option>
                          <option value="Wad Wid">Wad Wid</option>
                          <option value="Waterfront">Waterfront</option>
                          <option value="Wayb Hawf">Wayb Hawf</option>
                          <option value="Yasmin Village">Yasmin Village</option>
                          <option value="Yinas">Yinas</option>
                      </ng-container>

                  </select>
                      <div *ngIf="form.area.errors" class="invalid-feedback">
                        <span *ngIf="form.area.hasError('required')">Area is required.</span>
                      </div> 
                    </div>
                  </div>
                  <div class="row mb-3">
                    <label for="validationCustom22" class="col-md-3 col-form-label">Building</label>
                    <div class="col-md-9">
                      <input type="text" class="form-control" id="validationCustom22" formControlName="building"
                      placeholder="Enter Building" [ngClass]="{'is-invalid': validation && form.building.errors}">
                      <div *ngIf="form.building.errors" class="invalid-feedback">
                        <span *ngIf="form.building.hasError('required')">Building is required.</span>
                      </div> 
                    </div>
                  </div>
                  <div class="row mb-3">
                    <label for="validationCustom23" class="col-md-3 col-form-label">Apartment</label>
                    <div class="col-md-9">
                      <input type="text" class="form-control" id="validationCustom23" formControlName="apartment"
                      placeholder="Enter Apartment" [ngClass]="{'is-invalid': validation && form.apartment.errors}">
                      <div *ngIf="form.apartment.errors" class="invalid-feedback">
                        <span *ngIf="form.apartment.hasError('required')">Apartment is required.</span>
                      </div> 
                    </div>
                  </div>
                  <div class="row mb-3">
                    <label for="validationCustom10" class="col-md-3 col-form-label">Latitude</label>
                    <div class="col-md-9">
                      <input type="text" class="form-control" id="validationCustom10" formControlName="latitude"
                      placeholder="Enter Latitude" [ngClass]="{'is-invalid': validation && form.latitude.errors}">
                      <div *ngIf="form.latitude.errors" class="invalid-feedback">
                        <span *ngIf="form.latitude.hasError('required')">Latitude is required.</span>
                      </div> 
                    </div>
                  </div>
                  <div class="row mb-3">
                    <label for="validationCustom11" class="col-md-3 col-form-label">Longitude</label>
                    <div class="col-md-9">
                      <input type="text" class="form-control" id="validationCustom11" formControlName="longitude"
                      placeholder="Enter Longitude" [ngClass]="{'is-invalid': validation && form.longitude.errors}">
                      <div *ngIf="form.longitude.errors" class="invalid-feedback">
                        <span *ngIf="form.longitude.hasError('required')">Longitude is required.</span>
                      </div> 
                    </div>
                  </div>
              </div>
              <div class="col-lg-12">
                <div class="card">
                  <div class="card-body">
                    <!-- Map -->
                    <agm-map 
                      [latitude]="latitude" 
                      [longitude]="longitude" 
                      style="height: 300px" 
                      (mapClick)="mapLeftClick($event)">
                      
                      <agm-marker 
                          *ngIf="markerVisible"
                          [latitude]="latitude"
                          [longitude]="longitude">
                      </agm-marker>
                      
                    </agm-map>
                  </div>
                </div>
              </div>
              <div #streetviewMap></div>
              <!-- <div #streetviewPano></div> -->
              
              <ul class="list-inline wizard mb-0">
                <li class="previous list-inline-item"><button class="btn btn-primary" (click)="goToPreviousStep()" awPreviousStep>Previous</button>
                </li>
                <li class="list-inline-item"><button class="btn btn-primary" (click)="getCurrentLocation()" >Get Current Location</button>
                </li>
                <li class="next list-inline-item float-end"><button class="btn btn-primary" (click)="goToPreviousStep()" awNextStep>Next</button>
                </li>
              </ul>

              

            </aw-wizard-step>

            <aw-wizard-step>
              <ng-template awWizardStepSymbol>
                <i class="fas fa-upload"></i>
              </ng-template>
              <div class="row">
                <div class="row mb-3">
                  <div class="col-md-12">
                    <label for="validationCustom12" class="col-md-12 col-form-label">Upload the Profile Image</label>
                    <input type="file" class="form-control" id="validationCustom12" formControlName="image"
                    [ngClass]="{'is-invalid': !isImageValid}" (change)="validateImage($event)">
                    <div *ngIf="!isImageValid" class="invalid-feedback">
                      <!-- <span *ngIf="form.image.errors?.required">Please select an image to upload.</span> -->
                      <span *ngIf="form.image.errors?.invalidFileType">Invalid file type. Please select a JPG, PNG, or JPEG file.</span>
                      <span *ngIf="form.image.errors?.maxSizeExceeded">File size exceeded. Please select a file up to 5MB in size.</span>
                    </div> 
                  </div>
                </div>
              </div>
              <ul class="list-inline wizard mb-0">
                <li class="previous list-inline-item"><button class="btn btn-primary" (click)="goToPreviousStep()" awPreviousStep>Previous</button>
                </li>
                <li class="next list-inline-item float-end">
                  <button type="submit" class="btn btn-primary" (click)="submitData()">Submit</button>
              </ul>
            </aw-wizard-step>
          </form>
        </aw-wizard>
      </div>
    </div>
  </div>
</ng-template>

<!-- Tab Content -->
<ng-template #TabContent1>
  <div class="col-lg-12">
    <div class="card">
      <div class="card-body">
        <h4 class="card-title mb-4">Freelancer</h4>
        <aw-wizard #wizard [navBarLayout]="'large-empty-symbols'">
          <form class="needs-validation" (ngSubmit)="validSubmitFreelancer()" [formGroup]="validationfreelancer">
            <aw-wizard-step>
              <ng-template awWizardStepSymbol>
                <i class="fas fa-user"></i>
              </ng-template>
              <div class="row">
                  

                  <div class="row mb-3">
                    <label for="validationCustom100" class="col-md-3 col-form-label">Select Services</label>
                    <div class="col-md-9">
                      <ng-select 
                        [items]="selectValue" 
                        [multiple]="true" 
                        formControlName="services" 
                        class="form-control" 
                        id="validationCustom100"
                        [ngClass]="{'is-invalid': validation_freelancer && formFreelancer.services.errors}">
                      </ng-select>
                    </div>
                    <!-- Validation Feedback -->
                    <div *ngIf="formFreelancer.services.errors" class="invalid-feedback">
                      <span *ngIf="formFreelancer.services.hasError('required')">Services selection is required.</span>
                      <!-- <span *ngIf="formFreelancer.services.hasError('maxSelected')">You can select a maximum of 4 services.</span> -->
                    </div>
                  </div>


                  <div class="row mb-3">
                    <label for="validationCustom01" class="col-md-3 col-form-label">Name</label>
                    <div class="col-md-9">
                      <input type="text" class="form-control" id="validationCustom01" formControlName="name"
                      placeholder="Enter Name" [ngClass]="{'is-invalid': validation_freelancer && formFreelancer.name.errors}">
                      <div *ngIf="formFreelancer.name.errors" class="invalid-feedback">
                        <span *ngIf="formFreelancer.name.hasError('required')">User Name is required.</span>
                        <span *ngIf="formFreelancer.name.hasError('pattern')">Only Allowed Alphabet and Number.</span>
                      </div> 
                    </div>
                  </div>
                  <div class="row mb-3">
                    <label for="validationCustom02" class="col-md-3 col-form-label">Email</label>
                    <div class="col-md-9">
                      <input type="text" class="form-control" id="validationCustom02" formControlName="email"
                      placeholder="Enter Email" [ngClass]="{'is-invalid': validation_freelancer && formFreelancer.email.errors}">
                      <div *ngIf="formFreelancer.email.errors" class="invalid-feedback">
                        <span *ngIf="formFreelancer.email.hasError('required')">User Email is required.</span>
                        <span *ngIf="formFreelancer.email.hasError('pattern')">Email Pattern is not match.</span>
                      </div> 
                    </div>
                  </div>
                  <div class="row mb-3">
                    <label for="validationCustom03" class="col-md-3 col-form-label">Password</label>
                    <div class="col-md-9">
                      <input type="password" class="form-control" id="validationCustom03" formControlName="password"
                      placeholder="Enter Password" [ngClass]="{'is-invalid': validation_freelancer && formFreelancer.password.errors}">
                      <div *ngIf="formFreelancer.password.errors" class="invalid-feedback">
                        <span *ngIf="formFreelancer.password.hasError('required')">User password is required.</span>
                        <span *ngIf="formFreelancer.password.hasError('minlength')">Atleaset 8 characters required.</span>
                      </div> 
                    </div>
                  </div>
                  <div class="mb-3 row">
                    <label for="validationCustom04" class="col-md-3 col-form-label">Gender</label>
                    <div class="col-md-9">
                        <select class="form-select" id="validationCustom04" formControlName="gender"
                                [ngClass]="{'is-invalid': validation_freelancer && formFreelancer.gender.errors}">
                            <option value="M">Male</option>
                            <option value="F">Female</option>
                            <!-- <option value="O">Other</option> -->
                        </select>
                        <div *ngIf="formFreelancer.gender.errors" class="invalid-feedback">
                          <span *ngIf="formFreelancer.gender.hasError('required')">Gender is required.</span>
                        </div> 
                    </div>
                  </div>
                  <div class="mb-3 row">
                    <label for="validationCustom05" class="col-md-3 col-form-label">Phone Number</label>
                    <div class="col-md-9 d-flex align-items-center">
                      <div class="input-group">
                        <div class="input-group-text">+971</div>
                        <input type="text" class="form-control" id="validationCustom05" formControlName="phone_number"
                        placeholder="Enter Phone Number" [ngClass]="{'is-invalid': validation_freelancer && formFreelancer.phone_number.errors}">
                        </div>
                      <div *ngIf="formFreelancer.phone_number.errors" class="invalid-feedback">
                      <span *ngIf="formFreelancer.phone_number.hasError('required')">Phone Number is required.</span>
                      <span *ngIf="formFreelancer.phone_number.hasError('pattern')">Phone number has 9 digit.</span>
                    </div> 
                   </div>
                  </div>
              </div>
              <ul class="list-inline wizard mb-0">
                <li class="next list-inline-item float-end"><button class="btn btn-primary" (click)="goToPreviousStep()" awNextStep>Next</button>
                </li>
              </ul>
            </aw-wizard-step>            

            <aw-wizard-step>
              <ng-template awWizardStepSymbol>
                <i class="far fa-address-card"></i>
              </ng-template>
              <div class="row">
                  <div class="row mb-3">
                    <label for="validationCustom06" class="col-md-3 col-form-label">Address Name</label>
                    <div class="col-md-9">
                      <input type="text" class="form-control" id="validationCustom06" formControlName="address_name"
                      placeholder="Enter Address Name" [ngClass]="{'is-invalid': validation_freelancer && formFreelancer.address_name.errors}">
                      <div *ngIf="formFreelancer.address_name.errors" class="invalid-feedback">
                        <span *ngIf="formFreelancer.address_name.hasError('required')">Address Name is required.</span>
                      </div> 
                    </div>
                  </div>
                  <div class="mb-3 row">
                    <label for="validationCustom08" class="col-md-3 col-form-label">Country</label>
                    <div class="col-md-9">
                        <select class="form-select" id="validationCustom08" formControlName="country"
                                [ngClass]="{'is-invalid': validation_freelancer && formFreelancer.country.errors}">
                          <option value="UAE">United Arab Emirates</option>
                        </select>
                        <div *ngIf="formFreelancer.country.errors" class="invalid-feedback">
                          <span *ngIf="formFreelancer.country.hasError('required')">Country is required.</span>
                        </div> 
                    </div>                  
                  </div>
                  <div class="mb-3 row">
                    <label for="validationCustom09" class="col-md-3 col-form-label">City</label>
                    <div class="col-md-9">
                        <select class="form-select" id="validationCustom09" formControlName="city"
                                [ngClass]="{'is-invalid': validation_freelancer && formFreelancer.city.errors}">
                            <option value="AUH">Abu Dhabi</option>
                            <option value="AA">Al Ain</option>
                            <option value="DXB">Dubai</option>
                            <option value="SHJ">Sharjah</option>
                            <option value="AJM">Ajman</option>
                            <option value="UAQ">Umm Al Quwain</option>
                            <option value="RAK">Ras Al Khaimah</option>
                            <option value="FUJ">Fujairah</option>
                        </select>
                        <div *ngIf="formFreelancer.city.errors" class="invalid-feedback">
                          <span *ngIf="formFreelancer.city.hasError('required')">City is required.</span>
                        </div> 
                    </div>  
                  </div>
                  <div class="row mb-3">
                    <label for="validationCustom21" class="col-md-3 col-form-label">Area</label>
                    <div class="col-md-9">
                      <!-- <input type="text" class="form-control" id="validationCustom21" formControlName="area"
                      placeholder="Enter Area" [ngClass]="{'is-invalid': validation && form.area.errors}"> -->
                      <select class="form-select" id="validationCustom21" formControlName="area"
                      [ngClass]="{'is-invalid': validation_freelancer && formFreelancer.area.errors}">
                          <ng-container *ngIf="validationfreelancer.get('city').value === 'AUH'">
                              <option value="Abu Al Abyad">Abu Al Abyad</option>
                              <option value="Abu Dhabi">Abu Dhabi</option>
                              <option value="Abu Dhabi Airport">Abu Dhabi Airport</option>
                              <option value="Abu Dhabi Gate City">Abu Dhabi Gate City</option>
                              <option value="Al `Ayn">Al `Ayn</option>
                              <option value="Al `Idd">Al `Idd</option>
                              <option value="Al `Udayd">Al `Udayd</option>
                              <option value="Al Ain">Al Ain</option>
                              <option value="Al Aman">Al Aman</option>
                              <option value="Al Atir">Al Atir</option>
                              <option value="Al Badaa">Al Badaa</option>
                              <option value="Al Bahia">Al Bahia</option>
                              <option value="Al Baladiyah">Al Baladiyah</option>
                              <option value="Al Baraha">Al Baraha</option>
                              <option value="Al Bateen">Al Bateen</option>
                              <option value="Al Dhafrah">Al Dhafrah</option>
                              <option value="Al Falah City">Al Falah City</option>
                              <option value="Al Ghadeer">Al Ghadeer</option>
                              <option value="Al Hadhi">Al Hadhi</option>
                              <option value="Al Hayer">Al Hayer</option>
                              <option value="Al Hisn">Al Hisn</option>
                              <option value="Al Hosn">Al Hosn</option>
                              <option value="Al Hudayriat Island">Al Hudayriat Island</option>
                              <option value="Al Ittihad">Al Ittihad</option>
                              <option value="Al Jahr">Al Jahr</option>
                              <option value="Al Jami` al Kabir">Al Jami` al Kabir</option>
                              <option value="Al Karamah ">Al Karamah</option>
                              <option value="Al Khabb">Al Khabb</option>
                              <option value="Al Khaleej Al Arabi">Al Khaleej Al Arabi</option>
                              <option value="Al Khalidiya">Al Khalidiya</option>
                              <option value="Al Khalidiyah">Al Khalidiyah</option>
                              <option value="Al Khatim">Al Khatim</option>
                              <option value="Al Khazna">Al Khazna</option>
                              <option value="Al Khaznah">Al Khaznah</option>
                              <option value="Al Khis">Al Khis</option>
                              <option value="Al Khubayrah">Al Khubayrah</option>
                              <option value="Al Khubeirah">Al Khubeirah</option>
                              <option value="Al Mafraq">Al Mafraq</option>
                              <option value="Al Manaseer">Al Manaseer</option>
                              <option value="Al Manhal">Al Manhal</option>
                              <option value="Al Maqta">Al Maqta</option>
                              <option value="Al Marfa">Al Marfa</option>
                              <option value="Al Mariah United Group">Al Mariah United Group</option>
                              <option value="Al Mariyah">Al Mariyah</option>
                              <option value="Al Mariyah al Gharbiyah">Al Mariyah al Gharbiyah</option>
                              <option value="Al Markaziyah">Al Markaziyah</option>
                              <option value="Al Mashrub">Al Mashrub</option>
                              <option value="Al Mina">Al Mina</option>
                              <option value="Al Mirfa">Al Mirfa</option>
                              <option value="Al Mu`tarad">Al Mu`tarad</option>
                              <option value="Al Mughayra">Al Mughayra</option>
                              <option value="Al Muqattarah">Al Muqattarah</option>
                              <option value="Al Muroor">Al Muroor</option>
                              <option value="Al Murur">Al Murur</option>
                              <option value="Al Musalla">Al Musalla</option>
                              <option value="Al Mushrif">Al Mushrif</option>
                              <option value="Al Muwayqi`i">Al Muwayqi`i</option>
                              <option value="Al Muzun">Al Muzun</option>
                              <option value="Al Nahda Abu Dhabi">Al Nahda Abu Dhabi</option>
                              <option value="Al Nahyan">Al Nahyan</option>
                              <option value="Al Najda">Al Najda</option>
                              <option value="Al Qaia">Al Qaia</option>
                              <option value="Al Qimi">Al Qimi</option>
                              <option value="Al Qurm">Al Qurm</option>
                              <option value="Al Raha Beach">Al Raha Beach</option>
                              <option value="Al Raha Corniche">Al Raha Corniche</option>
                              <option value="Al Raha Gardens">Al Raha Gardens</option>
                              <option value="Al Raha Golf Gardens">Al Raha Golf Gardens</option>
                              <option value="Al Rahba">Al Rahba</option>
                              <option value="Al Ras Al Akhdar">Al Ras Al Akhdar</option>
                              <option value="Al Rawdah">Al Rawdah</option>
                              <option value="Al Reef">Al Reef</option>
                              <option value="Al Reem Island">Al Reem Island</option>
                              <option value="Al Rowdah">Al Rowdah</option>
                              <option value="Al Ruwais">Al Ruwais</option>
                              <option value="Al Samha">Al Samha</option>
                              <option value="Al Shahama">Al Shahama</option>
                              <option value="Al Shamkha">Al Shamkha</option>
                              <option value="Al Sowwah">Al Sowwah</option>
                              <option value="Al Wahda">Al Wahda</option>
                              <option value="Al Wahdah">Al Wahdah</option>
                              <option value="Al Wathba">Al Wathba</option>
                              <option value="Al Wathbah">Al Wathbah</option>
                              <option value="Al Zaab">Al Zaab</option>
                              <option value="An Nadi as Siyahi">An Nadi as Siyahi</option>
                              <option value="An Nashshash">An Nashshash</option>
                              <option value="Aqbiyah">Aqbiyah</option>
                              <option value="Ar Ra's al Akhdar">Ar Ra's al Akhdar</option>
                              <option value="Ar Rawdah">Ar Rawdah</option>
                              <option value="Ar Rihan">Ar Rihan</option>
                              <option value="Ar Ruways">Ar Ruways</option>
                              <option value="Aradah">Aradah</option>
                              <option value="As Sad">As Sad</option>
                              <option value="As Slabeikh">As Slabeikh</option>
                              <option value="As Sulaymat">As Sulaymat</option>
                              <option value="Ash Shahamah">Ash Shahamah</option>
                              <option value="Ash Shibhanah">Ash Shibhanah</option>
                              <option value="Attab">Attab</option>
                              <option value="Ayn al Faydah">Ayn al Faydah</option>
                              <option value="Az Za`ab">Az Za`ab</option>
                              <option value="Az Zafrah">Az Zafrah</option>
                              <option value="Az Zahra">Az Zahra</option>
                              <option value="Badiyah">Badiyah</option>
                              <option value="Baniyas">Baniyas</option>
                              <option value="Batin">Batin</option>
                              <option value="Bid' Zayed">Bid' Zayed</option>
                              <option value="Bid' Zayed, Manar Mall">Bid' Zayed, Manar Mall</option>
                              <option value="Bin Ahmad">Bin Ahmad</option>
                              <option value="Bu Hasa">Bu Hasa</option>
                              <option value="Bu Lifiyat">Bu Lifiyat</option>
                              <option value="Bu Rays">Bu Rays</option>
                              <option value="Capital District">Capital District</option>
                              <option value="Corniche">Corniche</option>
                              <option value="Da`sah">Da`sah</option>
                              <option value="Dahin">Dahin</option>
                              <option value="Danet">Danet</option>
                              <option value="Downtown">Downtown</option>
                              <option value="Fariq Tarif">Fariq Tarif</option>
                              <option value="Ghantoot">Ghantoot</option>
                              <option value="Ghurbah">Ghurbah</option>
                              <option value="Golf Gardens">Golf Gardens</option>
                              <option value="Grand Mosque District">Grand Mosque District</option>
                              <option value="Habshan">Habshan</option>
                              <option value="Hadbat az Za`faranah">Hadbat az Za`faranah</option>
                              <option value="Hafif">Hafif</option>
                              <option value="Hamarur">Hamarur</option>
                              <option value="Hameem">Hameem</option>
                              <option value="Hamim">Hamim</option>
                              <option value="Hilli">Hilli</option>
                              <option value="Humar">Humar</option>
                              <option value="Huwaylah">Huwaylah</option>
                              <option value="Huwaytayn">Huwaytayn</option>
                              <option value="Hydra Village">Hydra Village</option>
                              <option value="Istayhah">Istayhah</option>
                              <option value="Jarbub">Jarbub</option>
                              <option value="Jayf">Jayf</option>
                              <option value="Jebel Dhanna">Jebel Dhanna</option>
                              <option value="Jurayrah">Jurayrah</option>
                              <option value="Kayyah">Kayyah</option>
                              <option value="Khalifa City B">Khalifa City B</option>
                              <option value="Khalifa Street">Khalifa Street</option>
                              <option value="Khannur">Khannur</option>
                              <option value="Liwa">Liwa</option>
                              <option value="Lulu Island">Lulu Island</option>
                              <option value="Madinat ad Dubbat">Madinat ad Dubbat</option>
                              <option value="Madinat an Nahdah">Madinat an Nahdah</option>
                              <option value="Madinat Khalifah A">Madinat Khalifah A</option>
                              <option value="Madinat Khalifah B">Madinat Khalifah B</option>
                              <option value="Madinat Zayed">Madinat Zayed</option>
                              <option value="Madinat Zayid">Madinat Zayid</option>
                              <option value="Madinat Zayid, Rak Sports Cultural Club">Madinat Zayid, Rak Sports Cultural Club</option>
                              <option value="Madinat Zayid, Vegetable and Fruits Market">Madinat Zayid, Vegetable and Fruits Market</option>
                              <option value="Mahdar Bin `Usayyan">Mahdar Bin `Usayyan</option>
                              <option value="Majra al Ghaf">Majra al Ghaf</option>
                              <option value="Marawwah">Marawwah</option>
                              <option value="Marina Village">Marina Village</option>
                              <option value="Mas`udi">Mas`udi</option>
                              <option value="Masdar City ">Masdar City </option>
                              <option value="Mawsil">Mawsil</option>
                              <option value="Mazyad">Mazyad</option>
                              <option value="Milqatah">Milqatah</option>
                              <option value="Mintaqah Bayn al Jisrayn">Mintaqah Bayn al Jisrayn</option>
                              <option value="Mintaqat al Matar">Mintaqat al Matar</option>
                              <option value="Mohamed Bin Zayed City">Mohamed Bin Zayed City</option>
                              <option value="Mujib">Mujib</option>
                              <option value="Mundafinah">Mundafinah</option>
                              <option value="Muroor Area">Muroor Area</option>
                              <option value="Mussafah">Mussafah</option>
                              <option value="Muzayri">Muzayri</option>
                              <option value="Nafir">Nafir</option>
                              <option value="Nahel">Nahel</option>
                              <option value="Naqrah">Naqrah</option>
                              <option value="NPCC, Mussafa, Abu DHabi">NPCC, Mussafa, Abu DHabi</option>
                              <option value="Nuqayrah">Nuqayrah</option>
                              <option value="Nurai Island">Nurai Island</option>
                              <option value="Police Officers City">Police Officers City</option>
                              <option value="Qaryat at Turath">Qaryat at Turath</option>
                              <option value="Qasr al Bahr">Qasr al Bahr</option>
                              <option value="Qasr ash Shati">Qasr ash Shati</option>
                              <option value="Qasr El Bahr">Qasr El Bahr</option>
                              <option value="Qasr El Shatie">Qasr El Shatie</option>
                              <option value="Qatar">Qatar</option>
                              <option value="Qattarah">Qattarah</option>
                              <option value="Qu`aysah">Qu`aysah</option>
                              <option value="Qurmidah">Qurmidah</option>
                              <option value="Qutuf">Qutuf</option>
                              <option value="Radaim">Radaim</option>
                              <option value="Ras Khumais">Ras Khumais</option>
                              <option value="Rowdat Al Reef Palace">Rowdat Al Reef Palace</option>
                              <option value="Saadiyat Island">Saadiyat Island</option>
                              <option value="Sabkhah">Sabkhah</option>
                              <option value="Sas Al Nakheel">Sas Al Nakheel</option>
                              <option value="Sas an Nakhl">Sas an Nakhl</option>
                              <option value="Shah">Shah</option>
                              <option value="Shamis">Shamis</option>
                              <option value="Shati' ar Rahah">Shati' ar Rahah</option>
                              <option value="Sikkat al Khayl">Sikkat al Khayl</option>
                              <option value="Suwayhan">Suwayhan</option>
                              <option value="Sweihan">Sweihan</option>
                              <option value="Taraq">Taraq</option>
                              <option value="Tarif">Tarif</option>
                              <option value="Tharwaniyah">Tharwaniyah</option>
                              <option value="Tourist Club Area">Tourist Club Area</option>
                              <option value="Umm al Qurayn">Umm al Qurayn</option>
                              <option value="Wadhil">Wadhil</option>
                              <option value="Wafd">Wafd</option>
                              <option value="Yafur">Yafur</option>
                              <option value="Yas Island">Yas Island</option>
                              <option value="Yas Marina F1 Circuit">Yas Marina F1 Circuit</option>
                              <option value="Zafir">Zafir</option>
                              <option value="Zayed Military City">Zayed Military City</option>
                              <option value="Zuwayhir">Zuwayhir</option>

                              <option value="Abu Dhabi Cricket Stadium">Abu Dhabi Cricket Stadium</option>
                              <option value="Abu Dhabi Golf Club">Abu Dhabi Golf Club</option>
                              <option value="Khalifa A">Khalifa A</option>

                              <option value="Mazyad Mall">Mazyad Mall</option>
                              <option value="Mohammed Bin Zayed City">Mohammed Bin Zayed City</option>

                          </ng-container>
                          <ng-container *ngIf="validationfreelancer.get('city').value === 'AJM'">
                              <option value="Ain Ajman">Ain Ajman</option>
                              <option value="Ajman">Ajman</option>
                              <option value="Ajman, Al Bustan">Ajman, Al Bustan</option>
                              <option value="Ajman, Al Butain">Ajman, Al Butain</option>
                              <option value="Ajman, Al Nakhil">Ajman, Al Nakhil</option>
                              <option value="Ajman, Al Owan">Ajman, Al Owan</option>
                              <option value="Ajman, Al Rashidiya">Ajman, Al Rashidiya</option>
                              <option value="Ajman, Al Rifaah">Ajman, Al Rifaah</option>
                              <option value="Ajman, Al Rumailah">Ajman, Al Rumailah</option>
                              <option value="Ajman, Corniche Area">Ajman, Corniche Area</option>
                              <option value="Ajman, Old Industrial Area">Ajman, Old Industrial Area</option>
                              <option value="Ajman, Port Area">Ajman, Port Area</option>
                              <option value="Al Ameera Village">Al Ameera Village</option>
                              <option value="Al Bustan">Al Bustan</option>
                              <option value="Al Butain">Al Butain</option>
                              <option value="Al Hamidiyah">Al Hamidiyah</option>
                              <option value="Al Helio">Al Helio</option>
                              <option value="Al Humaid City">Al Humaid City</option>
                              <option value="Al Ittihad Village">Al Ittihad Village</option>
                              <option value="Al Naimiya">Al Naimiya</option>
                              <option value="Al Nakhil">Al Nakhil</option>
                              <option value="Al Owan">Al Owan</option>
                              <option value="Al Rumailah">Al Rumailah</option>
                              <option value="Al Tala Camel Race Track of Ajman">Al Tala Camel Race Track of Ajman</option>
                              <option value="Al Zahraa">Al Zahraa</option>
                              <option value="Awali City">Awali City</option>
                              <option value="Bustan">Bustan</option>
                              <option value="Corniche">Corniche</option>
                              <option value="Downtown">Downtown</option>
                              <option value="Emirates City">Emirates City</option>
                              <option value="Green City">Green City</option>
                              <option value="Hamideeyah">Hamideeyah</option>
                              <option value="Hasat al Bidiyah">Hasat al Bidiyah</option>
                              <option value="Helio">Helio</option>
                              <option value="Industrial Area">Industrial Area</option>
                              <option value="Jurf">Jurf</option>
                              <option value="Manama">Manama</option>
                              <option value="Marina">Marina</option>
                              <option value="Marmooka City">Marmooka City</option>
                              <option value="Meadows">Meadows</option>
                              <option value="Muehat">Muehat</option>
                              <option value="Musheirif">Musheirif</option>
                              <option value="Musheirif Commercial">Musheirif Commercial</option>
                              <option value="Muwayhat">Muwayhat</option>
                              <option value="Nakheel">Nakheel</option>
                              <option value="Naymiyah">Naymiyah</option>
                              <option value="New industrial area">New industrial area</option>
                              <option value="Park View City">Park View City</option>
                              <option value="Private Airfield">Private Airfield</option>
                              <option value="Rashidiya">Rashidiya</option>
                              <option value="Rumaylah">Rumaylah</option>
                              <option value="Sawan">Sawan</option>
                              <option value="Tala">Tala</option>
                              <option value="Uptown">Uptown</option>
                              <option value="Zahra">Zahra</option>
                              <option value="Zawra">Zawra</option>

                              <option value="Manama">Manama</option>
                              <option value="Manama, Al Aswaq Hayper Market">Manama, Al Aswaq Hayper Market</option>
                              <option value="Goal">Goal</option>
                              <option value="Masfut">Masfut</option>
                              <option value="Mazeira">Mazeira</option>

                          </ng-container>
                          <ng-container *ngIf="validationfreelancer.get('city').value === 'SHJ'">
                              <option value="Dayd">Dayd</option>
                              <option value="Dayd, Al Bustan">Dayd, Al Bustan</option>
                              <option value="Dayd, Al Hasan">Dayd, Al Hasan</option>
                              <option value="Dayd, Al Sharaya">Dayd, Al Sharaya</option>
                              <option value="Dayd, Al Suwaiah">Dayd, Al Suwaiah</option>
                              <option value="Dayd, Al Tayebah">Dayd, Al Tayebah</option>
                              <option value="Dayd, Lubsah Camel Race Track">Dayd, Lubsah Camel Race Track</option>
                              
                              <option value="Kalba">Kalba</option>
                              <option value="Kalba, Al Aoud">Kalba, Al Aoud</option>
                              <option value="Kalba, Al Baraha">Kalba, Al Baraha</option>
                              <option value="Kalba, Al Bateen">Kalba, Al Bateen</option>
                              <option value="Kalba, Al Bridi">Kalba, Al Bridi</option>
                              <option value="Kalba, Al Mafraq">Kalba, Al Mafraq</option>
                              <option value="Kalba, Al Nighala">Kalba, Al Nighala</option>
                              <option value="Kalba, Al Qadsia">Kalba, Al Qadsia</option>
                              <option value="Kalba, Al Qual'aa">Kalba, Al Qual'aa</option>
                              <option value="Kalba, Al Sidrah">Kalba, Al Sidrah</option>
                              <option value="Kalba, Industrial Area">Kalba, Industrial Area</option>
                              <option value="Khawr Kalba">Khawr Kalba</option>
                              <option value="Wadi Hilo">Wadi Hilo</option>

                              <option value="Al Lou'aluo'ayyah">Al Lou'aluo'ayyah</option>
                              <option value="Al Lou'aluo'ayyah, Stadium Sports Club Pterygium">Al Lou'aluo'ayyah, Stadium Sports Club Pterygium</option>
                              <option value="Khawr Fakkan">Khawr Fakkan</option>
                              <option value="Khawr Fakkan, Al Bridi">Khawr Fakkan, Al Bridi</option>
                              <option value="Khawr Fakkan, Al Khaledya">Khawr Fakkan, Al Khaledya</option>
                              <option value="Khawr Fakkan, Al Rifa'a">Khawr Fakkan, Al Rifa'a</option>
                              <option value="Khawr Fakkan, Al Sharq">Khawr Fakkan, Al Sharq</option>
                              <option value="Khawr Fakkan, Al Suwan Camel Track">Khawr Fakkan, Al Suwan Camel Track</option>
                              <option value="Khawr Fakkan, Al Yarmook">Khawr Fakkan, Al Yarmook</option>
                              <option value="Khawr Fakkan, Fort Hatta">Khawr Fakkan, Fort Hatta</option>
                              <option value="Khawr Fakkan, Hawaya">Khawr Fakkan, Hawaya</option>
                              <option value="Khawr Fakkan, Hutain">Khawr Fakkan, Hutain</option>
                              <option value="Khawr Fakkan, Vegetable and Fruits Market">Khawr Fakkan, Vegetable and Fruits Market</option>
                              <option value="Zubarah">Zubarah</option>


                              <option value="Abu Sangara">Abu Sangara</option>
                              <option value="Adh Dhayd">Adh Dhayd</option>
                              <option value="Al Aber">Al Aber</option>
                              <option value="Al Ardiyah">Al Ardiyah</option>
                              <option value="Al Azrra">Al Azrra</option>
                              <option value="Al Brashi">Al Brashi</option>
                              <option value="Al Butina">Al Butina</option>
                              <option value="Al Darrare">Al Darrare</option>
                              <option value="Al Dhaid">Al Dhaid</option>
                              <option value="Al Fallaj">Al Fallaj</option>
                              <option value="Al Fayha">Al Fayha</option>
                              <option value="AL Ghafiya">AL Ghafiya</option>
                              <option value="Al Ghuhaiba">Al Ghuhaiba</option>
                              <option value="Al Ghuwair">Al Ghuwair</option>
                              <option value="Al Goaz">Al Goaz</option>
                              <option value="Al Hamriyah">Al Hamriyah</option>
                              <option value="Al Hawayah">Al Hawayah</option>
                              <option value="Al Hayrah">Al Hayrah</option>
                              <option value="Al Hazana">Al Hazana</option>
                              <option value="Al Heera Suburb">Al Heera Suburb</option>
                              <option value="Al Hutain">Al Hutain</option>
                              <option value="Al Jazzat">Al Jazzat</option>
                              <option value="Al Khabba">Al Khabba</option>
                              <option value="Al Khaildia Suburb">Al Khaildia Suburb</option>
                              <option value="Al Khaldeia">Al Khaldeia</option>
                              <option value="Al Khan">Al Khan</option>
                              <option value="Al Khouzamiya">Al Khouzamiya</option>
                              <option value="Al Madam">Al Madam</option>
                              <option value="Al Mahatah">Al Mahatah</option>
                              <option value="Al Majaz">Al Majaz</option>
                              <option value="Al Malaiha">Al Malaiha</option>
                              <option value="Al Mamzar">Al Mamzar</option>
                              <option value="Al Mamzer">Al Mamzer</option>
                              <option value="Al Manakh">Al Manakh</option>
                              <option value="Al Marijah">Al Marijah</option>
                              <option value="Al Mirgab">Al Mirgab</option>
                              <option value="Al Mudaifi">Al Mudaifi</option>
                              <option value="Al Mussalla">Al Mussalla</option>
                              <option value="Al Nabba">Al Nabba</option>
                              <option value="Al Nahda 1">Al Nahda 1</option>
                              <option value="Al Nahda 2">Al Nahda 2</option>
                              <option value="Al Naimiya">Al Naimiya</option>
                              <option value="Al Nasserya">Al Nasserya</option>
                              <option value="Al nekhailat">Al nekhailat</option>
                              <option value="Al Nud">Al Nud</option>
                              <option value="Al Nujoom Islands">Al Nujoom Islands</option>
                              <option value="Al Qadsia">Al Qadsia</option>
                              <option value="Al Qasba">Al Qasba</option>
                              <option value="Al Qasemiya">Al Qasemiya</option>
                              <option value="Al Qusais Industrial Area 1">Al Qusais Industrial Area 1</option>
                              <option value="Al Qusais Industrial Area 3">Al Qusais Industrial Area 3</option>
                              <option value="Al Rafee'a 1">Al Rafee'a 1</option>
                              <option value="Al Ramaqia">Al Ramaqia</option>
                              <option value="Al Ramla">Al Ramla</option>
                              <option value="Al Ramla East">Al Ramla East</option>
                              <option value="AL Ramla West">AL Ramla West</option>
                              <option value="Al Ramtha">Al Ramtha</option>
                              <option value="Al Rifa">Al Rifa</option>
                              <option value="Al Rifah">Al Rifah</option>
                              <option value="Al Riqa Suburb">Al Riqa Suburb</option>
                              <option value="Al Sajaa">Al Sajaa</option>
                              <option value="Al Shahab">Al Shahab</option>
                              <option value="Al Sharq">Al Sharq</option>
                              <option value="Al Shuwaiheen">Al Shuwaiheen</option>
                              <option value="Al Subaikhi">Al Subaikhi</option>
                              <option value="Al Swehat">Al Swehat</option>
                              <option value="Al Talae">Al Talae</option>
                              <option value="Al Wahda">Al Wahda</option>
                              <option value="Al Yarmook">Al Yarmook</option>
                              <option value="an-Nahwa">an-Nahwa</option>
                              <option value="Ar Rufaysah">Ar Rufaysah</option>
                              <option value="Ash Shu`ayb">Ash Shu`ayb</option>
                              <option value="Atain">Atain</option>
                              <option value="Bu Danig">Bu Danig</option>
                              <option value="Bu Tina">Bu Tina</option>
                              <option value="Corniche Al Buhaira">Corniche Al Buhaira</option>
                              <option value="Eliash">Eliash</option>
                              <option value="Etisalat">Etisalat</option>
                              <option value="Ghunah">Ghunah</option>
                              <option value="Hajar">Hajar</option>
                              <option value="Hamriya">Hamriya</option>
                              <option value="Hamriyah Free Zone">Hamriyah Free Zone</option>
                              <option value="HANGAR AEROPRAKT A22 No220">HANGAR AEROPRAKT A22 No220</option>
                              <option value="Hiyawah">Hiyawah</option>
                              <option value="Hizayib az Zanah">Hizayib az Zanah</option>
                              <option value="Huwayyah">Huwayyah</option>
                              <option value="Industrial Area 13">Industrial Area 13</option>
                              <option value="Industrial Area 18">Industrial Area 18</option>
                              <option value="Khor Fakkan">Khor Fakkan</option>
                              <option value="Layyah">Layyah</option>
                              <option value="Lulayyah">Lulayyah</option>
                              <option value="Madha">Madha</option>
                              <option value="Maysaloon">Maysaloon</option>
                              <option value="Muelih">Muelih</option>
                              <option value="Muwafjah">Muwafjah</option>
                              <option value="Nahwa">Nahwa</option>
                              <option value="Nazwa">Nazwa</option>
                              <option value="Nedaifi">Nedaifi</option>
                              <option value="New Shwaib">New Shwaib</option>
                              <option value="Private airfield">Private airfield</option>
                              <option value="Rafa">Rafa</option>
                              <option value="Rolla Area">Rolla Area</option>
                              <option value="Rollah Square">Rollah Square</option>
                              <option value="Sa`d">Sa`d</option>
                              <option value="Sahanah">Sahanah</option>
                              <option value="Sajaa Industrial Area">Sajaa Industrial Area</option>
                              <option value="Samnan">Samnan</option>
                              <option value="Saruj">Saruj</option>
                              <option value="Shargan">Shargan</option>
                              <option value="Sharjah">Sharjah</option>
                              <option value="Sharjah Airport Free Zone (SAIF)">Sharjah Airport Free Zone (SAIF)</option>
                              <option value="Sharjah Industrial Area 1">Sharjah Industrial Area 1</option>
                              <option value="Sharjah Industrial Area 10">Sharjah Industrial Area 10Sharjah Industrial Area 10</option>
                              <option value="Sharjah Industrial Area 12">Sharjah Industrial Area 12</option>
                              <option value="Sharjah Industrial Area 2">Sharjah Industrial Area 2</option>
                              <option value="Sharjah Industrial Area 3">Sharjah Industrial Area 3</option>
                              <option value="Sharjah Industrial Area 4">Sharjah Industrial Area 4</option>
                              <option value="Sharjah Industrial Area 5">Sharjah Industrial Area 5</option>
                              <option value="Sharjah Industrial Area 6">Sharjah Industrial Area 6</option>
                              <option value="Sharjah Industrial Area 7">Sharjah Industrial Area 7</option>
                              <option value="Sharjah Industrial Area 8">Sharjah Industrial Area 8</option>
                              <option value="Sharjah Industrial Area 9">Sharjah Industrial Area 9</option>
                              <option value="Shis">Shis</option>
                              <option value="Shwaib">Shwaib</option>
                              <option value="Tawi Bil Khabis">Tawi Bil Khabis</option>
                              <option value="Tawi Rashidia">Tawi Rashidia</option>
                              <option value="Tawi Zubair Hamriyah">Tawi Zubair Hamriyah</option>
                              <option value="Turrfana">Turrfana</option>
                              <option value="Um Tarrafa">Um Tarrafa</option>
                              <option value="Umm Khanoor">Umm Khanoor</option>
                              <option value="Wadi Shi">Wadi Shi</option>
                              <option value="Wasit Suburb">Wasit Suburb</option>
                          

                          </ng-container>
                          <ng-container *ngIf="validationfreelancer.get('city').value === 'DXB'">
                              <option value="Ayal Nasir">Ayal Nasir</option>
                              <option value="Ud al Bayda">Ud al Bayda</option>
                              <option value="Urqub Juwayza">Urqub Juwayza</option>
                              <option value="Abu Hail">Abu Hail</option>
                              <option value="Abu Hayl">Abu Hayl</option>
                              <option value="Academic City">Academic City</option>
                              <option value="Ad Daghayah">Ad Daghayah</option>
                              <option value="Airport Free Zone">Airport Free Zone</option>
                              <option value="Al `Usbij">Al `Usbij</option>
                              <option value="Al Aweer">Al Aweer</option>
                              <option value="Al Awir">Al Awir</option>
                              <option value="Al Bada">Al Bada</option>
                              <option value="Al Bada'a">Al Bada'a</option>
                              <option value="Al Baharnah">Al Baharnah</option>
                              <option value="Al Balush">Al Balush</option>
                              <option value="Al Baraha">Al Baraha</option>
                              <option value="Al Barahah">Al Barahah</option>
                              <option value="Al Barari">Al Barari</option>
                              <option value="Al Barsha 1">Al Barsha 1</option>
                              <option value="Al Barsha 2">Al Barsha 2</option>
                              <option value="Al Barsha 3">Al Barsha 3</option>
                              <option value="Al Barsha First">Al Barsha First</option>
                              <option value="Al Barshaa Second">Al Barshaa Second</option>
                              <option value="Al Barshaa Third">Al Barshaa Third</option>
                              <option value="Al Faq">Al Faq</option>
                              <option value="Al Furjan">Al Furjan</option>
                              <option value="Al Garhoud">Al Garhoud</option>
                              <option value="Al Goze Industrial District">Al Goze Industrial District</option>
                              <option value="Al Hajarayn">Al Hajarayn</option>
                              <option value="Al Hamriyah">Al Hamriyah</option>
                              <option value="Al Hudaba">Al Hudaba</option>
                              <option value="Al Hudaiba">Al Hudaiba</option>
                              <option value="Al Hudaybah">Al Hudaybah</option>
                              <option value="Al Jaddaf">Al Jaddaf</option>
                              <option value="Al Jafiliya">Al Jafiliya</option>
                              <option value="Al Jafliya">Al Jafliya</option>
                              <option value="Al Karama">Al Karama</option>
                              <option value="Al Khabasi">Al Khabasi</option>
                              <option value="Al Khabeesi">Al Khabeesi</option>
                              <option value="Al Khawanij">Al Khawanij</option>
                              <option value="Al Kifaf">Al Kifaf</option>
                              <option value="Al Lusayli">Al Lusayli</option>
                              <option value="Al Mahra">Al Mahra</option>
                              <option value="Al Manara">Al Manara</option>
                              <option value="Al Mankhool">Al Mankhool</option>
                              <option value="Al Marqadh">Al Marqadh</option>
                              <option value="Al Matinah">Al Matinah</option>
                              <option value="Al Mina">Al Mina</option>
                              <option value="Al Mizhar">Al Mizhar</option>
                              <option value="Al Mizhar 1">Al Mizhar 1</option>
                              <option value="Al Mizhar 2">Al Mizhar 2</option>
                              <option value="Al Muhaisnah">Al Muhaisnah</option>
                              <option value="Al Muraqqabat">Al Muraqqabat</option>
                              <option value="Al Murar">Al Murar</option>
                              <option value="Al Murar al Jadid">Al Murar al Jadid</option>
                              <option value="Al Murar al Qadim">Al Murar al Qadim</option>
                              <option value="Al Musalla">Al Musalla</option>
                              <option value="Al Nahda">Al Nahda</option>
                              <option value="Al Qawz">Al Qawz</option>
                              <option value="Al Quoz">Al Quoz</option>
                              <option value="Al Quoz Industrial Area 1">Al Quoz Industrial Area 1</option>
                              <option value="Al Quoz Industrial Area 2">Al Quoz Industrial Area 2</option>
                              <option value="Al Quoz Industrial Area 3">Al Quoz Industrial Area 3</option>
                              <option value="Al Quoz Industrial Area 4">Al Quoz Industrial Area 4</option>
                              <option value="Al Qusais 1">Al Qusais 1</option>
                              <option value="Al Qusais 2">Al Qusais 2</option>
                              <option value="Al Qusais 3">Al Qusais 3</option>
                              <option value="Al Qusais First">Al Qusais First</option>
                              <option value="Al Qusais Industrial Area Second">Al Qusais Industrial Area Second</option>
                              <option value="Al Qusais Second">Al Qusais Second</option>
                              <option value="Al Qusais Third">Al Qusais Third</option>
                              <option value="Al Qusays">Al Qusays</option>
                              <option value="Al Raffa">Al Raffa</option>
                              <option value="Al Rashidiya">Al Rashidiya</option>
                              <option value="Al Reem 1">Al Reem 1</option>
                              <option value="Al Reem 2">Al Reem 2</option>
                              <option value="Al Reem 3">Al Reem 3</option>
                              <option value="Al Rigga">Al Rigga</option>
                              <option value="Al Safa 1">Al Safa 1</option>
                              <option value="Al Safa 2">Al Safa 2</option>
                              <option value="Al Saffa First">Al Saffa First</option>
                              <option value="Al Saffa Second">Al Saffa Second</option>
                              <option value="Al Safouh First">Al Safouh First</option>
                              <option value="Al Satwa">Al Satwa</option>
                              <option value="Al Shindagah">Al Shindagah</option>
                              <option value="Al Sufouh 2">Al Sufouh 2</option>
                              <option value="Al Twar 1">Al Twar 1</option>
                              <option value="Al Twar 2">Al Twar 2</option>
                              <option value="Al Twar 3">Al Twar 3</option>
                              <option value="Al Twar First">Al Twar First</option>
                              <option value="AL Twar Second">AL Twar Second</option>
                              <option value="Al Waha Villas 1">Al Waha Villas 1</option>
                              <option value="Al Waha Villas 2">Al Waha Villas 2</option>
                              <option value="Al Waheda">Al Waheda</option>
                              <option value="Al Warq'a 5">Al Warq'a 5</option>
                              <option value="Al Warqa'a">Al Warqa'a</option>
                              <option value="Al Wasl">Al Wasl</option>
                              <option value="Al Wuheida">Al Wuheida</option>
                              <option value="Alma">Alma</option>
                              <option value="Alvorada">Alvorada</option>
                              <option value="An Nakhl">An Nakhl</option>
                              <option value="Ar Ra's">Ar Ra's</option>
                              <option value="Ar Rashidiyah">Ar Rashidiyah</option>
                              <option value="Ar Rifa`ah">Ar Rifa`ah</option>
                              <option value="Ar Riqqah">Ar Riqqah</option>
                              <option value="Ar Riqqah Gharb">Ar Riqqah Gharb</option>
                              <option value="Ar Riqqah Sharq">Ar Riqqah Sharq</option>
                              <option value="Arabian Ranches">Arabian Ranches</option>
                              <option value="Armada towers">Armada towers</option>
                              <option value="As Sabkhah">As Sabkhah</option>
                              <option value="As Safa">As Safa</option>
                              <option value="As Satwah">As Satwah</option>
                              <option value="Ash Shamal">Ash Shamal</option>
                              <option value="Ash Shindaghah">Ash Shindaghah</option>
                              <option value="At Tawar">At Tawar</option>
                              <option value="Bawadi">Bawadi</option>
                              <option value="Bu Kadra">Bu Kadra</option>
                              <option value="Bur Dubai">Bur Dubai</option>
                              <option value="Bur Sa`id">Bur Sa`id</option>
                              <option value="Burj Nahar">Burj Nahar</option>
                              <option value="Business Bay">Business Bay</option>
                              <option value="Carmen Village">Carmen Village</option>
                              <option value="City of Arabia">City of Arabia</option>
                              <option value="Corniche Deira">Corniche Deira</option>
                              <option value="Culture Village">Culture Village</option>
                              <option value="Dawwar Burj Nahar">Dawwar Burj Nahar</option>
                              <option value="Dayrah">Dayrah</option>
                              <option value="Deira">Deira</option>
                              <option value="Discovery Gardens">Discovery Gardens</option>
                              <option value="Downtown Burj Khalifa">Downtown Burj Khalifa</option>
                              <option value="Dubai Aid City">Dubai Aid City</option>
                              <option value="Dubai Airport Freezone Area">Dubai Airport Freezone Area</option>
                              <option value="Dubai Autodrome">Dubai Autodrome</option>
                              <option value="Dubai Festival City">Dubai Festival City</option>
                              <option value="Dubai Healthcare City">Dubai Healthcare City</option>
                              <option value="Dubai Industrial City">Dubai Industrial City</option>
                              <option value="Dubai International Financial Centre">Dubai International Financial Centre</option>
                              <option value="Dubai International Media Production Zone (IMPZ)">Dubai International Media Production Zone (IMPZ)</option>
                              <option value="Dubai Internet City">Dubai Internet City</option>
                              <option value="Dubai Investment Park">Dubai Investment Park</option>
                              <option value="Dubai Land">Dubai Land</option>
                              <option value="Dubai Life Style City">Dubai Life Style City</option>
                              <option value="Dubai Marina">Dubai Marina</option>
                              <option value="Dubai Media City">Dubai Media City</option>
                              <option value="Dubai Pearl">Dubai Pearl</option>
                              <option value="Dubai Promenade">Dubai Promenade</option>
                              <option value="Dubai Silicon Oasis">Dubai Silicon Oasis</option>
                              <option value="Dubai Studio City">Dubai Studio City</option>
                              <option value="Dubai Studio City 1">Dubai Studio City 1</option>
                              <option value="Dubai Waterfront">Dubai Waterfront</option>
                              <option value="Dubai World Central">Dubai World Central</option>
                              <option value="DuBiotech">DuBiotech</option>
                              <option value="Emirates Hill First">Emirates Hill First</option>
                              <option value="Emirates Hill Second">Emirates Hill Second</option>
                              <option value="Emirates Hill Third">Emirates Hill Third</option>
                              <option value="Emirates Hills">Emirates Hills</option>
                              <option value="Estella Village">Estella Village</option>
                              <option value="Falcon City of Wonders">Falcon City of Wonders</option>
                              <option value="Ferij al Muhadham">Ferij al Muhadham</option>
                              <option value="Global Village">Global Village</option>
                              <option value="Green Community">Green Community</option>
                              <option value="Green Community Motor City">Green Community Motor City</option>
                              <option value="Green Community West">Green Community West</option>
                              <option value="Greens">Greens</option>
                              <option value="Hamriyah">Hamriyah</option>
                              <option value="Hatta">Hatta</option>
                              <option value="Hattan">Hattan</option>
                              <option value="Hawr al `Anz">Hawr al `Anz</option>
                              <option value="Hayl">Hayl</option>
                              <option value="Hayy al Bastakiyah">Hayy al Bastakiyah</option>
                              <option value="Healthcare City">Healthcare City</option>
                              <option value="Hor Al Anz">Hor Al Anz</option>
                              <option value="Hor Al Anz East">Hor Al Anz East</option>
                              <option value="Hunaywah">Hunaywah</option>
                              <option value="Industrial Area 15">Industrial Area 15</option>
                              <option value="Industrial Area 17">Industrial Area 17</option>
                              <option value="International City">International City</option>
                              <option value="International City (Phase 2)">International City (Phase 2)</option>
                              <option value="International Media Production Zone (IMPZ)">International Media Production Zone (IMPZ)</option>
                              <option value="Jaddaf">Jaddaf</option>
                              <option value="Jebel Ali Village">Jebel Ali Village</option>
                              <option value="Jumayra">Jumayra</option>
                              <option value="Jumeira Second">Jumeira Second</option>
                              <option value="Jumeira Third">Jumeira Third</option>
                              <option value="Jumeirah">Jumeirah</option>
                              <option value="Jumeirah 1">Jumeirah 1</option>
                              <option value="Jumeirah 2">Jumeirah 2</option>
                              <option value="Jumeirah Beach Residence (JBR)">Jumeirah Beach Residence (JBR)</option>
                              <option value="Jumeirah Golf Estates ">Jumeirah Golf Estates </option>
                              <option value="Jumeirah Heights">Jumeirah Heights</option>
                              <option value="Jumeirah Islands">Jumeirah Islands</option>
                              <option value="Jumeirah Lakes Towers">Jumeirah Lakes Towers</option>
                              <option value="Jumeirah Park">Jumeirah Park</option>
                              <option value="Jumeirah Village">Jumeirah Village</option>
                              <option value="Karama">Karama</option>
                              <option value="Knowledge Village ">Knowledge Village </option>
                              <option value="Kurnish">Kurnish</option>
                              <option value="La Colleccion">La Colleccion</option>
                              <option value="Lahbab">Lahbab</option>
                              <option value="Legends">Legends</option>
                              <option value="Liwan">Liwan</option>
                              <option value="M Z Faraidooni (MZF Al Kabhessi)">M Z Faraidooni (MZF Al Kabhessi)</option>
                              <option value="Ma`sharat al Baharnah">Ma`sharat al Baharnah</option>
                              <option value="Madinat Badr">Madinat Badr</option>
                              <option value="Majan">Majan</option>
                              <option value="Mankhul">Mankhul</option>
                              <option value="Margham">Margham</option>
                              <option value="Maritime City">Maritime City</option>
                              <option value="Masfut">Masfut</option>
                              <option value="Meydan">Meydan</option>
                              <option value="Meydan City">Meydan City</option>
                              <option value="Mintaqat as Suq">Mintaqat as Suq</option>
                              <option value="Mintaqat Dubayy at Ta`limiyah">Mintaqat Dubayy at Ta`limiyah</option>
                              <option value="Mirador">Mirador</option>
                              <option value="Mirdif">Mirdif</option>
                              <option value="Motor City">Motor City</option>
                              <option value="Mudon">Mudon</option>
                              <option value="Muhaisanah Fourth">Muhaisanah Fourth</option>
                              <option value="Muhaisanah Second">Muhaisanah Second</option>
                              <option value="Muhaisanah Third">Muhaisanah Third</option>
                              <option value="Muhaisnah 1">Muhaisnah 1</option>
                              <option value="Muhaisnah 2">Muhaisnah 2</option>
                              <option value="Muhaysnah">Muhaysnah</option>
                              <option value="Muhaysnah Shamal">Muhaysnah Shamal</option>
                              <option value="Murrquab">Murrquab</option>
                              <option value="Mushrif">Mushrif</option>
                              <option value="Mushrif Park">Mushrif Park</option>
                              <option value="Muteena">Muteena</option>
                              <option value="Nad Al Hammar">Nad Al Hammar</option>
                              <option value="Nad Al Sheba">Nad Al Sheba</option>
                              <option value="Nad Al Sheba 2">Nad Al Sheba 2</option>
                              <option value="Nadd al Humr">Nadd al Humr</option>
                              <option value="Nadd Al Sheba 3">Nadd Al Sheba 3</option>
                              <option value="Nadd Al Sheba 4">Nadd Al Sheba 4</option>
                              <option value="Nadd ash Shiba">Nadd ash Shiba</option>
                              <option value="Nayf">Nayf</option>
                              <option value="Oud Al Muteena">Oud Al Muteena</option>
                              <option value="Oud Metha">Oud Metha</option>
                              <option value="Palm Jebel Ali">Palm Jebel Ali</option>
                              <option value="Palm Jumeirah">Palm Jumeirah</option>
                              <option value="Palmera">Palmera</option>
                              <option value="Plantation Equestrian and Polo Club">Plantation Equestrian and Polo Club</option>
                              <option value="Port Saeed">Port Saeed</option>
                              <option value="Qaraytaysah">Qaraytaysah</option>
                              <option value="Qimah">Qimah</option>
                              <option value="Ras Al Khor">Ras Al Khor</option>
                              <option value="Ras Al Khor Industrial Area 1">Ras Al Khor Industrial Area 1</option>
                              <option value="Ras Al Khor Industrial Area 2">Ras Al Khor Industrial Area 2</option>
                              <option value="Ras Al Khor Industrial Area 3">Ras Al Khor Industrial Area 3</option>
                              <option value="Remraam">Remraam</option>
                              <option value="Riqqah al Butayn">Riqqah al Butayn</option>
                              <option value="Saheel">Saheel</option>
                              <option value="Satwa">Satwa</option>
                              <option value="Savannah">Savannah</option>
                              <option value="Sharjah Industrial Area 11">Sharjah Industrial Area 11</option>
                              <option value="Sikkat al Khayl">Sikkat al Khayl</option>
                              <option value="Sports City">Sports City</option>
                              <option value="Sufayri">Sufayri</option>
                              <option value="Tawi as Saygh">Tawi as Saygh</option>
                              <option value="Technology Park">Technology Park</option>
                              <option value="Tecom">Tecom</option>
                              <option value="Terra Nova">Terra Nova</option>
                              <option value="The Gardens">The Gardens</option>
                              <option value="The Lagoons">The Lagoons</option>
                              <option value="The Lakes">The Lakes</option>
                              <option value="The Meadows">The Meadows</option>
                              <option value="The Meadows 5">The Meadows 5</option>
                              <option value="The Springs">The Springs</option>
                              <option value="The Tiger Woods Dubai">The Tiger Woods Dubai</option>
                              <option value="The Views">The Views</option>
                              <option value="The Villa">The Villa</option>
                              <option value="The World Islands">The World Islands</option>
                              <option value="Tilal Dubai">Tilal Dubai</option>
                              <option value="Um Al Sheif">Um Al Sheif</option>
                              <option value="Um Suqaim Second">Um Suqaim Second</option>
                              <option value="Umm Al Sheif">Umm Al Sheif</option>
                              <option value="Umm Hurair 1">Umm Hurair 1</option>
                              <option value="Umm Hurair 2">Umm Hurair 2</option>
                              <option value="Umm Hurayr">Umm Hurayr</option>
                              <option value="Umm Ramool">Umm Ramool</option>
                              <option value="Umm Suqaym">Umm Suqaym</option>
                              <option value="Umm Suqueim 1">Umm Suqueim 1</option>
                              <option value="Umm Suqueim 2">Umm Suqueim 2</option>
                              <option value="Umm Suqueim 3">Umm Suqueim 3</option>
                              <option value="Up Town Motor City">Up Town Motor City</option>
                              <option value="Victory Heights">Victory Heights</option>
                              <option value="Warisan">Warisan</option>
                              <option value="Warsan">Warsan</option>
                              <option value="Warsan 1">Warsan 1</option>
                              <option value="Warsan 2">Warsan 2</option>
                              <option value="World Trade Center">World Trade Center</option>
                              <option value="Zabeel 1">Zabeel 1</option>
                              <option value="Zabeel First">Zabeel First</option>
                              <option value="Zaribat Dawiy">Zaribat Dawiy</option>

                              <option value="Hatta, Friday Market">Hatta, Friday Market</option>
                              <option value="Hatta, Hatta Stadium">Hatta, Hatta Stadium</option>
                              <option value="Hatta, Khansaheb Camel Track">Hatta, Khansaheb Camel Track</option>

                          </ng-container>
                          <ng-container *ngIf="validationfreelancer.get('city').value === 'UAQ'">
                            <option value="Falaj Al Mualla">Falaj Al Mualla</option>

                            <option value="Uwaynat">Uwaynat</option>
                            <option value="Al `Adhib">Al `Adhib</option>
                            <option value="Al Abraq">Al Abraq</option>
                            <option value="Al Azeeb">Al Azeeb</option>
                            <option value="Al Azeeb, Al Khaleej Markets">Al Azeeb, Al Khaleej Markets</option>
                            <option value="Al Biyatha">Al Biyatha</option>
                            <option value="Al Dar Al Baida - A">Al Dar Al Baida - A</option>
                            <option value="Al Dar Al Baida - B">Al Dar Al Baida - B</option>
                            <option value="Al Haditha">Al Haditha</option>
                            <option value="Al Hamrah - B">Al Hamrah - B</option>
                            <option value="Al Hamrah - D">Al Hamrah - D</option>
                            <option value="Al Hawiyah">Al Hawiyah</option>
                            <option value="Al Hazaywah">Al Hazaywah</option>
                            <option value="Al Humrah - A">Al Humrah - A</option>
                            <option value="Al Khor">Al Khor</option>
                            <option value="Al Labsah">Al Labsah</option>
                            <option value="Al Limghadar">Al Limghadar</option>
                            <option value="Al Madar">Al Madar</option>
                            <option value="Al Maidan">Al Maidan</option>
                            <option value="Al Quram">Al Quram</option>
                            <option value="Al Raafa">Al Raafa</option>
                            <option value="Al Ra'as - A">Al Ra'as - A</option>
                            <option value="Al Ra'as - B">Al Ra'as - B</option>
                            <option value="Al Ra'as - C">Al Ra'as - C</option>
                            <option value="Al Ra'as - D">Al Ra'as - D</option>
                            <option value="Al Rashidiya">Al Rashidiya</option>
                            <option value="Al Rashidiya, Hamra Golf Club">Al Rashidiya, Hamra Golf Club</option>
                            <option value="Al Rashidiya, Sharjah Co-Operative Society">Al Rashidiya, Sharjah Co-Operative Society</option>
                            <option value="Al Raudah">Al Raudah</option>
                            <option value="Al Riqqah">Al Riqqah</option>
                            <option value="Al Salam City">Al Salam City</option>
                            <option value="Al Surrah">Al Surrah</option>
                            <option value="Ar Ra`fah">Ar Ra`fah</option>
                            <option value="Ar Ramlah">Ar Ramlah</option>
                            <option value="Ar Rashidiyah">Ar Rashidiyah</option>
                            <option value="As Salamah">As Salamah</option>
                            <option value="As Surrah">As Surrah</option>
                            <option value="Barracuda">Barracuda</option>
                            <option value="Barracuda Beach Resort">Barracuda Beach Resort</option>
                            <option value="Biyatah">Biyatah</option>
                            <option value="Defence Camp">Defence Camp</option>
                            <option value="Diwwan Al Amiri">Diwwan Al Amiri</option>
                            <option value="Emirates Modern Industrial">Emirates Modern Industrial</option>
                            <option value="Emirates Motorplex - UAQ/RAK road">Emirates Motorplex - UAQ/RAK road</option>
                            <option value="Environmental Marine Research Center">Environmental Marine Research Center</option>
                            <option value="Falaj al Moalla">Falaj al Moalla</option>
                            <option value="Green Belt">Green Belt</option>
                            <option value="Hazaiwa">Hazaiwa</option>
                            <option value="Industrial Area A">Industrial Area A</option>
                            <option value="Industrial Area B">Industrial Area B</option>
                            <option value="Industrial Area C">Industrial Area C</option>
                            <option value="Kaber">Kaber</option>
                            <option value="Kabir">Kabir</option>
                            <option value="Khor Al Beidah">Khor Al Beidah</option>
                            <option value="Lazimah">Lazimah</option>
                            <option value="Lubsah">Lubsah</option>
                            <option value="Lubsah, Lulu Centre">Lubsah, Lulu Centre</option>
                            <option value="Mintaqah al Hadithah">Mintaqah al Hadithah</option>
                            <option value="Mintaqat ad Dar al Bayda' A">Mintaqat ad Dar al Bayda' A</option>
                            <option value="Mintaqat ad Dar al Bayda' B">Mintaqat ad Dar al Bayda' B</option>
                            <option value="Mintaqat al `Ahd">Mintaqat al `Ahd</option>
                            <option value="Mintaqat al Hawiyah">Mintaqat al Hawiyah</option>
                            <option value="Mintaqat al Humrah A">Mintaqat al Humrah A</option>
                            <option value="Mintaqat al Humrah B">Mintaqat al Humrah B</option>
                            <option value="Mintaqat al Humrah D">Mintaqat al Humrah D</option>
                            <option value="Mintaqat al Humrah J">Mintaqat al Humrah J</option>
                            <option value="Mintaqat al Khawr">Mintaqat al Khawr</option>
                            <option value="Mintaqat al Madinah al Qadimah">Mintaqat al Madinah al Qadimah</option>
                            <option value="Mintaqat al Maydan">Mintaqat al Maydan</option>
                            <option value="Mintaqat ar Ra's A">Mintaqat ar Ra's A</option>
                            <option value="Mintaqat ar Ra's B">Mintaqat ar Ra's B</option>
                            <option value="Mintaqat ar Ra's D">Mintaqat ar Ra's D</option>
                            <option value="Mintaqat ar Ra's J">Mintaqat ar Ra's J</option>
                            <option value="Mintaqat ar Rawdah">Mintaqat ar Rawdah</option>
                            <option value="Mintaqat ar Riqqah">Mintaqat ar Riqqah</option>
                            <option value="Mintaqat Limghadar">Mintaqat Limghadar</option>
                            <option value="Mintaqat Umm al Qaywayn at Tibbiyah">Mintaqat Umm al Qaywayn at Tibbiyah</option>
                            <option value="Mohadhub">Mohadhub</option>
                            <option value="Muhadhdhib">Muhadhdhib</option>
                            <option value="Old Town">Old Town</option>
                            <option value="The settlement of fishermen">The settlement of fishermen</option>
                            <option value="Umm Al Quwain">Umm Al Quwain</option>
                            <option value="Umm Al Quwain Aviation & Parachute Club">Umm Al Quwain Aviation & Parachute Club</option>
                            <option value="Umm Al Quwain Hunting & Shooting Club">Umm Al Quwain Hunting & Shooting Club</option>
                            <option value="Umm Al Quwain Marina">Umm Al Quwain Marina</option>
                            <option value="Umm Al Thaoub Industrial Area">Umm Al Thaoub Industrial Area</option>
                            <option value="White Bay">White Bay</option>
                          </ng-container>
                          <ng-container *ngIf="validationfreelancer.get('city').value === 'FUJ'">
                              <option value="Abadilah">Abadilah</option>
                              <option value="Akamiyah">Akamiyah</option>
                              <option value="Aqqah">Aqqah</option>
                              <option value="Asamah">Asamah</option>
                              <option value="Ashashah">Ashashah</option>
                              <option value="Uqayr">Uqayr</option>
                              <option value="Afarah">Afarah</option>
                              <option value="Al `Awdah">Al `Awdah</option>
                              <option value="Al `Ayn al Ghumur">Al `Ayn al Ghumur</option>
                              <option value="Al `Uyaynah">Al `Uyaynah</option>
                              <option value="Al Aqah">Al Aqah</option>
                              <option value="Al Fuqait">Al Fuqait</option>
                              <option value="Al Ghurfa">Al Ghurfa</option>
                              <option value="Al Ghurfah">Al Ghurfah</option>
                              <option value="Al Gissemari">Al Gissemari</option>
                              <option value="Al Halah">Al Halah</option>
                              <option value="Al Hayl">Al Hayl</option>
                              <option value="Al Hinya">Al Hinya</option>
                              <option value="Al Kubus">Al Kubus</option>
                              <option value="Al Manamah">Al Manamah</option>
                              <option value="Al Qurayyah">Al Qurayyah</option>
                              <option value="Ar Rul">Ar Rul</option>
                              <option value="Badiyah">Badiyah</option>
                              <option value="Bethna">Bethna</option>
                              <option value="Bitnah">Bitnah</option>
                              <option value="Blaydah">Blaydah</option>
                              <option value="Corniche">Corniche</option>
                              <option value="Dab`ah">Dab`ah</option>
                              <option value="Dadna">Dadna</option>
                              <option value="Daftah">Daftah</option>
                              <option value="Dahir">Dahir</option>
                              <option value="Diba">Diba</option>
                              <option value="Dibba">Dibba</option>
                              <option value="Dub">Dub</option>
                              <option value="Falakh">Falakh</option>
                              <option value="Faqi">Faqi</option>
                              <option value="Far`ah">Far`ah</option>
                              <option value="Friday Market">Friday Market</option>
                              <option value="Fujairah">Fujairah</option>
                              <option value="Ghamarah">Ghamarah</option>
                              <option value="Ghayl">Ghayl</option>
                              <option value="Ghurfah">Ghurfah</option>
                              <option value="Girath">Girath</option>
                              <option value="Haqil">Haqil</option>
                              <option value="Harat Zutut">Harat Zutut</option>
                              <option value="Harrah">Harrah</option>
                              <option value="Hatiyah">Hatiyah</option>
                              <option value="Hayat">Hayat</option>
                              <option value="Jabal Qurayyah">Jabal Qurayyah</option>
                              <option value="Jareef">Jareef</option>
                              <option value="Kalba">Kalba</option>
                              <option value="Khalba">Khalba</option>
                              <option value="Khawr Kalba">Khawr Kalba</option>
                              <option value="Khor Khalba">Khor Khalba</option>
                              <option value="Khulaybiyah">Khulaybiyah</option>
                              <option value="Maidaq">Maidaq</option>
                              <option value="Masafi">Masafi</option>
                              <option value="Masafi, Fruit and Vegetables Market">Masafi, Fruit and Vegetables Market</option>
                              <option value="Mawrid">Mawrid</option>
                              <option value="Maydaq">Maydaq</option>
                              <option value="Merbah, Fujairah">Merbah, Fujairah</option>
                              <option value="Minazif">Minazif</option>
                              <option value="Mu`taridah">Mu`taridah</option>
                              <option value="Mukhtaraqah">Mukhtaraqah</option>
                              <option value="Murbad">Murbad</option>
                              <option value="Murbah">Murbah</option>
                              <option value="Murrah">Murrah</option>
                              <option value="Nuhayy">Nuhayy</option>
                              <option value="Osfai">Osfai</option>
                              <option value="Qidfa">Qidfa</option>
                              <option value="Ras Dibba">Ras Dibba</option>
                              <option value="Riyamah">Riyamah</option>
                              <option value="Rughaylat">Rughaylat</option>
                              <option value="Rul Dadna">Rul Dadna</option>
                              <option value="Safad">Safad</option>
                              <option value="Sa'if">Sa'if</option>
                              <option value="Saqamqam">Saqamqam</option>
                              <option value="Sharm">Sharm</option>
                              <option value="Shawiyah">Shawiyah</option>
                              <option value="Siji">Siji</option>
                              <option value="Sinnah">Sinnah</option>
                              <option value="Sumbrair">Sumbrair</option>
                              <option value="Sur">Sur</option>
                              <option value="Tarif Kalba">Tarif Kalba</option>
                              <option value="Tariqat Ja`d">Tariqat Ja`d</option>
                              <option value="Tawi Siji">Tawi Siji</option>
                              <option value="Tawian">Tawian</option>
                              <option value="Tayyibah">Tayyibah</option>
                              <option value="Teba">Teba</option>
                              <option value="Theeb">Theeb</option>
                              <option value="Thoban">Thoban</option>
                              <option value="Wa`bayn">Wa`bayn</option>
                              <option value="Wahala">Wahala</option>
                              <option value="Wamm">Wamm</option>
                              <option value="Yalah">Yalah</option>
                              <option value="Zanhah">Zanhah</option>
                              <option value="Zikt">Zikt</option>
                          </ng-container>
                          <ng-container *ngIf="validationfreelancer.get('city').value === 'RAK'">
                              <option value="Old Ras Al Khaimah">Old Ras Al Khaimah</option>
                              <option value="Old Ras Al Khaimah, Al Waha Trading Market">Old Ras Al Khaimah, Al Waha Trading Market</option>
                              <option value="Old Ras Al Khaimah, Bin Dahur Centre">Old Ras Al Khaimah, Bin Dahur Centre</option>
                              <option value="Ayim">Ayim</option>
                              <option value="Uraybi">Uraybi</option>
                              <option value="Adh Dharbaniyah">Adh Dharbaniyah</option>
                              <option value="Adhan">Adhan</option>
                              <option value="Al Fahlayn">Al Fahlayn</option>
                              <option value="Al Fara">Al Fara</option>
                              <option value="Al Fara">Al Fara</option>
                              <option value="Al Fulayyah">Al Fulayyah</option>
                              <option value="Al Ghabah">Al Ghabah</option>
                              <option value="Al Ghabam">Al Ghabam</option>
                              <option value="Al Ghail">Al Ghail</option>
                              <option value="Al Ghashban">Al Ghashban</option>
                              <option value="Al Hamra Village">Al Hamra Village</option>
                              <option value="Al Hamraniyah">Al Hamraniyah</option>
                              <option value="Al Hayr">Al Hayr</option>
                              <option value="Al Hulaylah">Al Hulaylah</option>
                              <option value="Al Jaddah">Al Jaddah</option>
                              <option value="Al Jazirah al Hamra">Al Jazirah al Hamra</option>
                              <option value="Al Jazirah Aviation Club">Al Jazirah Aviation Club</option>
                              <option value="Al Khari">Al Khari</option>
                              <option value="Al Khashfah">Al Khashfah</option>
                              <option value="Al Mahamm">Al Mahamm</option>
                              <option value="Al Mamorah">Al Mamorah</option>
                              <option value="Al Marjan Island">Al Marjan Island</option>
                              <option value="Al Masafirah">Al Masafirah</option>
                              <option value="Al Mu`amurah">Al Mu`amurah</option>
                              <option value="Al Qir">Al Qir</option>
                              <option value="Al Quwayz">Al Quwayz</option>
                              <option value="Al Ramms">Al Ramms</option>
                              <option value="Al Riffa">Al Riffa</option>
                              <option value="Al Usayli">Al Usayli</option>
                              <option value="An Nakhil">An Nakhil</option>
                              <option value="Ar Rams">Ar Rams</option>
                              <option value="As Sur">As Sur</option>
                              <option value="Ash Sha`m">Ash Sha`m</option>
                              <option value="Athabat">Athabat</option>
                              <option value="Baqal">Baqal</option>
                              <option value="Bida">Bida</option>
                              <option value="Bidiyah">Bidiyah</option>
                              <option value="Bulaydah">Bulaydah</option>
                              <option value="Corniche">Corniche</option>
                              <option value="Creek">Creek</option>
                              <option value="Daftah">Daftah</option>
                              <option value="Darah">Darah</option>
                              <option value="Dayah">Dayah</option>
                              <option value="Daynah">Daynah</option>
                              <option value="Dhad al Arab">Dhad al Arab</option>
                              <option value="Difan">Difan</option>
                              <option value="Dihan">Dihan</option>
                              <option value="Diqdaqah">Diqdaqah</option>
                              <option value="Diqdaqah, Al Waha Centre">Diqdaqah, Al Waha Centre</option>
                              <option value="eXmajor Hangar">eXmajor Hangar</option>
                              <option value="Fashrah">Fashrah</option>
                              <option value="Fa'y">Fa'y</option>
                              <option value="Fayyad">Fayyad</option>
                              <option value="Financial City (DIFC)">Financial City (DIFC)</option>
                              <option value="Furfar">Furfar</option>
                              <option value="Ghadf">Ghadf</option>
                              <option value="Ghaghah">Ghaghah</option>
                              <option value="Ghalilah">Ghalilah</option>
                              <option value="Ghay">Ghay</option>
                              <option value="Ghubb">Ghubb</option>
                              <option value="Ghubbat Khawrah">Ghubbat Khawrah</option>
                              <option value="Ghurah">Ghurah</option>
                              <option value="Gragrah">Gragrah</option>
                              <option value="Habhab">Habhab</option>
                              <option value="Ham Ham">Ham Ham</option>
                              <option value="Hamra' Al Jazirah al">Hamra' Al Jazirah al</option>
                              <option value="Harat `Awali">Harat `Awali</option>
                              <option value="Hayl">Hayl</option>
                              <option value="Homraniya">Homraniya</option>
                              <option value="Hudaybah">Hudaybah</option>
                              <option value="Huwaylat">Huwaylat</option>
                              <option value="Industrial and Technology Park">Industrial and Technology Park</option>
                              <option value="Jazirat al Hamra">Jazirat al Hamra</option>
                              <option value="Jazirat al Hamra', Beach Centre">Jazirat al Hamra', Beach Centre</option>
                              <option value="Jazirat al Hamra', Hatta Fort Golf Course">Jazirat al Hamra', Hatta Fort Golf Course</option>
                              <option value="Khabakhib">Khabakhib</option>
                              <option value="Kharran">Kharran</option>
                              <option value="Khatt">Khatt</option>
                              <option value="Khawr Khuwayr">Khawr Khuwayr</option>
                              <option value="Khazam">Khazam</option>
                              <option value="Kub">Kub</option>
                              <option value="Ma`ali">Ma`ali</option>
                              <option value="Maghribiyah">Maghribiyah</option>
                              <option value="Manqashah">Manqashah</option>
                              <option value="Marhamid">Marhamid</option>
                              <option value="Masafi">Masafi</option>
                              <option value="Masah">Masah</option>
                              <option value="Mina Al Arab">Mina Al Arab</option>
                              <option value="Minha">Minha</option>
                              <option value="Mu`ayrid">Mu`ayrid</option>
                              <option value="Munay`i">Munay`i</option>
                              <option value="Muraytah">Muraytah</option>
                              <option value="New Hangar Zebra VON">New Hangar Zebra VON</option>
                              <option value="Qabas">Qabas</option>
                              <option value="Qaf'ah">Qaf'ah</option>
                              <option value="Qarat ad Dum">Qarat ad Dum</option>
                              <option value="Quar Ah Qahlish">Quar Ah Qahlish</option>
                              <option value="Qur">Qur</option>
                              <option value="Qurm">Qurm</option>
                              <option value="Qusaydat">Qusaydat</option>
                              <option value="Rafaq">Rafaq</option>
                              <option value="RAK airport">RAK airport</option>
                              <option value="Ramlah">Ramlah</option>
                              <option value="Rams">Rams</option>
                              <option value="Ras Al Khaimah">Ras Al Khaimah</option>
                              <option value="Ras al Khaimah, Al Dour Archaeological Site">Ras al Khaimah, Al Dour Archaeological Site</option>
                              <option value="Ras al Khaimah, Al Safeer Shopping Center">Ras al Khaimah, Al Safeer Shopping Center</option>
                              <option value="Ras al Khaimah, Emirates Cultural Sport Club">Ras al Khaimah, Emirates Cultural Sport Club</option>
                              <option value="Ras al Khaimah, Emirates Pearls Markets">Ras al Khaimah, Emirates Pearls Markets</option>
                              <option value="Ras al Khaimah, Fish Market">Ras al Khaimah, Fish Market</option>
                              <option value="Ras al Khaimah, Madinet Zayed Camel Race Track">Ras al Khaimah, Madinet Zayed Camel Race Track</option>
                              <option value="Ras al Khaimah, Mdinet Zayed Market">Ras al Khaimah, Mdinet Zayed Market</option>
                              <option value="Ras al Khaimah, Rak Trading Mall">Ras al Khaimah, Rak Trading Mall</option>
                              <option value="Ras al Khaimah, Safeer Mall">Ras al Khaimah, Safeer Mall</option>
                              <option value="Ras al Khaimah, Saif Al Shawi">Ras al Khaimah, Saif Al Shawi</option>
                              <option value="Rima">Rima</option>
                              <option value="Sal Dora">Sal Dora</option>
                              <option value="Salihiyah">Salihiyah</option>
                              <option value="Samarat">Samarat</option>
                              <option value="Saraya Islands">Saraya Islands</option>
                              <option value="Sayh">Sayh</option>
                              <option value="Sayh as Saqlah">Sayh as Saqlah</option>
                              <option value="Sha`biyat Naslah">Sha`biyat Naslah</option>
                              <option value="Shabakah">Shabakah</option>
                              <option value="Shah">Shah</option>
                              <option value="Shahawat">Shahawat</option>
                              <option value="Shariyah">Shariyah</option>
                              <option value="Sharyat">Sharyat</option>
                              <option value="Shawkah">Shawkah</option>
                              <option value="Shimal">Shimal</option>
                              <option value="Stan">Stan</option>
                              <option value="Suhaybah">Suhaybah</option>
                              <option value="Wad Wid">Wad Wid</option>
                              <option value="Waterfront">Waterfront</option>
                              <option value="Wayb Hawf">Wayb Hawf</option>
                              <option value="Yasmin Village">Yasmin Village</option>
                              <option value="Yinas">Yinas</option>
                          </ng-container>

                      </select>
                      <div *ngIf="formFreelancer.area.errors" class="invalid-feedback">
                        <span *ngIf="formFreelancer.area.hasError('required')">Area is required.</span>
                      </div> 
                    </div>
                  </div>
                  <div class="row mb-3">
                    <label for="validationCustom22" class="col-md-3 col-form-label">Building</label>
                    <div class="col-md-9">
                      <input type="text" class="form-control" id="validationCustom22" formControlName="building"
                      placeholder="Enter Building" [ngClass]="{'is-invalid': validation_freelancer && formFreelancer.building.errors}">
                      <div *ngIf="formFreelancer.building.errors" class="invalid-feedback">
                        <span *ngIf="formFreelancer.building.hasError('required')">Building is required.</span>
                      </div> 
                    </div>
                  </div>
                  <div class="row mb-3">
                    <label for="validationCustom23" class="col-md-3 col-form-label">Apartment</label>
                    <div class="col-md-9">
                      <input type="text" class="form-control" id="validationCustom23" formControlName="apartment"
                      placeholder="Enter Apartment" [ngClass]="{'is-invalid': validation_freelancer && formFreelancer.apartment.errors}">
                      <div *ngIf="formFreelancer.apartment.errors" class="invalid-feedback">
                        <span *ngIf="formFreelancer.apartment.hasError('required')">Apartment is required.</span>
                      </div> 
                    </div>
                  </div>
                  <div class="row mb-3">
                    <label for="validationCustom10" class="col-md-3 col-form-label">Latitude</label>
                    <div class="col-md-9">
                      <input type="text" class="form-control" id="validationCustom10" formControlName="latitude"
                      placeholder="Enter Latitude" [ngClass]="{'is-invalid': validation_freelancer && formFreelancer.latitude.errors}">
                      <div *ngIf="formFreelancer.latitude.errors" class="invalid-feedback">
                        <span *ngIf="formFreelancer.latitude.hasError('required')">Latitude is required.</span>
                      </div> 
                    </div>
                  </div>
                  <div class="row mb-3">
                    <label for="validationCustom11" class="col-md-3 col-form-label">Longitude</label>
                    <div class="col-md-9">
                      <input type="text" class="form-control" id="validationCustom11" formControlName="longitude"
                      placeholder="Enter Longitude" [ngClass]="{'is-invalid': validation_freelancer && formFreelancer.longitude.errors}">
                      <div *ngIf="formFreelancer.longitude.errors" class="invalid-feedback">
                        <span *ngIf="formFreelancer.longitude.hasError('required')">Longitude is required.</span>
                      </div> 
                    </div>
                  </div>
              </div>
              <div class="col-lg-12">
                <div class="card">
                  <div class="card-body">
                    <!-- Map -->
                    <agm-map 
                      [latitude]="latitude" 
                      [longitude]="longitude" 
                      style="height: 300px" 
                      (mapClick)="mapLeftClick($event)">
                      
                      <agm-marker 
                          *ngIf="markerVisible"
                          [latitude]="latitude"
                          [longitude]="longitude">
                      </agm-marker>
                      
                    </agm-map>
                  </div>
                </div>
              </div>
              <div #streetviewMap></div>
              <ul class="list-inline wizard mb-0">
                <li class="previous list-inline-item"><button class="btn btn-primary" (click)="goToPreviousStep()" awPreviousStep>Previous</button>
                </li>
                <li class="list-inline-item"><button class="btn btn-primary" (click)="getCurrentLocationFreelancer()" >Get Current Location</button>
                </li>
                <li class="next list-inline-item float-end"><button class="btn btn-primary" (click)="goToPreviousStep()" awNextStep>Next</button>
                </li>
              </ul>
            </aw-wizard-step>

            <aw-wizard-step>
              <ng-template awWizardStepSymbol>
                <i class="fas fa-upload"></i>
              </ng-template>
              <div class="row">
                <div class="row mb-3">
                  <div class="col-md-12">
                    <label for="validationCustom12f" class="col-md-12 col-form-label">Upload the Profile Image</label>
                    <input type="file" class="form-control" id="validationCustom12f" formControlName="image"
                    [ngClass]="{'is-invalid': !isImageValidFreelancer}" (change)="validateImageFreelancer($event)">
                    <div *ngIf="!isImageValidFreelancer" class="invalid-feedback">
                      <!-- <span *ngIf="formFreelancer.image.errors?.required">Please select an image to upload.</span> -->
                      <span *ngIf="formFreelancer.image.errors?.invalidFileType">Invalid file type. Please select a JPG, PNG, or JPEG file.</span>
                      <span *ngIf="formFreelancer.image.errors?.maxSizeExceeded">File size exceeded. Please select a file up to 5MB in size.</span>
                    </div> 
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-md-12">
                    <label for="validationCustom13f" class="col-md-12 col-form-label">Upload the Emirates ID</label>
                    <input type="file" class="form-control" id="validationCustom13f" formControlName="emirates_id"
                    [ngClass]="{'is-invalid': !isEmirateIDValidFreelancer}" (change)="validaEmirateIDFreelancer($event)">
                    <div *ngIf="!isEmirateIDValidFreelancer" class="invalid-feedback">
                      <span *ngIf="formFreelancer.emirates_id.errors?.required">Please select an file to upload.</span>
                      <span *ngIf="formFreelancer.emirates_id.errors?.invalidFileType">Invalid file type. Please select a JPG, PNG or JPEG file.</span>
                      <span *ngIf="formFreelancer.emirates_id.errors?.maxSizeExceeded">File size exceeded. Please select a file up to 5MB in size.</span>
                    </div> 
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-md-12">
                    <label for="validationCustom14f" class="col-md-12 col-form-label">Upload the Passport</label>
                    <input type="file" class="form-control" id="validationCustom14f" formControlName="passport"
                    [ngClass]="{'is-invalid': !isPassportValidFreelancer}" (change)="validaPassportFreelancer($event)">
                    <div *ngIf="!isPassportValidFreelancer" class="invalid-feedback">
                      <!-- <span *ngIf="formFreelancer.passport.errors?.required">Please select an file to upload.</span> -->
                      <span *ngIf="formFreelancer.passport.errors?.invalidFileType">Invalid file type. Please select a JPG, PNG or JPEG file.</span>
                      <span *ngIf="formFreelancer.passport.errors?.maxSizeExceeded">File size exceeded. Please select a file up to 5MB in size.</span>
                    </div> 
                  </div>
                </div>
                
              </div>
              <ul class="list-inline wizard mb-0">
                <li class="previous list-inline-item"><button class="btn btn-primary" (click)="goToPreviousStep()" awPreviousStep>Previous</button>
                </li>
                <li class="next list-inline-item float-end">
                  <button type="submit" class="btn btn-primary" (click)="submitDataFreelancer()">Submit</button>
              </ul>
            </aw-wizard-step>
          </form>
        </aw-wizard>
      </div>
    </div>
  </div>
</ng-template>


<ng-template #TabContent2>
  <div class="col-lg-12">
    <div class="card">
      <div class="card-body">
        <h4 class="card-title mb-4">Company Vendor</h4>
        <aw-wizard #wizard [navBarLayout]="'large-empty-symbols'">
          <form class="needs-validation" (ngSubmit)="validSubmitCompany()" [formGroup]="validationcompany">
            <aw-wizard-step>
              <ng-template awWizardStepSymbol>
                <i class="fas fa-user"></i>
              </ng-template>
              <div class="row">
                  <div class="row mb-3">
                    <label for="validationCustom101" class="col-md-3 col-form-label">Select Services</label>
                    <div class="col-md-9">
                      <ng-select 
                        [items]="selectValue" 
                        [multiple]="true" 
                        formControlName="services" 
                        class="form-control" 
                        id="validationCustom101"
                        [ngClass]="{'is-invalid': validation_company && formCompany.services.errors}">
                      </ng-select>
                    </div>
                    <!-- Validation Feedback -->
                    <div *ngIf="formCompany.services.errors" class="invalid-feedback">
                      <span *ngIf="formCompany.services.hasError('required')">Services selection is required.</span>
                    </div>
                  </div>

                  <div class="row mb-3">
                    <label for="validationCustom01" class="col-md-3 col-form-label">Name</label>
                    <div class="col-md-9">
                      <input type="text" class="form-control" id="validationCustom01" formControlName="name"
                      placeholder="Enter Name" [ngClass]="{'is-invalid': validation_company && formCompany.name.errors}">
                      <div *ngIf="formCompany.name.errors" class="invalid-feedback">
                        <span *ngIf="formCompany.name.hasError('required')">User Name is required.</span>
                        <span *ngIf="formCompany.name.hasError('pattern')">Only Allowed Alphabet and Number.</span>
                      </div> 
                    </div>
                  </div>
                  <div class="row mb-3">
                    <label for="validationCustom02" class="col-md-3 col-form-label">Email</label>
                    <div class="col-md-9">
                      <input type="text" class="form-control" id="validationCustom02" formControlName="email"
                      placeholder="Enter Email" [ngClass]="{'is-invalid': validation_company && formCompany.email.errors}">
                      <div *ngIf="formCompany.email.errors" class="invalid-feedback">
                        <span *ngIf="formCompany.email.hasError('required')">User Email is required.</span>
                        <span *ngIf="formCompany.email.hasError('pattern')">Email Pattern is not match.</span>
                      </div> 
                    </div>
                  </div>
                  <div class="row mb-3">
                    <label for="validationCustom03" class="col-md-3 col-form-label">Password</label>
                    <div class="col-md-9">
                      <input type="password" class="form-control" id="validationCustom03" formControlName="password"
                      placeholder="Enter Password" [ngClass]="{'is-invalid': validation_company && formCompany.password.errors}">
                      <div *ngIf="formCompany.password.errors" class="invalid-feedback">
                        <span *ngIf="formCompany.password.hasError('required')">User password is required.</span>
                        <span *ngIf="formCompany.password.hasError('minlength')">Atleaset 8 characters required.</span>
                      </div> 
                    </div>
                  </div>
                  <!-- <div class="mb-3 row">
                    <label for="validationCustom04" class="col-md-3 col-form-label">Gender</label>
                    <div class="col-md-9">
                        <select class="form-select" id="validationCustom04" formControlName="gender"
                                [ngClass]="{'is-invalid': validation_company && formCompany.gender.errors}">
                            <option value="M">Male</option>
                            <option value="F">Female</option>
                            <option value="O">Other</option>
                        </select>
                        <div *ngIf="formCompany.gender.errors" class="invalid-feedback">
                          <span *ngIf="formCompany.gender.hasError('required')">Gender is required.</span>
                        </div> 
                    </div>
                  </div> -->
                  <div class="mb-3 row">
                    <label for="validationCustom05" class="col-md-3 col-form-label">Phone Number</label>
                    <div class="col-md-9 d-flex align-items-center">
                      <div class="input-group">
                        <div class="input-group-text">+971</div>
                          <input type="text" class="form-control" id="validationCustom05" formControlName="phone_number"
                          placeholder="Enter Phone Number" [ngClass]="{'is-invalid': validation_company && formCompany.phone_number.errors}">
                        </div>
                      <div *ngIf="formCompany.phone_number.errors" class="invalid-feedback">
                        <span *ngIf="formCompany.phone_number.hasError('required')">Phone Number is required.</span>
                        <span *ngIf="formCompany.phone_number.hasError('pattern')">Phone number has 9 digit.</span>
                      </div> 
                    </div>
                  </div>
                  <div class="mb-3 row">
                    <label for="validationCustom06" class="col-md-3 col-form-label">Land Line Number</label>
                    <div class="col-md-9 d-flex align-items-center">
                      <div class="input-group">
                        <div class="input-group-text">+971</div>
                          <input type="text" class="form-control" id="validationCustom06" formControlName="land_line_number"
                          placeholder="Enter Land Line Number" [ngClass]="{'is-invalid': validation_company && formCompany.land_line_number.errors}">
                        </div>
                      <div *ngIf="formCompany.land_line_number.errors" class="invalid-feedback">
                        <span *ngIf="formCompany.land_line_number.hasError('required')">Land Line Number is required.</span>
                        <!-- <span *ngIf="formCompany.land_line_number.hasError('pattern')">Land Line number has 7 digit.</span> -->
                      </div> 
                    </div>
                  </div>
              </div>
              <ul class="list-inline wizard mb-0">
                <li class="next list-inline-item float-end"><button class="btn btn-primary" (click)="goToPreviousStep()" awNextStep>Next</button>
                </li>
              </ul>
            </aw-wizard-step>            

            <aw-wizard-step>
              <ng-template awWizardStepSymbol>
                <i class="far fa-address-card"></i>
              </ng-template>
              <div class="row">
                  <div class="row mb-3">
                    <label for="validationCustom06" class="col-md-3 col-form-label">Address Name</label>
                    <div class="col-md-9">
                      <input type="text" class="form-control" id="validationCustom06" formControlName="address_name"
                      placeholder="Enter Address Name" [ngClass]="{'is-invalid': validation_company && formCompany.address_name.errors}">
                      <div *ngIf="formCompany.address_name.errors" class="invalid-feedback">
                        <span *ngIf="formCompany.address_name.hasError('required')">Address Name is required.</span>
                      </div> 
                    </div>
                  </div>
                  <div class="mb-3 row">
                    <label for="validationCustom08" class="col-md-3 col-form-label">Country</label>
                    <div class="col-md-9">
                        <select class="form-select" id="validationCustom08" formControlName="country"
                                [ngClass]="{'is-invalid': validation_company && formCompany.country.errors}">
                          <option value="UAE">United Arab Emirates</option>
                        </select>
                        <div *ngIf="formCompany.country.errors" class="invalid-feedback">
                          <span *ngIf="formCompany.country.hasError('required')">Country is required.</span>
                        </div> 
                    </div>                  
                  </div>
                  <div class="mb-3 row">
                    <label for="validationCustom09" class="col-md-3 col-form-label">City</label>
                    <div class="col-md-9">
                        <select class="form-select" id="validationCustom09" formControlName="city"
                                [ngClass]="{'is-invalid': validation_company && formCompany.city.errors}">
                            <option value="AUH">Abu Dhabi</option>
                            <option value="AA">Al Ain</option>
                            <option value="DXB">Dubai</option>
                            <option value="SHJ">Sharjah</option>
                            <option value="AJM">Ajman</option>
                            <option value="UAQ">Umm Al Quwain</option>
                            <option value="RAK">Ras Al Khaimah</option>
                            <option value="FUJ">Fujairah</option>
                        </select>
                        <div *ngIf="formCompany.city.errors" class="invalid-feedback">
                          <span *ngIf="formCompany.city.hasError('required')">City is required.</span>
                        </div>
                    </div>  
                  </div>
                  <div class="row mb-3">
                    <label for="validationCustom21" class="col-md-3 col-form-label">Area</label>
                    <div class="col-md-9">
                      <!-- <input type="text" class="form-control" id="validationCustom21" formControlName="area"
                      placeholder="Enter Area" [ngClass]="{'is-invalid': validation && form.area.errors}"> -->
                      <select class="form-select" id="subscriptionCustom02" formControlName="area"
                      [ngClass]="{'is-invalid': validation_company && formCompany.area.errors}">
                        <ng-container *ngIf="validationcompany.get('city').value === 'AUH'">
                            <option value="Abu Al Abyad">Abu Al Abyad</option>
                            <option value="Abu Dhabi">Abu Dhabi</option>
                            <option value="Abu Dhabi Airport">Abu Dhabi Airport</option>
                            <option value="Abu Dhabi Gate City">Abu Dhabi Gate City</option>
                            <option value="Al `Ayn">Al `Ayn</option>
                            <option value="Al `Idd">Al `Idd</option>
                            <option value="Al `Udayd">Al `Udayd</option>
                            <option value="Al Ain">Al Ain</option>
                            <option value="Al Aman">Al Aman</option>
                            <option value="Al Atir">Al Atir</option>
                            <option value="Al Badaa">Al Badaa</option>
                            <option value="Al Bahia">Al Bahia</option>
                            <option value="Al Baladiyah">Al Baladiyah</option>
                            <option value="Al Baraha">Al Baraha</option>
                            <option value="Al Bateen">Al Bateen</option>
                            <option value="Al Dhafrah">Al Dhafrah</option>
                            <option value="Al Falah City">Al Falah City</option>
                            <option value="Al Ghadeer">Al Ghadeer</option>
                            <option value="Al Hadhi">Al Hadhi</option>
                            <option value="Al Hayer">Al Hayer</option>
                            <option value="Al Hisn">Al Hisn</option>
                            <option value="Al Hosn">Al Hosn</option>
                            <option value="Al Hudayriat Island">Al Hudayriat Island</option>
                            <option value="Al Ittihad">Al Ittihad</option>
                            <option value="Al Jahr">Al Jahr</option>
                            <option value="Al Jami` al Kabir">Al Jami` al Kabir</option>
                            <option value="Al Karamah ">Al Karamah</option>
                            <option value="Al Khabb">Al Khabb</option>
                            <option value="Al Khaleej Al Arabi">Al Khaleej Al Arabi</option>
                            <option value="Al Khalidiya">Al Khalidiya</option>
                            <option value="Al Khalidiyah">Al Khalidiyah</option>
                            <option value="Al Khatim">Al Khatim</option>
                            <option value="Al Khazna">Al Khazna</option>
                            <option value="Al Khaznah">Al Khaznah</option>
                            <option value="Al Khis">Al Khis</option>
                            <option value="Al Khubayrah">Al Khubayrah</option>
                            <option value="Al Khubeirah">Al Khubeirah</option>
                            <option value="Al Mafraq">Al Mafraq</option>
                            <option value="Al Manaseer">Al Manaseer</option>
                            <option value="Al Manhal">Al Manhal</option>
                            <option value="Al Maqta">Al Maqta</option>
                            <option value="Al Marfa">Al Marfa</option>
                            <option value="Al Mariah United Group">Al Mariah United Group</option>
                            <option value="Al Mariyah">Al Mariyah</option>
                            <option value="Al Mariyah al Gharbiyah">Al Mariyah al Gharbiyah</option>
                            <option value="Al Markaziyah">Al Markaziyah</option>
                            <option value="Al Mashrub">Al Mashrub</option>
                            <option value="Al Mina">Al Mina</option>
                            <option value="Al Mirfa">Al Mirfa</option>
                            <option value="Al Mu`tarad">Al Mu`tarad</option>
                            <option value="Al Mughayra">Al Mughayra</option>
                            <option value="Al Muqattarah">Al Muqattarah</option>
                            <option value="Al Muroor">Al Muroor</option>
                            <option value="Al Murur">Al Murur</option>
                            <option value="Al Musalla">Al Musalla</option>
                            <option value="Al Mushrif">Al Mushrif</option>
                            <option value="Al Muwayqi`i">Al Muwayqi`i</option>
                            <option value="Al Muzun">Al Muzun</option>
                            <option value="Al Nahda Abu Dhabi">Al Nahda Abu Dhabi</option>
                            <option value="Al Nahyan">Al Nahyan</option>
                            <option value="Al Najda">Al Najda</option>
                            <option value="Al Qaia">Al Qaia</option>
                            <option value="Al Qimi">Al Qimi</option>
                            <option value="Al Qurm">Al Qurm</option>
                            <option value="Al Raha Beach">Al Raha Beach</option>
                            <option value="Al Raha Corniche">Al Raha Corniche</option>
                            <option value="Al Raha Gardens">Al Raha Gardens</option>
                            <option value="Al Raha Golf Gardens">Al Raha Golf Gardens</option>
                            <option value="Al Rahba">Al Rahba</option>
                            <option value="Al Ras Al Akhdar">Al Ras Al Akhdar</option>
                            <option value="Al Rawdah">Al Rawdah</option>
                            <option value="Al Reef">Al Reef</option>
                            <option value="Al Reem Island">Al Reem Island</option>
                            <option value="Al Rowdah">Al Rowdah</option>
                            <option value="Al Ruwais">Al Ruwais</option>
                            <option value="Al Samha">Al Samha</option>
                            <option value="Al Shahama">Al Shahama</option>
                            <option value="Al Shamkha">Al Shamkha</option>
                            <option value="Al Sowwah">Al Sowwah</option>
                            <option value="Al Wahda">Al Wahda</option>
                            <option value="Al Wahdah">Al Wahdah</option>
                            <option value="Al Wathba">Al Wathba</option>
                            <option value="Al Wathbah">Al Wathbah</option>
                            <option value="Al Zaab">Al Zaab</option>
                            <option value="An Nadi as Siyahi">An Nadi as Siyahi</option>
                            <option value="An Nashshash">An Nashshash</option>
                            <option value="Aqbiyah">Aqbiyah</option>
                            <option value="Ar Ra's al Akhdar">Ar Ra's al Akhdar</option>
                            <option value="Ar Rawdah">Ar Rawdah</option>
                            <option value="Ar Rihan">Ar Rihan</option>
                            <option value="Ar Ruways">Ar Ruways</option>
                            <option value="Aradah">Aradah</option>
                            <option value="As Sad">As Sad</option>
                            <option value="As Slabeikh">As Slabeikh</option>
                            <option value="As Sulaymat">As Sulaymat</option>
                            <option value="Ash Shahamah">Ash Shahamah</option>
                            <option value="Ash Shibhanah">Ash Shibhanah</option>
                            <option value="Attab">Attab</option>
                            <option value="Ayn al Faydah">Ayn al Faydah</option>
                            <option value="Az Za`ab">Az Za`ab</option>
                            <option value="Az Zafrah">Az Zafrah</option>
                            <option value="Az Zahra">Az Zahra</option>
                            <option value="Badiyah">Badiyah</option>
                            <option value="Baniyas">Baniyas</option>
                            <option value="Batin">Batin</option>
                            <option value="Bid' Zayed">Bid' Zayed</option>
                            <option value="Bid' Zayed, Manar Mall">Bid' Zayed, Manar Mall</option>
                            <option value="Bin Ahmad">Bin Ahmad</option>
                            <option value="Bu Hasa">Bu Hasa</option>
                            <option value="Bu Lifiyat">Bu Lifiyat</option>
                            <option value="Bu Rays">Bu Rays</option>
                            <option value="Capital District">Capital District</option>
                            <option value="Corniche">Corniche</option>
                            <option value="Da`sah">Da`sah</option>
                            <option value="Dahin">Dahin</option>
                            <option value="Danet">Danet</option>
                            <option value="Downtown">Downtown</option>
                            <option value="Fariq Tarif">Fariq Tarif</option>
                            <option value="Ghantoot">Ghantoot</option>
                            <option value="Ghurbah">Ghurbah</option>
                            <option value="Golf Gardens">Golf Gardens</option>
                            <option value="Grand Mosque District">Grand Mosque District</option>
                            <option value="Habshan">Habshan</option>
                            <option value="Hadbat az Za`faranah">Hadbat az Za`faranah</option>
                            <option value="Hafif">Hafif</option>
                            <option value="Hamarur">Hamarur</option>
                            <option value="Hameem">Hameem</option>
                            <option value="Hamim">Hamim</option>
                            <option value="Hilli">Hilli</option>
                            <option value="Humar">Humar</option>
                            <option value="Huwaylah">Huwaylah</option>
                            <option value="Huwaytayn">Huwaytayn</option>
                            <option value="Hydra Village">Hydra Village</option>
                            <option value="Istayhah">Istayhah</option>
                            <option value="Jarbub">Jarbub</option>
                            <option value="Jayf">Jayf</option>
                            <option value="Jebel Dhanna">Jebel Dhanna</option>
                            <option value="Jurayrah">Jurayrah</option>
                            <option value="Kayyah">Kayyah</option>
                            <option value="Khalifa City B">Khalifa City B</option>
                            <option value="Khalifa Street">Khalifa Street</option>
                            <option value="Khannur">Khannur</option>
                            <option value="Liwa">Liwa</option>
                            <option value="Lulu Island">Lulu Island</option>
                            <option value="Madinat ad Dubbat">Madinat ad Dubbat</option>
                            <option value="Madinat an Nahdah">Madinat an Nahdah</option>
                            <option value="Madinat Khalifah A">Madinat Khalifah A</option>
                            <option value="Madinat Khalifah B">Madinat Khalifah B</option>
                            <option value="Madinat Zayed">Madinat Zayed</option>
                            <option value="Madinat Zayid">Madinat Zayid</option>
                            <option value="Madinat Zayid, Rak Sports Cultural Club">Madinat Zayid, Rak Sports Cultural Club</option>
                            <option value="Madinat Zayid, Vegetable and Fruits Market">Madinat Zayid, Vegetable and Fruits Market</option>
                            <option value="Mahdar Bin `Usayyan">Mahdar Bin `Usayyan</option>
                            <option value="Majra al Ghaf">Majra al Ghaf</option>
                            <option value="Marawwah">Marawwah</option>
                            <option value="Marina Village">Marina Village</option>
                            <option value="Mas`udi">Mas`udi</option>
                            <option value="Masdar City ">Masdar City </option>
                            <option value="Mawsil">Mawsil</option>
                            <option value="Mazyad">Mazyad</option>
                            <option value="Milqatah">Milqatah</option>
                            <option value="Mintaqah Bayn al Jisrayn">Mintaqah Bayn al Jisrayn</option>
                            <option value="Mintaqat al Matar">Mintaqat al Matar</option>
                            <option value="Mohamed Bin Zayed City">Mohamed Bin Zayed City</option>
                            <option value="Mujib">Mujib</option>
                            <option value="Mundafinah">Mundafinah</option>
                            <option value="Muroor Area">Muroor Area</option>
                            <option value="Mussafah">Mussafah</option>
                            <option value="Muzayri">Muzayri</option>
                            <option value="Nafir">Nafir</option>
                            <option value="Nahel">Nahel</option>
                            <option value="Naqrah">Naqrah</option>
                            <option value="NPCC, Mussafa, Abu DHabi">NPCC, Mussafa, Abu DHabi</option>
                            <option value="Nuqayrah">Nuqayrah</option>
                            <option value="Nurai Island">Nurai Island</option>
                            <option value="Police Officers City">Police Officers City</option>
                            <option value="Qaryat at Turath">Qaryat at Turath</option>
                            <option value="Qasr al Bahr">Qasr al Bahr</option>
                            <option value="Qasr ash Shati">Qasr ash Shati</option>
                            <option value="Qasr El Bahr">Qasr El Bahr</option>
                            <option value="Qasr El Shatie">Qasr El Shatie</option>
                            <option value="Qatar">Qatar</option>
                            <option value="Qattarah">Qattarah</option>
                            <option value="Qu`aysah">Qu`aysah</option>
                            <option value="Qurmidah">Qurmidah</option>
                            <option value="Qutuf">Qutuf</option>
                            <option value="Radaim">Radaim</option>
                            <option value="Ras Khumais">Ras Khumais</option>
                            <option value="Rowdat Al Reef Palace">Rowdat Al Reef Palace</option>
                            <option value="Saadiyat Island">Saadiyat Island</option>
                            <option value="Sabkhah">Sabkhah</option>
                            <option value="Sas Al Nakheel">Sas Al Nakheel</option>
                            <option value="Sas an Nakhl">Sas an Nakhl</option>
                            <option value="Shah">Shah</option>
                            <option value="Shamis">Shamis</option>
                            <option value="Shati' ar Rahah">Shati' ar Rahah</option>
                            <option value="Sikkat al Khayl">Sikkat al Khayl</option>
                            <option value="Suwayhan">Suwayhan</option>
                            <option value="Sweihan">Sweihan</option>
                            <option value="Taraq">Taraq</option>
                            <option value="Tarif">Tarif</option>
                            <option value="Tharwaniyah">Tharwaniyah</option>
                            <option value="Tourist Club Area">Tourist Club Area</option>
                            <option value="Umm al Qurayn">Umm al Qurayn</option>
                            <option value="Wadhil">Wadhil</option>
                            <option value="Wafd">Wafd</option>
                            <option value="Yafur">Yafur</option>
                            <option value="Yas Island">Yas Island</option>
                            <option value="Yas Marina F1 Circuit">Yas Marina F1 Circuit</option>
                            <option value="Zafir">Zafir</option>
                            <option value="Zayed Military City">Zayed Military City</option>
                            <option value="Zuwayhir">Zuwayhir</option>

                            <option value="Abu Dhabi Cricket Stadium">Abu Dhabi Cricket Stadium</option>
                            <option value="Abu Dhabi Golf Club">Abu Dhabi Golf Club</option>
                            <option value="Khalifa A">Khalifa A</option>

                            <option value="Mazyad Mall">Mazyad Mall</option>
                            <option value="Mohammed Bin Zayed City">Mohammed Bin Zayed City</option>

                        </ng-container>
                        <ng-container *ngIf="validationcompany.get('city').value === 'AJM'">
                            <option value="Ain Ajman">Ain Ajman</option>
                            <option value="Ajman">Ajman</option>
                            <option value="Ajman, Al Bustan">Ajman, Al Bustan</option>
                            <option value="Ajman, Al Butain">Ajman, Al Butain</option>
                            <option value="Ajman, Al Nakhil">Ajman, Al Nakhil</option>
                            <option value="Ajman, Al Owan">Ajman, Al Owan</option>
                            <option value="Ajman, Al Rashidiya">Ajman, Al Rashidiya</option>
                            <option value="Ajman, Al Rifaah">Ajman, Al Rifaah</option>
                            <option value="Ajman, Al Rumailah">Ajman, Al Rumailah</option>
                            <option value="Ajman, Corniche Area">Ajman, Corniche Area</option>
                            <option value="Ajman, Old Industrial Area">Ajman, Old Industrial Area</option>
                            <option value="Ajman, Port Area">Ajman, Port Area</option>
                            <option value="Al Ameera Village">Al Ameera Village</option>
                            <option value="Al Bustan">Al Bustan</option>
                            <option value="Al Butain">Al Butain</option>
                            <option value="Al Hamidiyah">Al Hamidiyah</option>
                            <option value="Al Helio">Al Helio</option>
                            <option value="Al Humaid City">Al Humaid City</option>
                            <option value="Al Ittihad Village">Al Ittihad Village</option>
                            <option value="Al Naimiya">Al Naimiya</option>
                            <option value="Al Nakhil">Al Nakhil</option>
                            <option value="Al Owan">Al Owan</option>
                            <option value="Al Rumailah">Al Rumailah</option>
                            <option value="Al Tala Camel Race Track of Ajman">Al Tala Camel Race Track of Ajman</option>
                            <option value="Al Zahraa">Al Zahraa</option>
                            <option value="Awali City">Awali City</option>
                            <option value="Bustan">Bustan</option>
                            <option value="Corniche">Corniche</option>
                            <option value="Downtown">Downtown</option>
                            <option value="Emirates City">Emirates City</option>
                            <option value="Green City">Green City</option>
                            <option value="Hamideeyah">Hamideeyah</option>
                            <option value="Hasat al Bidiyah">Hasat al Bidiyah</option>
                            <option value="Helio">Helio</option>
                            <option value="Industrial Area">Industrial Area</option>
                            <option value="Jurf">Jurf</option>
                            <option value="Manama">Manama</option>
                            <option value="Marina">Marina</option>
                            <option value="Marmooka City">Marmooka City</option>
                            <option value="Meadows">Meadows</option>
                            <option value="Muehat">Muehat</option>
                            <option value="Musheirif">Musheirif</option>
                            <option value="Musheirif Commercial">Musheirif Commercial</option>
                            <option value="Muwayhat">Muwayhat</option>
                            <option value="Nakheel">Nakheel</option>
                            <option value="Naymiyah">Naymiyah</option>
                            <option value="New industrial area">New industrial area</option>
                            <option value="Park View City">Park View City</option>
                            <option value="Private Airfield">Private Airfield</option>
                            <option value="Rashidiya">Rashidiya</option>
                            <option value="Rumaylah">Rumaylah</option>
                            <option value="Sawan">Sawan</option>
                            <option value="Tala">Tala</option>
                            <option value="Uptown">Uptown</option>
                            <option value="Zahra">Zahra</option>
                            <option value="Zawra">Zawra</option>

                            <option value="Manama">Manama</option>
                            <option value="Manama, Al Aswaq Hayper Market">Manama, Al Aswaq Hayper Market</option>
                            <option value="Goal">Goal</option>
                            <option value="Masfut">Masfut</option>
                            <option value="Mazeira">Mazeira</option>

                        </ng-container>
                        <ng-container *ngIf="validationcompany.get('city').value === 'SHJ'">
                            <option value="Dayd">Dayd</option>
                            <option value="Dayd, Al Bustan">Dayd, Al Bustan</option>
                            <option value="Dayd, Al Hasan">Dayd, Al Hasan</option>
                            <option value="Dayd, Al Sharaya">Dayd, Al Sharaya</option>
                            <option value="Dayd, Al Suwaiah">Dayd, Al Suwaiah</option>
                            <option value="Dayd, Al Tayebah">Dayd, Al Tayebah</option>
                            <option value="Dayd, Lubsah Camel Race Track">Dayd, Lubsah Camel Race Track</option>
                            
                            <option value="Kalba">Kalba</option>
                            <option value="Kalba, Al Aoud">Kalba, Al Aoud</option>
                            <option value="Kalba, Al Baraha">Kalba, Al Baraha</option>
                            <option value="Kalba, Al Bateen">Kalba, Al Bateen</option>
                            <option value="Kalba, Al Bridi">Kalba, Al Bridi</option>
                            <option value="Kalba, Al Mafraq">Kalba, Al Mafraq</option>
                            <option value="Kalba, Al Nighala">Kalba, Al Nighala</option>
                            <option value="Kalba, Al Qadsia">Kalba, Al Qadsia</option>
                            <option value="Kalba, Al Qual'aa">Kalba, Al Qual'aa</option>
                            <option value="Kalba, Al Sidrah">Kalba, Al Sidrah</option>
                            <option value="Kalba, Industrial Area">Kalba, Industrial Area</option>
                            <option value="Khawr Kalba">Khawr Kalba</option>
                            <option value="Wadi Hilo">Wadi Hilo</option>

                            <option value="Al Lou'aluo'ayyah">Al Lou'aluo'ayyah</option>
                            <option value="Al Lou'aluo'ayyah, Stadium Sports Club Pterygium">Al Lou'aluo'ayyah, Stadium Sports Club Pterygium</option>
                            <option value="Khawr Fakkan">Khawr Fakkan</option>
                            <option value="Khawr Fakkan, Al Bridi">Khawr Fakkan, Al Bridi</option>
                            <option value="Khawr Fakkan, Al Khaledya">Khawr Fakkan, Al Khaledya</option>
                            <option value="Khawr Fakkan, Al Rifa'a">Khawr Fakkan, Al Rifa'a</option>
                            <option value="Khawr Fakkan, Al Sharq">Khawr Fakkan, Al Sharq</option>
                            <option value="Khawr Fakkan, Al Suwan Camel Track">Khawr Fakkan, Al Suwan Camel Track</option>
                            <option value="Khawr Fakkan, Al Yarmook">Khawr Fakkan, Al Yarmook</option>
                            <option value="Khawr Fakkan, Fort Hatta">Khawr Fakkan, Fort Hatta</option>
                            <option value="Khawr Fakkan, Hawaya">Khawr Fakkan, Hawaya</option>
                            <option value="Khawr Fakkan, Hutain">Khawr Fakkan, Hutain</option>
                            <option value="Khawr Fakkan, Vegetable and Fruits Market">Khawr Fakkan, Vegetable and Fruits Market</option>
                            <option value="Zubarah">Zubarah</option>


                            <option value="Abu Sangara">Abu Sangara</option>
                            <option value="Adh Dhayd">Adh Dhayd</option>
                            <option value="Al Aber">Al Aber</option>
                            <option value="Al Ardiyah">Al Ardiyah</option>
                            <option value="Al Azrra">Al Azrra</option>
                            <option value="Al Brashi">Al Brashi</option>
                            <option value="Al Butina">Al Butina</option>
                            <option value="Al Darrare">Al Darrare</option>
                            <option value="Al Dhaid">Al Dhaid</option>
                            <option value="Al Fallaj">Al Fallaj</option>
                            <option value="Al Fayha">Al Fayha</option>
                            <option value="AL Ghafiya">AL Ghafiya</option>
                            <option value="Al Ghuhaiba">Al Ghuhaiba</option>
                            <option value="Al Ghuwair">Al Ghuwair</option>
                            <option value="Al Goaz">Al Goaz</option>
                            <option value="Al Hamriyah">Al Hamriyah</option>
                            <option value="Al Hawayah">Al Hawayah</option>
                            <option value="Al Hayrah">Al Hayrah</option>
                            <option value="Al Hazana">Al Hazana</option>
                            <option value="Al Heera Suburb">Al Heera Suburb</option>
                            <option value="Al Hutain">Al Hutain</option>
                            <option value="Al Jazzat">Al Jazzat</option>
                            <option value="Al Khabba">Al Khabba</option>
                            <option value="Al Khaildia Suburb">Al Khaildia Suburb</option>
                            <option value="Al Khaldeia">Al Khaldeia</option>
                            <option value="Al Khan">Al Khan</option>
                            <option value="Al Khouzamiya">Al Khouzamiya</option>
                            <option value="Al Madam">Al Madam</option>
                            <option value="Al Mahatah">Al Mahatah</option>
                            <option value="Al Majaz">Al Majaz</option>
                            <option value="Al Malaiha">Al Malaiha</option>
                            <option value="Al Mamzar">Al Mamzar</option>
                            <option value="Al Mamzer">Al Mamzer</option>
                            <option value="Al Manakh">Al Manakh</option>
                            <option value="Al Marijah">Al Marijah</option>
                            <option value="Al Mirgab">Al Mirgab</option>
                            <option value="Al Mudaifi">Al Mudaifi</option>
                            <option value="Al Mussalla">Al Mussalla</option>
                            <option value="Al Nabba">Al Nabba</option>
                            <option value="Al Nahda 1">Al Nahda 1</option>
                            <option value="Al Nahda 2">Al Nahda 2</option>
                            <option value="Al Naimiya">Al Naimiya</option>
                            <option value="Al Nasserya">Al Nasserya</option>
                            <option value="Al nekhailat">Al nekhailat</option>
                            <option value="Al Nud">Al Nud</option>
                            <option value="Al Nujoom Islands">Al Nujoom Islands</option>
                            <option value="Al Qadsia">Al Qadsia</option>
                            <option value="Al Qasba">Al Qasba</option>
                            <option value="Al Qasemiya">Al Qasemiya</option>
                            <option value="Al Qusais Industrial Area 1">Al Qusais Industrial Area 1</option>
                            <option value="Al Qusais Industrial Area 3">Al Qusais Industrial Area 3</option>
                            <option value="Al Rafee'a 1">Al Rafee'a 1</option>
                            <option value="Al Ramaqia">Al Ramaqia</option>
                            <option value="Al Ramla">Al Ramla</option>
                            <option value="Al Ramla East">Al Ramla East</option>
                            <option value="AL Ramla West">AL Ramla West</option>
                            <option value="Al Ramtha">Al Ramtha</option>
                            <option value="Al Rifa">Al Rifa</option>
                            <option value="Al Rifah">Al Rifah</option>
                            <option value="Al Riqa Suburb">Al Riqa Suburb</option>
                            <option value="Al Sajaa">Al Sajaa</option>
                            <option value="Al Shahab">Al Shahab</option>
                            <option value="Al Sharq">Al Sharq</option>
                            <option value="Al Shuwaiheen">Al Shuwaiheen</option>
                            <option value="Al Subaikhi">Al Subaikhi</option>
                            <option value="Al Swehat">Al Swehat</option>
                            <option value="Al Talae">Al Talae</option>
                            <option value="Al Wahda">Al Wahda</option>
                            <option value="Al Yarmook">Al Yarmook</option>
                            <option value="an-Nahwa">an-Nahwa</option>
                            <option value="Ar Rufaysah">Ar Rufaysah</option>
                            <option value="Ash Shu`ayb">Ash Shu`ayb</option>
                            <option value="Atain">Atain</option>
                            <option value="Bu Danig">Bu Danig</option>
                            <option value="Bu Tina">Bu Tina</option>
                            <option value="Corniche Al Buhaira">Corniche Al Buhaira</option>
                            <option value="Eliash">Eliash</option>
                            <option value="Etisalat">Etisalat</option>
                            <option value="Ghunah">Ghunah</option>
                            <option value="Hajar">Hajar</option>
                            <option value="Hamriya">Hamriya</option>
                            <option value="Hamriyah Free Zone">Hamriyah Free Zone</option>
                            <option value="HANGAR AEROPRAKT A22 No220">HANGAR AEROPRAKT A22 No220</option>
                            <option value="Hiyawah">Hiyawah</option>
                            <option value="Hizayib az Zanah">Hizayib az Zanah</option>
                            <option value="Huwayyah">Huwayyah</option>
                            <option value="Industrial Area 13">Industrial Area 13</option>
                            <option value="Industrial Area 18">Industrial Area 18</option>
                            <option value="Khor Fakkan">Khor Fakkan</option>
                            <option value="Layyah">Layyah</option>
                            <option value="Lulayyah">Lulayyah</option>
                            <option value="Madha">Madha</option>
                            <option value="Maysaloon">Maysaloon</option>
                            <option value="Muelih">Muelih</option>
                            <option value="Muwafjah">Muwafjah</option>
                            <option value="Nahwa">Nahwa</option>
                            <option value="Nazwa">Nazwa</option>
                            <option value="Nedaifi">Nedaifi</option>
                            <option value="New Shwaib">New Shwaib</option>
                            <option value="Private airfield">Private airfield</option>
                            <option value="Rafa">Rafa</option>
                            <option value="Rolla Area">Rolla Area</option>
                            <option value="Rollah Square">Rollah Square</option>
                            <option value="Sa`d">Sa`d</option>
                            <option value="Sahanah">Sahanah</option>
                            <option value="Sajaa Industrial Area">Sajaa Industrial Area</option>
                            <option value="Samnan">Samnan</option>
                            <option value="Saruj">Saruj</option>
                            <option value="Shargan">Shargan</option>
                            <option value="Sharjah">Sharjah</option>
                            <option value="Sharjah Airport Free Zone (SAIF)">Sharjah Airport Free Zone (SAIF)</option>
                            <option value="Sharjah Industrial Area 1">Sharjah Industrial Area 1</option>
                            <option value="Sharjah Industrial Area 10">Sharjah Industrial Area 10Sharjah Industrial Area 10</option>
                            <option value="Sharjah Industrial Area 12">Sharjah Industrial Area 12</option>
                            <option value="Sharjah Industrial Area 2">Sharjah Industrial Area 2</option>
                            <option value="Sharjah Industrial Area 3">Sharjah Industrial Area 3</option>
                            <option value="Sharjah Industrial Area 4">Sharjah Industrial Area 4</option>
                            <option value="Sharjah Industrial Area 5">Sharjah Industrial Area 5</option>
                            <option value="Sharjah Industrial Area 6">Sharjah Industrial Area 6</option>
                            <option value="Sharjah Industrial Area 7">Sharjah Industrial Area 7</option>
                            <option value="Sharjah Industrial Area 8">Sharjah Industrial Area 8</option>
                            <option value="Sharjah Industrial Area 9">Sharjah Industrial Area 9</option>
                            <option value="Shis">Shis</option>
                            <option value="Shwaib">Shwaib</option>
                            <option value="Tawi Bil Khabis">Tawi Bil Khabis</option>
                            <option value="Tawi Rashidia">Tawi Rashidia</option>
                            <option value="Tawi Zubair Hamriyah">Tawi Zubair Hamriyah</option>
                            <option value="Turrfana">Turrfana</option>
                            <option value="Um Tarrafa">Um Tarrafa</option>
                            <option value="Umm Khanoor">Umm Khanoor</option>
                            <option value="Wadi Shi">Wadi Shi</option>
                            <option value="Wasit Suburb">Wasit Suburb</option>
                        

                        </ng-container>
                        <ng-container *ngIf="validationcompany.get('city').value === 'DXB'">
                            <option value="Ayal Nasir">Ayal Nasir</option>
                            <option value="Ud al Bayda">Ud al Bayda</option>
                            <option value="Urqub Juwayza">Urqub Juwayza</option>
                            <option value="Abu Hail">Abu Hail</option>
                            <option value="Abu Hayl">Abu Hayl</option>
                            <option value="Academic City">Academic City</option>
                            <option value="Ad Daghayah">Ad Daghayah</option>
                            <option value="Airport Free Zone">Airport Free Zone</option>
                            <option value="Al `Usbij">Al `Usbij</option>
                            <option value="Al Aweer">Al Aweer</option>
                            <option value="Al Awir">Al Awir</option>
                            <option value="Al Bada">Al Bada</option>
                            <option value="Al Bada'a">Al Bada'a</option>
                            <option value="Al Baharnah">Al Baharnah</option>
                            <option value="Al Balush">Al Balush</option>
                            <option value="Al Baraha">Al Baraha</option>
                            <option value="Al Barahah">Al Barahah</option>
                            <option value="Al Barari">Al Barari</option>
                            <option value="Al Barsha 1">Al Barsha 1</option>
                            <option value="Al Barsha 2">Al Barsha 2</option>
                            <option value="Al Barsha 3">Al Barsha 3</option>
                            <option value="Al Barsha First">Al Barsha First</option>
                            <option value="Al Barshaa Second">Al Barshaa Second</option>
                            <option value="Al Barshaa Third">Al Barshaa Third</option>
                            <option value="Al Faq">Al Faq</option>
                            <option value="Al Furjan">Al Furjan</option>
                            <option value="Al Garhoud">Al Garhoud</option>
                            <option value="Al Goze Industrial District">Al Goze Industrial District</option>
                            <option value="Al Hajarayn">Al Hajarayn</option>
                            <option value="Al Hamriyah">Al Hamriyah</option>
                            <option value="Al Hudaba">Al Hudaba</option>
                            <option value="Al Hudaiba">Al Hudaiba</option>
                            <option value="Al Hudaybah">Al Hudaybah</option>
                            <option value="Al Jaddaf">Al Jaddaf</option>
                            <option value="Al Jafiliya">Al Jafiliya</option>
                            <option value="Al Jafliya">Al Jafliya</option>
                            <option value="Al Karama">Al Karama</option>
                            <option value="Al Khabasi">Al Khabasi</option>
                            <option value="Al Khabeesi">Al Khabeesi</option>
                            <option value="Al Khawanij">Al Khawanij</option>
                            <option value="Al Kifaf">Al Kifaf</option>
                            <option value="Al Lusayli">Al Lusayli</option>
                            <option value="Al Mahra">Al Mahra</option>
                            <option value="Al Manara">Al Manara</option>
                            <option value="Al Mankhool">Al Mankhool</option>
                            <option value="Al Marqadh">Al Marqadh</option>
                            <option value="Al Matinah">Al Matinah</option>
                            <option value="Al Mina">Al Mina</option>
                            <option value="Al Mizhar">Al Mizhar</option>
                            <option value="Al Mizhar 1">Al Mizhar 1</option>
                            <option value="Al Mizhar 2">Al Mizhar 2</option>
                            <option value="Al Muhaisnah">Al Muhaisnah</option>
                            <option value="Al Muraqqabat">Al Muraqqabat</option>
                            <option value="Al Murar">Al Murar</option>
                            <option value="Al Murar al Jadid">Al Murar al Jadid</option>
                            <option value="Al Murar al Qadim">Al Murar al Qadim</option>
                            <option value="Al Musalla">Al Musalla</option>
                            <option value="Al Nahda">Al Nahda</option>
                            <option value="Al Qawz">Al Qawz</option>
                            <option value="Al Quoz">Al Quoz</option>
                            <option value="Al Quoz Industrial Area 1">Al Quoz Industrial Area 1</option>
                            <option value="Al Quoz Industrial Area 2">Al Quoz Industrial Area 2</option>
                            <option value="Al Quoz Industrial Area 3">Al Quoz Industrial Area 3</option>
                            <option value="Al Quoz Industrial Area 4">Al Quoz Industrial Area 4</option>
                            <option value="Al Qusais 1">Al Qusais 1</option>
                            <option value="Al Qusais 2">Al Qusais 2</option>
                            <option value="Al Qusais 3">Al Qusais 3</option>
                            <option value="Al Qusais First">Al Qusais First</option>
                            <option value="Al Qusais Industrial Area Second">Al Qusais Industrial Area Second</option>
                            <option value="Al Qusais Second">Al Qusais Second</option>
                            <option value="Al Qusais Third">Al Qusais Third</option>
                            <option value="Al Qusays">Al Qusays</option>
                            <option value="Al Raffa">Al Raffa</option>
                            <option value="Al Rashidiya">Al Rashidiya</option>
                            <option value="Al Reem 1">Al Reem 1</option>
                            <option value="Al Reem 2">Al Reem 2</option>
                            <option value="Al Reem 3">Al Reem 3</option>
                            <option value="Al Rigga">Al Rigga</option>
                            <option value="Al Safa 1">Al Safa 1</option>
                            <option value="Al Safa 2">Al Safa 2</option>
                            <option value="Al Saffa First">Al Saffa First</option>
                            <option value="Al Saffa Second">Al Saffa Second</option>
                            <option value="Al Safouh First">Al Safouh First</option>
                            <option value="Al Satwa">Al Satwa</option>
                            <option value="Al Shindagah">Al Shindagah</option>
                            <option value="Al Sufouh 2">Al Sufouh 2</option>
                            <option value="Al Twar 1">Al Twar 1</option>
                            <option value="Al Twar 2">Al Twar 2</option>
                            <option value="Al Twar 3">Al Twar 3</option>
                            <option value="Al Twar First">Al Twar First</option>
                            <option value="AL Twar Second">AL Twar Second</option>
                            <option value="Al Waha Villas 1">Al Waha Villas 1</option>
                            <option value="Al Waha Villas 2">Al Waha Villas 2</option>
                            <option value="Al Waheda">Al Waheda</option>
                            <option value="Al Warq'a 5">Al Warq'a 5</option>
                            <option value="Al Warqa'a">Al Warqa'a</option>
                            <option value="Al Wasl">Al Wasl</option>
                            <option value="Al Wuheida">Al Wuheida</option>
                            <option value="Alma">Alma</option>
                            <option value="Alvorada">Alvorada</option>
                            <option value="An Nakhl">An Nakhl</option>
                            <option value="Ar Ra's">Ar Ra's</option>
                            <option value="Ar Rashidiyah">Ar Rashidiyah</option>
                            <option value="Ar Rifa`ah">Ar Rifa`ah</option>
                            <option value="Ar Riqqah">Ar Riqqah</option>
                            <option value="Ar Riqqah Gharb">Ar Riqqah Gharb</option>
                            <option value="Ar Riqqah Sharq">Ar Riqqah Sharq</option>
                            <option value="Arabian Ranches">Arabian Ranches</option>
                            <option value="Armada towers">Armada towers</option>
                            <option value="As Sabkhah">As Sabkhah</option>
                            <option value="As Safa">As Safa</option>
                            <option value="As Satwah">As Satwah</option>
                            <option value="Ash Shamal">Ash Shamal</option>
                            <option value="Ash Shindaghah">Ash Shindaghah</option>
                            <option value="At Tawar">At Tawar</option>
                            <option value="Bawadi">Bawadi</option>
                            <option value="Bu Kadra">Bu Kadra</option>
                            <option value="Bur Dubai">Bur Dubai</option>
                            <option value="Bur Sa`id">Bur Sa`id</option>
                            <option value="Burj Nahar">Burj Nahar</option>
                            <option value="Business Bay">Business Bay</option>
                            <option value="Carmen Village">Carmen Village</option>
                            <option value="City of Arabia">City of Arabia</option>
                            <option value="Corniche Deira">Corniche Deira</option>
                            <option value="Culture Village">Culture Village</option>
                            <option value="Dawwar Burj Nahar">Dawwar Burj Nahar</option>
                            <option value="Dayrah">Dayrah</option>
                            <option value="Deira">Deira</option>
                            <option value="Discovery Gardens">Discovery Gardens</option>
                            <option value="Downtown Burj Khalifa">Downtown Burj Khalifa</option>
                            <option value="Dubai Aid City">Dubai Aid City</option>
                            <option value="Dubai Airport Freezone Area">Dubai Airport Freezone Area</option>
                            <option value="Dubai Autodrome">Dubai Autodrome</option>
                            <option value="Dubai Festival City">Dubai Festival City</option>
                            <option value="Dubai Healthcare City">Dubai Healthcare City</option>
                            <option value="Dubai Industrial City">Dubai Industrial City</option>
                            <option value="Dubai International Financial Centre">Dubai International Financial Centre</option>
                            <option value="Dubai International Media Production Zone (IMPZ)">Dubai International Media Production Zone (IMPZ)</option>
                            <option value="Dubai Internet City">Dubai Internet City</option>
                            <option value="Dubai Investment Park">Dubai Investment Park</option>
                            <option value="Dubai Land">Dubai Land</option>
                            <option value="Dubai Life Style City">Dubai Life Style City</option>
                            <option value="Dubai Marina">Dubai Marina</option>
                            <option value="Dubai Media City">Dubai Media City</option>
                            <option value="Dubai Pearl">Dubai Pearl</option>
                            <option value="Dubai Promenade">Dubai Promenade</option>
                            <option value="Dubai Silicon Oasis">Dubai Silicon Oasis</option>
                            <option value="Dubai Studio City">Dubai Studio City</option>
                            <option value="Dubai Studio City 1">Dubai Studio City 1</option>
                            <option value="Dubai Waterfront">Dubai Waterfront</option>
                            <option value="Dubai World Central">Dubai World Central</option>
                            <option value="DuBiotech">DuBiotech</option>
                            <option value="Emirates Hill First">Emirates Hill First</option>
                            <option value="Emirates Hill Second">Emirates Hill Second</option>
                            <option value="Emirates Hill Third">Emirates Hill Third</option>
                            <option value="Emirates Hills">Emirates Hills</option>
                            <option value="Estella Village">Estella Village</option>
                            <option value="Falcon City of Wonders">Falcon City of Wonders</option>
                            <option value="Ferij al Muhadham">Ferij al Muhadham</option>
                            <option value="Global Village">Global Village</option>
                            <option value="Green Community">Green Community</option>
                            <option value="Green Community Motor City">Green Community Motor City</option>
                            <option value="Green Community West">Green Community West</option>
                            <option value="Greens">Greens</option>
                            <option value="Hamriyah">Hamriyah</option>
                            <option value="Hatta">Hatta</option>
                            <option value="Hattan">Hattan</option>
                            <option value="Hawr al `Anz">Hawr al `Anz</option>
                            <option value="Hayl">Hayl</option>
                            <option value="Hayy al Bastakiyah">Hayy al Bastakiyah</option>
                            <option value="Healthcare City">Healthcare City</option>
                            <option value="Hor Al Anz">Hor Al Anz</option>
                            <option value="Hor Al Anz East">Hor Al Anz East</option>
                            <option value="Hunaywah">Hunaywah</option>
                            <option value="Industrial Area 15">Industrial Area 15</option>
                            <option value="Industrial Area 17">Industrial Area 17</option>
                            <option value="International City">International City</option>
                            <option value="International City (Phase 2)">International City (Phase 2)</option>
                            <option value="International Media Production Zone (IMPZ)">International Media Production Zone (IMPZ)</option>
                            <option value="Jaddaf">Jaddaf</option>
                            <option value="Jebel Ali Village">Jebel Ali Village</option>
                            <option value="Jumayra">Jumayra</option>
                            <option value="Jumeira Second">Jumeira Second</option>
                            <option value="Jumeira Third">Jumeira Third</option>
                            <option value="Jumeirah">Jumeirah</option>
                            <option value="Jumeirah 1">Jumeirah 1</option>
                            <option value="Jumeirah 2">Jumeirah 2</option>
                            <option value="Jumeirah Beach Residence (JBR)">Jumeirah Beach Residence (JBR)</option>
                            <option value="Jumeirah Golf Estates ">Jumeirah Golf Estates </option>
                            <option value="Jumeirah Heights">Jumeirah Heights</option>
                            <option value="Jumeirah Islands">Jumeirah Islands</option>
                            <option value="Jumeirah Lakes Towers">Jumeirah Lakes Towers</option>
                            <option value="Jumeirah Park">Jumeirah Park</option>
                            <option value="Jumeirah Village">Jumeirah Village</option>
                            <option value="Karama">Karama</option>
                            <option value="Knowledge Village ">Knowledge Village </option>
                            <option value="Kurnish">Kurnish</option>
                            <option value="La Colleccion">La Colleccion</option>
                            <option value="Lahbab">Lahbab</option>
                            <option value="Legends">Legends</option>
                            <option value="Liwan">Liwan</option>
                            <option value="M Z Faraidooni (MZF Al Kabhessi)">M Z Faraidooni (MZF Al Kabhessi)</option>
                            <option value="Ma`sharat al Baharnah">Ma`sharat al Baharnah</option>
                            <option value="Madinat Badr">Madinat Badr</option>
                            <option value="Majan">Majan</option>
                            <option value="Mankhul">Mankhul</option>
                            <option value="Margham">Margham</option>
                            <option value="Maritime City">Maritime City</option>
                            <option value="Masfut">Masfut</option>
                            <option value="Meydan">Meydan</option>
                            <option value="Meydan City">Meydan City</option>
                            <option value="Mintaqat as Suq">Mintaqat as Suq</option>
                            <option value="Mintaqat Dubayy at Ta`limiyah">Mintaqat Dubayy at Ta`limiyah</option>
                            <option value="Mirador">Mirador</option>
                            <option value="Mirdif">Mirdif</option>
                            <option value="Motor City">Motor City</option>
                            <option value="Mudon">Mudon</option>
                            <option value="Muhaisanah Fourth">Muhaisanah Fourth</option>
                            <option value="Muhaisanah Second">Muhaisanah Second</option>
                            <option value="Muhaisanah Third">Muhaisanah Third</option>
                            <option value="Muhaisnah 1">Muhaisnah 1</option>
                            <option value="Muhaisnah 2">Muhaisnah 2</option>
                            <option value="Muhaysnah">Muhaysnah</option>
                            <option value="Muhaysnah Shamal">Muhaysnah Shamal</option>
                            <option value="Murrquab">Murrquab</option>
                            <option value="Mushrif">Mushrif</option>
                            <option value="Mushrif Park">Mushrif Park</option>
                            <option value="Muteena">Muteena</option>
                            <option value="Nad Al Hammar">Nad Al Hammar</option>
                            <option value="Nad Al Sheba">Nad Al Sheba</option>
                            <option value="Nad Al Sheba 2">Nad Al Sheba 2</option>
                            <option value="Nadd al Humr">Nadd al Humr</option>
                            <option value="Nadd Al Sheba 3">Nadd Al Sheba 3</option>
                            <option value="Nadd Al Sheba 4">Nadd Al Sheba 4</option>
                            <option value="Nadd ash Shiba">Nadd ash Shiba</option>
                            <option value="Nayf">Nayf</option>
                            <option value="Oud Al Muteena">Oud Al Muteena</option>
                            <option value="Oud Metha">Oud Metha</option>
                            <option value="Palm Jebel Ali">Palm Jebel Ali</option>
                            <option value="Palm Jumeirah">Palm Jumeirah</option>
                            <option value="Palmera">Palmera</option>
                            <option value="Plantation Equestrian and Polo Club">Plantation Equestrian and Polo Club</option>
                            <option value="Port Saeed">Port Saeed</option>
                            <option value="Qaraytaysah">Qaraytaysah</option>
                            <option value="Qimah">Qimah</option>
                            <option value="Ras Al Khor">Ras Al Khor</option>
                            <option value="Ras Al Khor Industrial Area 1">Ras Al Khor Industrial Area 1</option>
                            <option value="Ras Al Khor Industrial Area 2">Ras Al Khor Industrial Area 2</option>
                            <option value="Ras Al Khor Industrial Area 3">Ras Al Khor Industrial Area 3</option>
                            <option value="Remraam">Remraam</option>
                            <option value="Riqqah al Butayn">Riqqah al Butayn</option>
                            <option value="Saheel">Saheel</option>
                            <option value="Satwa">Satwa</option>
                            <option value="Savannah">Savannah</option>
                            <option value="Sharjah Industrial Area 11">Sharjah Industrial Area 11</option>
                            <option value="Sikkat al Khayl">Sikkat al Khayl</option>
                            <option value="Sports City">Sports City</option>
                            <option value="Sufayri">Sufayri</option>
                            <option value="Tawi as Saygh">Tawi as Saygh</option>
                            <option value="Technology Park">Technology Park</option>
                            <option value="Tecom">Tecom</option>
                            <option value="Terra Nova">Terra Nova</option>
                            <option value="The Gardens">The Gardens</option>
                            <option value="The Lagoons">The Lagoons</option>
                            <option value="The Lakes">The Lakes</option>
                            <option value="The Meadows">The Meadows</option>
                            <option value="The Meadows 5">The Meadows 5</option>
                            <option value="The Springs">The Springs</option>
                            <option value="The Tiger Woods Dubai">The Tiger Woods Dubai</option>
                            <option value="The Views">The Views</option>
                            <option value="The Villa">The Villa</option>
                            <option value="The World Islands">The World Islands</option>
                            <option value="Tilal Dubai">Tilal Dubai</option>
                            <option value="Um Al Sheif">Um Al Sheif</option>
                            <option value="Um Suqaim Second">Um Suqaim Second</option>
                            <option value="Umm Al Sheif">Umm Al Sheif</option>
                            <option value="Umm Hurair 1">Umm Hurair 1</option>
                            <option value="Umm Hurair 2">Umm Hurair 2</option>
                            <option value="Umm Hurayr">Umm Hurayr</option>
                            <option value="Umm Ramool">Umm Ramool</option>
                            <option value="Umm Suqaym">Umm Suqaym</option>
                            <option value="Umm Suqueim 1">Umm Suqueim 1</option>
                            <option value="Umm Suqueim 2">Umm Suqueim 2</option>
                            <option value="Umm Suqueim 3">Umm Suqueim 3</option>
                            <option value="Up Town Motor City">Up Town Motor City</option>
                            <option value="Victory Heights">Victory Heights</option>
                            <option value="Warisan">Warisan</option>
                            <option value="Warsan">Warsan</option>
                            <option value="Warsan 1">Warsan 1</option>
                            <option value="Warsan 2">Warsan 2</option>
                            <option value="World Trade Center">World Trade Center</option>
                            <option value="Zabeel 1">Zabeel 1</option>
                            <option value="Zabeel First">Zabeel First</option>
                            <option value="Zaribat Dawiy">Zaribat Dawiy</option>

                            <option value="Hatta, Friday Market">Hatta, Friday Market</option>
                            <option value="Hatta, Hatta Stadium">Hatta, Hatta Stadium</option>
                            <option value="Hatta, Khansaheb Camel Track">Hatta, Khansaheb Camel Track</option>

                        </ng-container>
                        <ng-container *ngIf="validationcompany.get('city').value === 'UAQ'">
                          <option value="Falaj Al Mualla">Falaj Al Mualla</option>

                          <option value="Uwaynat">Uwaynat</option>
                          <option value="Al `Adhib">Al `Adhib</option>
                          <option value="Al Abraq">Al Abraq</option>
                          <option value="Al Azeeb">Al Azeeb</option>
                          <option value="Al Azeeb, Al Khaleej Markets">Al Azeeb, Al Khaleej Markets</option>
                          <option value="Al Biyatha">Al Biyatha</option>
                          <option value="Al Dar Al Baida - A">Al Dar Al Baida - A</option>
                          <option value="Al Dar Al Baida - B">Al Dar Al Baida - B</option>
                          <option value="Al Haditha">Al Haditha</option>
                          <option value="Al Hamrah - B">Al Hamrah - B</option>
                          <option value="Al Hamrah - D">Al Hamrah - D</option>
                          <option value="Al Hawiyah">Al Hawiyah</option>
                          <option value="Al Hazaywah">Al Hazaywah</option>
                          <option value="Al Humrah - A">Al Humrah - A</option>
                          <option value="Al Khor">Al Khor</option>
                          <option value="Al Labsah">Al Labsah</option>
                          <option value="Al Limghadar">Al Limghadar</option>
                          <option value="Al Madar">Al Madar</option>
                          <option value="Al Maidan">Al Maidan</option>
                          <option value="Al Quram">Al Quram</option>
                          <option value="Al Raafa">Al Raafa</option>
                          <option value="Al Ra'as - A">Al Ra'as - A</option>
                          <option value="Al Ra'as - B">Al Ra'as - B</option>
                          <option value="Al Ra'as - C">Al Ra'as - C</option>
                          <option value="Al Ra'as - D">Al Ra'as - D</option>
                          <option value="Al Rashidiya">Al Rashidiya</option>
                          <option value="Al Rashidiya, Hamra Golf Club">Al Rashidiya, Hamra Golf Club</option>
                          <option value="Al Rashidiya, Sharjah Co-Operative Society">Al Rashidiya, Sharjah Co-Operative Society</option>
                          <option value="Al Raudah">Al Raudah</option>
                          <option value="Al Riqqah">Al Riqqah</option>
                          <option value="Al Salam City">Al Salam City</option>
                          <option value="Al Surrah">Al Surrah</option>
                          <option value="Ar Ra`fah">Ar Ra`fah</option>
                          <option value="Ar Ramlah">Ar Ramlah</option>
                          <option value="Ar Rashidiyah">Ar Rashidiyah</option>
                          <option value="As Salamah">As Salamah</option>
                          <option value="As Surrah">As Surrah</option>
                          <option value="Barracuda">Barracuda</option>
                          <option value="Barracuda Beach Resort">Barracuda Beach Resort</option>
                          <option value="Biyatah">Biyatah</option>
                          <option value="Defence Camp">Defence Camp</option>
                          <option value="Diwwan Al Amiri">Diwwan Al Amiri</option>
                          <option value="Emirates Modern Industrial">Emirates Modern Industrial</option>
                          <option value="Emirates Motorplex - UAQ/RAK road">Emirates Motorplex - UAQ/RAK road</option>
                          <option value="Environmental Marine Research Center">Environmental Marine Research Center</option>
                          <option value="Falaj al Moalla">Falaj al Moalla</option>
                          <option value="Green Belt">Green Belt</option>
                          <option value="Hazaiwa">Hazaiwa</option>
                          <option value="Industrial Area A">Industrial Area A</option>
                          <option value="Industrial Area B">Industrial Area B</option>
                          <option value="Industrial Area C">Industrial Area C</option>
                          <option value="Kaber">Kaber</option>
                          <option value="Kabir">Kabir</option>
                          <option value="Khor Al Beidah">Khor Al Beidah</option>
                          <option value="Lazimah">Lazimah</option>
                          <option value="Lubsah">Lubsah</option>
                          <option value="Lubsah, Lulu Centre">Lubsah, Lulu Centre</option>
                          <option value="Mintaqah al Hadithah">Mintaqah al Hadithah</option>
                          <option value="Mintaqat ad Dar al Bayda' A">Mintaqat ad Dar al Bayda' A</option>
                          <option value="Mintaqat ad Dar al Bayda' B">Mintaqat ad Dar al Bayda' B</option>
                          <option value="Mintaqat al `Ahd">Mintaqat al `Ahd</option>
                          <option value="Mintaqat al Hawiyah">Mintaqat al Hawiyah</option>
                          <option value="Mintaqat al Humrah A">Mintaqat al Humrah A</option>
                          <option value="Mintaqat al Humrah B">Mintaqat al Humrah B</option>
                          <option value="Mintaqat al Humrah D">Mintaqat al Humrah D</option>
                          <option value="Mintaqat al Humrah J">Mintaqat al Humrah J</option>
                          <option value="Mintaqat al Khawr">Mintaqat al Khawr</option>
                          <option value="Mintaqat al Madinah al Qadimah">Mintaqat al Madinah al Qadimah</option>
                          <option value="Mintaqat al Maydan">Mintaqat al Maydan</option>
                          <option value="Mintaqat ar Ra's A">Mintaqat ar Ra's A</option>
                          <option value="Mintaqat ar Ra's B">Mintaqat ar Ra's B</option>
                          <option value="Mintaqat ar Ra's D">Mintaqat ar Ra's D</option>
                          <option value="Mintaqat ar Ra's J">Mintaqat ar Ra's J</option>
                          <option value="Mintaqat ar Rawdah">Mintaqat ar Rawdah</option>
                          <option value="Mintaqat ar Riqqah">Mintaqat ar Riqqah</option>
                          <option value="Mintaqat Limghadar">Mintaqat Limghadar</option>
                          <option value="Mintaqat Umm al Qaywayn at Tibbiyah">Mintaqat Umm al Qaywayn at Tibbiyah</option>
                          <option value="Mohadhub">Mohadhub</option>
                          <option value="Muhadhdhib">Muhadhdhib</option>
                          <option value="Old Town">Old Town</option>
                          <option value="The settlement of fishermen">The settlement of fishermen</option>
                          <option value="Umm Al Quwain">Umm Al Quwain</option>
                          <option value="Umm Al Quwain Aviation & Parachute Club">Umm Al Quwain Aviation & Parachute Club</option>
                          <option value="Umm Al Quwain Hunting & Shooting Club">Umm Al Quwain Hunting & Shooting Club</option>
                          <option value="Umm Al Quwain Marina">Umm Al Quwain Marina</option>
                          <option value="Umm Al Thaoub Industrial Area">Umm Al Thaoub Industrial Area</option>
                          <option value="White Bay">White Bay</option>
                        </ng-container>
                        <ng-container *ngIf="validationcompany.get('city').value === 'FUJ'">
                            <option value="Abadilah">Abadilah</option>
                            <option value="Akamiyah">Akamiyah</option>
                            <option value="Aqqah">Aqqah</option>
                            <option value="Asamah">Asamah</option>
                            <option value="Ashashah">Ashashah</option>
                            <option value="Uqayr">Uqayr</option>
                            <option value="Afarah">Afarah</option>
                            <option value="Al `Awdah">Al `Awdah</option>
                            <option value="Al `Ayn al Ghumur">Al `Ayn al Ghumur</option>
                            <option value="Al `Uyaynah">Al `Uyaynah</option>
                            <option value="Al Aqah">Al Aqah</option>
                            <option value="Al Fuqait">Al Fuqait</option>
                            <option value="Al Ghurfa">Al Ghurfa</option>
                            <option value="Al Ghurfah">Al Ghurfah</option>
                            <option value="Al Gissemari">Al Gissemari</option>
                            <option value="Al Halah">Al Halah</option>
                            <option value="Al Hayl">Al Hayl</option>
                            <option value="Al Hinya">Al Hinya</option>
                            <option value="Al Kubus">Al Kubus</option>
                            <option value="Al Manamah">Al Manamah</option>
                            <option value="Al Qurayyah">Al Qurayyah</option>
                            <option value="Ar Rul">Ar Rul</option>
                            <option value="Badiyah">Badiyah</option>
                            <option value="Bethna">Bethna</option>
                            <option value="Bitnah">Bitnah</option>
                            <option value="Blaydah">Blaydah</option>
                            <option value="Corniche">Corniche</option>
                            <option value="Dab`ah">Dab`ah</option>
                            <option value="Dadna">Dadna</option>
                            <option value="Daftah">Daftah</option>
                            <option value="Dahir">Dahir</option>
                            <option value="Diba">Diba</option>
                            <option value="Dibba">Dibba</option>
                            <option value="Dub">Dub</option>
                            <option value="Falakh">Falakh</option>
                            <option value="Faqi">Faqi</option>
                            <option value="Far`ah">Far`ah</option>
                            <option value="Friday Market">Friday Market</option>
                            <option value="Fujairah">Fujairah</option>
                            <option value="Ghamarah">Ghamarah</option>
                            <option value="Ghayl">Ghayl</option>
                            <option value="Ghurfah">Ghurfah</option>
                            <option value="Girath">Girath</option>
                            <option value="Haqil">Haqil</option>
                            <option value="Harat Zutut">Harat Zutut</option>
                            <option value="Harrah">Harrah</option>
                            <option value="Hatiyah">Hatiyah</option>
                            <option value="Hayat">Hayat</option>
                            <option value="Jabal Qurayyah">Jabal Qurayyah</option>
                            <option value="Jareef">Jareef</option>
                            <option value="Kalba">Kalba</option>
                            <option value="Khalba">Khalba</option>
                            <option value="Khawr Kalba">Khawr Kalba</option>
                            <option value="Khor Khalba">Khor Khalba</option>
                            <option value="Khulaybiyah">Khulaybiyah</option>
                            <option value="Maidaq">Maidaq</option>
                            <option value="Masafi">Masafi</option>
                            <option value="Masafi, Fruit and Vegetables Market">Masafi, Fruit and Vegetables Market</option>
                            <option value="Mawrid">Mawrid</option>
                            <option value="Maydaq">Maydaq</option>
                            <option value="Merbah, Fujairah">Merbah, Fujairah</option>
                            <option value="Minazif">Minazif</option>
                            <option value="Mu`taridah">Mu`taridah</option>
                            <option value="Mukhtaraqah">Mukhtaraqah</option>
                            <option value="Murbad">Murbad</option>
                            <option value="Murbah">Murbah</option>
                            <option value="Murrah">Murrah</option>
                            <option value="Nuhayy">Nuhayy</option>
                            <option value="Osfai">Osfai</option>
                            <option value="Qidfa">Qidfa</option>
                            <option value="Ras Dibba">Ras Dibba</option>
                            <option value="Riyamah">Riyamah</option>
                            <option value="Rughaylat">Rughaylat</option>
                            <option value="Rul Dadna">Rul Dadna</option>
                            <option value="Safad">Safad</option>
                            <option value="Sa'if">Sa'if</option>
                            <option value="Saqamqam">Saqamqam</option>
                            <option value="Sharm">Sharm</option>
                            <option value="Shawiyah">Shawiyah</option>
                            <option value="Siji">Siji</option>
                            <option value="Sinnah">Sinnah</option>
                            <option value="Sumbrair">Sumbrair</option>
                            <option value="Sur">Sur</option>
                            <option value="Tarif Kalba">Tarif Kalba</option>
                            <option value="Tariqat Ja`d">Tariqat Ja`d</option>
                            <option value="Tawi Siji">Tawi Siji</option>
                            <option value="Tawian">Tawian</option>
                            <option value="Tayyibah">Tayyibah</option>
                            <option value="Teba">Teba</option>
                            <option value="Theeb">Theeb</option>
                            <option value="Thoban">Thoban</option>
                            <option value="Wa`bayn">Wa`bayn</option>
                            <option value="Wahala">Wahala</option>
                            <option value="Wamm">Wamm</option>
                            <option value="Yalah">Yalah</option>
                            <option value="Zanhah">Zanhah</option>
                            <option value="Zikt">Zikt</option>
                        </ng-container>
                        <ng-container *ngIf="validationcompany.get('city').value === 'RAK'">
                            <option value="Old Ras Al Khaimah">Old Ras Al Khaimah</option>
                            <option value="Old Ras Al Khaimah, Al Waha Trading Market">Old Ras Al Khaimah, Al Waha Trading Market</option>
                            <option value="Old Ras Al Khaimah, Bin Dahur Centre">Old Ras Al Khaimah, Bin Dahur Centre</option>
                            <option value="Ayim">Ayim</option>
                            <option value="Uraybi">Uraybi</option>
                            <option value="Adh Dharbaniyah">Adh Dharbaniyah</option>
                            <option value="Adhan">Adhan</option>
                            <option value="Al Fahlayn">Al Fahlayn</option>
                            <option value="Al Fara">Al Fara</option>
                            <option value="Al Fara">Al Fara</option>
                            <option value="Al Fulayyah">Al Fulayyah</option>
                            <option value="Al Ghabah">Al Ghabah</option>
                            <option value="Al Ghabam">Al Ghabam</option>
                            <option value="Al Ghail">Al Ghail</option>
                            <option value="Al Ghashban">Al Ghashban</option>
                            <option value="Al Hamra Village">Al Hamra Village</option>
                            <option value="Al Hamraniyah">Al Hamraniyah</option>
                            <option value="Al Hayr">Al Hayr</option>
                            <option value="Al Hulaylah">Al Hulaylah</option>
                            <option value="Al Jaddah">Al Jaddah</option>
                            <option value="Al Jazirah al Hamra">Al Jazirah al Hamra</option>
                            <option value="Al Jazirah Aviation Club">Al Jazirah Aviation Club</option>
                            <option value="Al Khari">Al Khari</option>
                            <option value="Al Khashfah">Al Khashfah</option>
                            <option value="Al Mahamm">Al Mahamm</option>
                            <option value="Al Mamorah">Al Mamorah</option>
                            <option value="Al Marjan Island">Al Marjan Island</option>
                            <option value="Al Masafirah">Al Masafirah</option>
                            <option value="Al Mu`amurah">Al Mu`amurah</option>
                            <option value="Al Qir">Al Qir</option>
                            <option value="Al Quwayz">Al Quwayz</option>
                            <option value="Al Ramms">Al Ramms</option>
                            <option value="Al Riffa">Al Riffa</option>
                            <option value="Al Usayli">Al Usayli</option>
                            <option value="An Nakhil">An Nakhil</option>
                            <option value="Ar Rams">Ar Rams</option>
                            <option value="As Sur">As Sur</option>
                            <option value="Ash Sha`m">Ash Sha`m</option>
                            <option value="Athabat">Athabat</option>
                            <option value="Baqal">Baqal</option>
                            <option value="Bida">Bida</option>
                            <option value="Bidiyah">Bidiyah</option>
                            <option value="Bulaydah">Bulaydah</option>
                            <option value="Corniche">Corniche</option>
                            <option value="Creek">Creek</option>
                            <option value="Daftah">Daftah</option>
                            <option value="Darah">Darah</option>
                            <option value="Dayah">Dayah</option>
                            <option value="Daynah">Daynah</option>
                            <option value="Dhad al Arab">Dhad al Arab</option>
                            <option value="Difan">Difan</option>
                            <option value="Dihan">Dihan</option>
                            <option value="Diqdaqah">Diqdaqah</option>
                            <option value="Diqdaqah, Al Waha Centre">Diqdaqah, Al Waha Centre</option>
                            <option value="eXmajor Hangar">eXmajor Hangar</option>
                            <option value="Fashrah">Fashrah</option>
                            <option value="Fa'y">Fa'y</option>
                            <option value="Fayyad">Fayyad</option>
                            <option value="Financial City (DIFC)">Financial City (DIFC)</option>
                            <option value="Furfar">Furfar</option>
                            <option value="Ghadf">Ghadf</option>
                            <option value="Ghaghah">Ghaghah</option>
                            <option value="Ghalilah">Ghalilah</option>
                            <option value="Ghay">Ghay</option>
                            <option value="Ghubb">Ghubb</option>
                            <option value="Ghubbat Khawrah">Ghubbat Khawrah</option>
                            <option value="Ghurah">Ghurah</option>
                            <option value="Gragrah">Gragrah</option>
                            <option value="Habhab">Habhab</option>
                            <option value="Ham Ham">Ham Ham</option>
                            <option value="Hamra' Al Jazirah al">Hamra' Al Jazirah al</option>
                            <option value="Harat `Awali">Harat `Awali</option>
                            <option value="Hayl">Hayl</option>
                            <option value="Homraniya">Homraniya</option>
                            <option value="Hudaybah">Hudaybah</option>
                            <option value="Huwaylat">Huwaylat</option>
                            <option value="Industrial and Technology Park">Industrial and Technology Park</option>
                            <option value="Jazirat al Hamra">Jazirat al Hamra</option>
                            <option value="Jazirat al Hamra', Beach Centre">Jazirat al Hamra', Beach Centre</option>
                            <option value="Jazirat al Hamra', Hatta Fort Golf Course">Jazirat al Hamra', Hatta Fort Golf Course</option>
                            <option value="Khabakhib">Khabakhib</option>
                            <option value="Kharran">Kharran</option>
                            <option value="Khatt">Khatt</option>
                            <option value="Khawr Khuwayr">Khawr Khuwayr</option>
                            <option value="Khazam">Khazam</option>
                            <option value="Kub">Kub</option>
                            <option value="Ma`ali">Ma`ali</option>
                            <option value="Maghribiyah">Maghribiyah</option>
                            <option value="Manqashah">Manqashah</option>
                            <option value="Marhamid">Marhamid</option>
                            <option value="Masafi">Masafi</option>
                            <option value="Masah">Masah</option>
                            <option value="Mina Al Arab">Mina Al Arab</option>
                            <option value="Minha">Minha</option>
                            <option value="Mu`ayrid">Mu`ayrid</option>
                            <option value="Munay`i">Munay`i</option>
                            <option value="Muraytah">Muraytah</option>
                            <option value="New Hangar Zebra VON">New Hangar Zebra VON</option>
                            <option value="Qabas">Qabas</option>
                            <option value="Qaf'ah">Qaf'ah</option>
                            <option value="Qarat ad Dum">Qarat ad Dum</option>
                            <option value="Quar Ah Qahlish">Quar Ah Qahlish</option>
                            <option value="Qur">Qur</option>
                            <option value="Qurm">Qurm</option>
                            <option value="Qusaydat">Qusaydat</option>
                            <option value="Rafaq">Rafaq</option>
                            <option value="RAK airport">RAK airport</option>
                            <option value="Ramlah">Ramlah</option>
                            <option value="Rams">Rams</option>
                            <option value="Ras Al Khaimah">Ras Al Khaimah</option>
                            <option value="Ras al Khaimah, Al Dour Archaeological Site">Ras al Khaimah, Al Dour Archaeological Site</option>
                            <option value="Ras al Khaimah, Al Safeer Shopping Center">Ras al Khaimah, Al Safeer Shopping Center</option>
                            <option value="Ras al Khaimah, Emirates Cultural Sport Club">Ras al Khaimah, Emirates Cultural Sport Club</option>
                            <option value="Ras al Khaimah, Emirates Pearls Markets">Ras al Khaimah, Emirates Pearls Markets</option>
                            <option value="Ras al Khaimah, Fish Market">Ras al Khaimah, Fish Market</option>
                            <option value="Ras al Khaimah, Madinet Zayed Camel Race Track">Ras al Khaimah, Madinet Zayed Camel Race Track</option>
                            <option value="Ras al Khaimah, Mdinet Zayed Market">Ras al Khaimah, Mdinet Zayed Market</option>
                            <option value="Ras al Khaimah, Rak Trading Mall">Ras al Khaimah, Rak Trading Mall</option>
                            <option value="Ras al Khaimah, Safeer Mall">Ras al Khaimah, Safeer Mall</option>
                            <option value="Ras al Khaimah, Saif Al Shawi">Ras al Khaimah, Saif Al Shawi</option>
                            <option value="Rima">Rima</option>
                            <option value="Sal Dora">Sal Dora</option>
                            <option value="Salihiyah">Salihiyah</option>
                            <option value="Samarat">Samarat</option>
                            <option value="Saraya Islands">Saraya Islands</option>
                            <option value="Sayh">Sayh</option>
                            <option value="Sayh as Saqlah">Sayh as Saqlah</option>
                            <option value="Sha`biyat Naslah">Sha`biyat Naslah</option>
                            <option value="Shabakah">Shabakah</option>
                            <option value="Shah">Shah</option>
                            <option value="Shahawat">Shahawat</option>
                            <option value="Shariyah">Shariyah</option>
                            <option value="Sharyat">Sharyat</option>
                            <option value="Shawkah">Shawkah</option>
                            <option value="Shimal">Shimal</option>
                            <option value="Stan">Stan</option>
                            <option value="Suhaybah">Suhaybah</option>
                            <option value="Wad Wid">Wad Wid</option>
                            <option value="Waterfront">Waterfront</option>
                            <option value="Wayb Hawf">Wayb Hawf</option>
                            <option value="Yasmin Village">Yasmin Village</option>
                            <option value="Yinas">Yinas</option>
                        </ng-container>

                    </select>
                      <div *ngIf="formCompany.area.errors" class="invalid-feedback">
                        <span *ngIf="formCompany.area.hasError('required')">Area is required.</span>
                      </div> 
                    </div>
                  </div>
                  <div class="row mb-3">
                    <label for="validationCustom22" class="col-md-3 col-form-label">Building</label>
                    <div class="col-md-9">
                      <input type="text" class="form-control" id="validationCustom22" formControlName="building"
                      placeholder="Enter Building" [ngClass]="{'is-invalid': validation_company && formCompany.building.errors}">
                      <div *ngIf="formCompany.building.errors" class="invalid-feedback">
                        <span *ngIf="formCompany.building.hasError('required')">Building is required.</span>
                      </div> 
                    </div>
                  </div>
                  <div class="row mb-3">
                    <label for="validationCustom23" class="col-md-3 col-form-label">Apartment</label>
                    <div class="col-md-9">
                      <input type="text" class="form-control" id="validationCustom23" formControlName="apartment"
                      placeholder="Enter Apartment" [ngClass]="{'is-invalid': validation_company && formCompany.apartment.errors}">
                      <div *ngIf="formCompany.apartment.errors" class="invalid-feedback">
                        <span *ngIf="formCompany.apartment.hasError('required')">Apartment is required.</span>
                      </div> 
                    </div>
                  </div>
                  <div class="row mb-3">
                    <label for="validationCustom10" class="col-md-3 col-form-label">Latitude</label>
                    <div class="col-md-9">
                      <input type="text" class="form-control" id="validationCustom10" formControlName="latitude"
                      placeholder="Enter Latitude" [ngClass]="{'is-invalid': validation_company && formCompany.latitude.errors}">
                      <div *ngIf="formCompany.latitude.errors" class="invalid-feedback">
                        <span *ngIf="formCompany.latitude.hasError('required')">Latitude is required.</span>
                      </div> 
                    </div>
                  </div>
                  <div class="row mb-3">
                    <label for="validationCustom11" class="col-md-3 col-form-label">Longitude</label>
                    <div class="col-md-9">
                      <input type="text" class="form-control" id="validationCustom11" formControlName="longitude"
                      placeholder="Enter Longitude" [ngClass]="{'is-invalid': validation_company && formCompany.longitude.errors}">
                      <div *ngIf="formCompany.longitude.errors" class="invalid-feedback">
                        <span *ngIf="formCompany.longitude.hasError('required')">Longitude is required.</span>
                      </div> 
                    </div>
                  </div>
              </div>
              <div class="col-lg-12">
                <div class="card">
                  <div class="card-body">
                    <!-- Map -->
                    <agm-map 
                      [latitude]="latitude"
                      [longitude]="longitude" 
                      style="height: 300px" 
                      (mapClick)="mapLeftClick($event)">
                      
                      <agm-marker 
                          *ngIf="markerVisible"
                          [latitude]="latitude"
                          [longitude]="longitude">
                      </agm-marker>
                      
                    </agm-map>
                  </div>
                </div>
              </div>
              <div #streetviewMap></div>
              <ul class="list-inline wizard mb-0">
                <li class="previous list-inline-item"><button class="btn btn-primary" (click)="goToPreviousStep()" awPreviousStep>Previous</button>
                </li>
                <li class="list-inline-item"><button class="btn btn-primary" (click)="getCurrentLocationCompany()" >Get Current Location</button>
                </li>
                <li class="next list-inline-item float-end"><button class="btn btn-primary" (click)="goToPreviousStep()" awNextStep>Next</button>
                </li>
              </ul>
            </aw-wizard-step>

            <aw-wizard-step>
              <ng-template awWizardStepSymbol>
                <i class="fas fa-upload"></i>
              </ng-template>
              <div class="row">
                <div class="row mb-3">
                  <div class="col-md-12">
                    <label for="validationCustom12c" class="col-md-12 col-form-label">Upload the Profile Image</label>
                    <input type="file" class="form-control" id="validationCustom12c" formControlName="image"
                    [ngClass]="{'is-invalid': !isImageValidCompany}" (change)="validateImageCompany($event)">
                    <div *ngIf="!isImageValidCompany" class="invalid-feedback">
                      <!-- <span *ngIf="formCompany.image.errors?.required">Please select an image to upload.</span> -->
                      <span *ngIf="formCompany.image.errors?.invalidFileType">Invalid file type. Please select a JPG, PNG, or JPEG file.</span>
                      <span *ngIf="formCompany.image.errors?.maxSizeExceeded">File size exceeded. Please select a file up to 5MB in size.</span>
                    </div> 
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-md-12">
                    <label for="validationCustom13c" class="col-md-12 col-form-label">Upload the Emirates ID</label>
                    <input type="file" class="form-control" id="validationCustom13c" formControlName="emirates_id"
                    [ngClass]="{'is-invalid': !isEmirateIDValidCompany}" (change)="validaEmirateIDCompany($event)">
                    <div *ngIf="!isEmirateIDValidCompany" class="invalid-feedback">
                      <span *ngIf="formCompany.emirates_id.errors?.required">Please select an file to upload.</span>
                      <span *ngIf="formCompany.emirates_id.errors?.invalidFileType">Invalid file type. Please select a JPG, PNG or JPEG file.</span>
                      <span *ngIf="formCompany.emirates_id.errors?.maxSizeExceeded">File size exceeded. Please select a file up to 5MB in size.</span>
                    </div> 
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-md-12">
                    <label for="validationCustom14c" class="col-md-12 col-form-label">Upload the Passport</label>
                    <input type="file" class="form-control" id="validationCustom14c" formControlName="passport"
                    [ngClass]="{'is-invalid': !isPassportValidCompany}" (change)="validaPassportCompany($event)">
                    <div *ngIf="!isPassportValidCompany" class="invalid-feedback">
                      <!-- <span *ngIf="formCompany.passport.errors?.required">Please select an file to upload.</span> -->
                      <span *ngIf="formCompany.passport.errors?.invalidFileType">Invalid file type. Please select a JPG, PNG or JPEG file.</span>
                      <span *ngIf="formCompany.passport.errors?.maxSizeExceeded">File size exceeded. Please select a file up to 5MB in size.</span>
                    </div> 
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-md-12">
                    <label for="validationCustom15c" class="col-md-12 col-form-label">Upload the Tenant Contract</label>
                    <input type="file" class="form-control" id="validationCustom15c" formControlName="tenant_contract"
                    [ngClass]="{'is-invalid': !isTenantContractValidCompany}" (change)="validaTenantContractCompany($event)">
                    <div *ngIf="!isTenantContractValidCompany" class="invalid-feedback">
                      <!-- <span *ngIf="formCompany.tenant_contract.errors?.required">Please select an PDF to upload.</span> -->
                      <span *ngIf="formCompany.tenant_contract.errors?.invalidFileType">Invalid file type. Please select a JPG, PNG or JPEG file.</span>
                      <span *ngIf="formCompany.tenant_contract.errors?.maxSizeExceeded">File size exceeded. Please select a file up to 5MB in size.</span>
                    </div> 
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-md-12">
                    <label for="validationCustom16c" class="col-md-12 col-form-label">Upload the Trade License</label>
                    <input type="file" class="form-control" id="validationCustom16c" formControlName="trade_license"
                    [ngClass]="{'is-invalid': !isTradeLicenseValidCompany}" (change)="validTradeLicenseCompany($event)">
                    <div *ngIf="!isTradeLicenseValidCompany" class="invalid-feedback">
                      <span *ngIf="formCompany.trade_license.errors?.required">Please select an JPG, PNG or JPEG file to upload.</span>
                      <span *ngIf="formCompany.trade_license.errors?.invalidFileType">Invalid file type. Please select a JPG, PNG or JPEG file.</span>
                      <span *ngIf="formCompany.trade_license.errors?.maxSizeExceeded">File size exceeded. Please select a file up to 5MB in size.</span>
                    </div> 
                  </div>
                </div>
              </div>
              <ul class="list-inline wizard mb-0">
                <li class="previous list-inline-item"><button class="btn btn-primary" (click)="goToPreviousStep()" awPreviousStep>Previous</button>
                </li>
                <li class="next list-inline-item float-end">
                  <button type="submit" class="btn btn-primary" (click)="submitDataCompany()">Submit</button>
              </ul>
            </aw-wizard-step>
          </form>
        </aw-wizard>
      </div>
    </div>
  </div>
</ng-template>

